var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoodsI(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.26,
    y: 64.91,
    width: 3.12,
    height: 10.81,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.85,
    y: 64.91,
    width: 3.12,
    height: 10.81,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.45,
    y: 70.38,
    width: 91.41,
    height: 56.57,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.73 82.17 325.44 75.72 328.41 84.45 336.85 82 335.16 90.67 344.07 92.88 338.18 99.16 345.17 105.44 336.65 107.65 339.85 116.31 330.98 113.86 329.54 122.59 322.7 116.14 317 122.59 314.02 113.86 305.59 116.31 307.27 107.65 298.36 105.44 304.26 99.16 297.26 92.88 305.79 90.67 302.58 82 311.45 84.45 312.89 75.72 319.73 82.17",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.17,94.53a2.11,2.11,0,0,1,.69,1.82,2.67,2.67,0,0,1-.47,1.34,2.82,2.82,0,0,1-1.19,1,4.29,4.29,0,0,1-1.88.37,6.16,6.16,0,0,1-1.66-.23,3.85,3.85,0,0,1-1.35-.64l.84-1.42a3.09,3.09,0,0,0,1,.53,3.78,3.78,0,0,0,1.21.19,2.08,2.08,0,0,0,1.13-.27,1,1,0,0,0,.46-.77.82.82,0,0,0-.37-.79,2.89,2.89,0,0,0-1.44-.26h-2.05l.73-4.53h4.91l-.1,1.49h-3.36l-.24,1.53h.66A3.67,3.67,0,0,1,315.17,94.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.13,98.52A3,3,0,0,1,317,97.09a5.06,5.06,0,0,1-.28-2.24,5.39,5.39,0,0,1,.6-2.23,3.71,3.71,0,0,1,1.33-1.44,3.52,3.52,0,0,1,1.82-.49,3.14,3.14,0,0,1,1.74.49,3,3,0,0,1,1.13,1.44,5,5,0,0,1,.28,2.23,5.4,5.4,0,0,1-.6,2.24,3.61,3.61,0,0,1-1.33,1.43,3.42,3.42,0,0,1-1.81.5A3.1,3.1,0,0,1,318.13,98.52Zm3.06-1.71a3.84,3.84,0,0,0,.56-2,3.55,3.55,0,0,0-.28-1.95,1.23,1.23,0,0,0-1.12-.63,1.42,1.42,0,0,0-1.19.63,3.84,3.84,0,0,0-.55,1.95,3.4,3.4,0,0,0,.28,2,1.2,1.2,0,0,0,1.1.63A1.43,1.43,0,0,0,321.19,96.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,94.57a2.15,2.15,0,0,1-.44-1.61,2.41,2.41,0,0,1,.67-1.62,2,2,0,0,1,1.48-.6,1.74,1.74,0,0,1,1.4.6,2.21,2.21,0,0,1,.44,1.62,2.45,2.45,0,0,1-.67,1.61,2,2,0,0,1-1.48.61A1.75,1.75,0,0,1,325,94.57Zm2.1-.66a1.7,1.7,0,0,0,.3-1,1.65,1.65,0,0,0-.16-1,.66.66,0,0,0-.59-.32A.77.77,0,0,0,326,92a1.81,1.81,0,0,0-.29.95,1.52,1.52,0,0,0,.16.94.65.65,0,0,0,.59.33A.73.73,0,0,0,327.07,93.91Zm4.4-3.08h1.37l-6.07,8h-1.36Zm-.92,7.87a1.67,1.67,0,0,1-.65-.78,2.54,2.54,0,0,1-.17-1.17,2.76,2.76,0,0,1,.34-1.17,2,2,0,0,1,.76-.78,2.08,2.08,0,0,1,1.05-.27,1.72,1.72,0,0,1,1.4.61,2.15,2.15,0,0,1,.44,1.61,2.48,2.48,0,0,1-.67,1.62,2,2,0,0,1-1.49.6A1.88,1.88,0,0,1,330.55,98.7Zm1.72-1a1.81,1.81,0,0,0,.29-1,1.57,1.57,0,0,0-.16-1,.64.64,0,0,0-.59-.32.76.76,0,0,0-.63.32,1.7,1.7,0,0,0-.3,1,1.66,1.66,0,0,0,.16,1,.68.68,0,0,0,.59.32A.77.77,0,0,0,332.27,97.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.09,110.36a3.58,3.58,0,0,1-1.47-1.49,3.87,3.87,0,0,1-.42-2.13,4.44,4.44,0,0,1,.72-2.14,4.65,4.65,0,0,1,1.68-1.49,5.09,5.09,0,0,1,2.3-.54,4.56,4.56,0,0,1,2.22.54,3.76,3.76,0,0,1,1.47,1.49,3.84,3.84,0,0,1,.42,2.14,4.27,4.27,0,0,1-.72,2.13,4.51,4.51,0,0,1-1.69,1.49,4.87,4.87,0,0,1-2.29.54A4.48,4.48,0,0,1,311.09,110.36Zm3.65-1.37a2.64,2.64,0,0,0,1-.92,2.83,2.83,0,0,0,.43-1.33,2.68,2.68,0,0,0-.24-1.34,2.11,2.11,0,0,0-.84-.91,2.39,2.39,0,0,0-1.26-.33,2.67,2.67,0,0,0-2.28,1.24,2.79,2.79,0,0,0-.42,1.34,2.52,2.52,0,0,0,.23,1.33,2.14,2.14,0,0,0,.84.92,2.51,2.51,0,0,0,1.26.32A2.8,2.8,0,0,0,314.74,109Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.46,104.21l-.15,2.13H325l-.1,1.49H321.2l-.21,2.93h-1.86l.57-8.05h6.08l-.1,1.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.81,104.21l-.15,2.13h3.72l-.1,1.49h-3.73l-.21,2.93h-1.86l.57-8.05h6.08l-.1,1.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.92,
    y: 193.97,
    width: 108.84,
    height: 143.21,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.92,
    y: 193.97,
    width: 108.84,
    height: 143.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.92,
    y: 193.97,
    width: 13.35,
    height: 143.21,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.42,
    y: 197.38,
    width: 90.06,
    height: 20.97,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.98,
    y: 221.8,
    width: 90.06,
    height: 20.97,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.54,
    y: 246.23,
    width: 90.06,
    height: 20.97,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.1,
    y: 270.66,
    width: 90.06,
    height: 20.97,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.65,
    y: 295.09,
    width: 90.06,
    height: 20.97,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.4,300.13V299h-8.75v1.14a1.59,1.59,0,0,0-1.49,1.58V314.6a1.59,1.59,0,0,0,1.59,1.58h8.55a1.59,1.59,0,0,0,1.59-1.58V301.71A1.59,1.59,0,0,0,130.4,300.13Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.08,298H130a1.33,1.33,0,0,1,1.33,1.33v.19a0,0,0,0,1,0,0H120.75a0,0,0,0,1,0,0v-.19A1.33,1.33,0,0,1,122.08,298Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.95,
    y: 303.93,
    width: 6.15,
    height: 3.25,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.66,313.86c-.21.07-.35.34-.43.57a.36.36,0,0,1-.4.22h0a.36.36,0,0,1-.27-.47,1.57,1.57,0,0,1,.86-1,3.79,3.79,0,0,0,1-1,1.9,1.9,0,0,0-1.87.8c-.67.8-.78,1.8-.26,2.24s1.49.14,2.16-.65a2,2,0,0,0,.49-1.92A4.25,4.25,0,0,1,123.66,313.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.14,311.34a.91.91,0,0,0-.71,0,.37.37,0,0,1-.41-.2h0a.36.36,0,0,1,.24-.49,1.53,1.53,0,0,1,1.3.15,4.07,4.07,0,0,0,1.38.31,1.9,1.9,0,0,0-1.72-1.09c-1-.1-1.93.37-2,1.05s.72,1.32,1.76,1.41a2,2,0,0,0,1.85-.67A4.17,4.17,0,0,1,126.14,311.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.23,312.55a.89.89,0,0,0,0-.71.34.34,0,0,1,.16-.42h0a.35.35,0,0,1,.51.17,1.56,1.56,0,0,1,0,1.32,3.72,3.72,0,0,0-.15,1.4,1.91,1.91,0,0,0,.89-1.82c0-1-.58-1.88-1.26-1.87s-1.23.86-1.22,1.9a2,2,0,0,0,.88,1.77A4.05,4.05,0,0,1,130.23,312.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.89,309.49a.9.9,0,0,0-.25.67.35.35,0,0,1-.31.33h0a.34.34,0,0,1-.39-.37,1.49,1.49,0,0,1,.54-1.2,3.94,3.94,0,0,0,.71-1.22,1.92,1.92,0,0,0-1.56,1.3c-.41,1-.23,1.95.39,2.22s1.47-.28,1.89-1.24a2,2,0,0,0-.08-2A4.06,4.06,0,0,1,122.89,309.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.23,308.86a.91.91,0,0,0,.57.43.36.36,0,0,1,.22.4h0a.36.36,0,0,1-.47.27,1.52,1.52,0,0,1-1-.87,4,4,0,0,0-1-1,1.92,1.92,0,0,0,.8,1.87c.79.67,1.79.8,2.23.27s.16-1.49-.64-2.16a2,2,0,0,0-1.91-.5A4.1,4.1,0,0,1,128.23,308.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.09,314.35a.89.89,0,0,0-.67.24.35.35,0,0,1-.45,0h0a.34.34,0,0,1,0-.54,1.56,1.56,0,0,1,1.26-.36,3.81,3.81,0,0,0,1.39-.24,1.92,1.92,0,0,0-2-.35c-1,.3-1.64,1.08-1.44,1.73s1.17.94,2.16.64a2,2,0,0,0,1.46-1.33A4.29,4.29,0,0,1,127.09,314.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.68,300.13V299h-8.74v1.14a1.59,1.59,0,0,0-1.49,1.58V314.6a1.59,1.59,0,0,0,1.59,1.58h8.55a1.58,1.58,0,0,0,1.58-1.58V301.71A1.59,1.59,0,0,0,146.68,300.13Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.36,298h7.89a1.33,1.33,0,0,1,1.33,1.33v.19a0,0,0,0,1,0,0H137a0,0,0,0,1,0,0v-.19A1.33,1.33,0,0,1,138.36,298Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.23,
    y: 303.93,
    width: 6.15,
    height: 3.25,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.94,313.86c-.21.07-.35.34-.43.57a.34.34,0,0,1-.39.22h0a.35.35,0,0,1-.27-.47,1.51,1.51,0,0,1,.86-1,3.94,3.94,0,0,0,1-1,1.89,1.89,0,0,0-1.86.8c-.67.8-.79,1.8-.26,2.24s1.49.14,2.16-.65a2,2,0,0,0,.49-1.92A4.27,4.27,0,0,1,139.94,313.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.43,311.34a.93.93,0,0,0-.72,0,.36.36,0,0,1-.4-.2h0a.35.35,0,0,1,.23-.49,1.53,1.53,0,0,1,1.3.15,4.15,4.15,0,0,0,1.39.31,1.91,1.91,0,0,0-1.72-1.09c-1-.1-1.93.37-2,1.05s.73,1.32,1.76,1.41a2,2,0,0,0,1.86-.67A4.17,4.17,0,0,1,142.43,311.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.51,312.55a.89.89,0,0,0,0-.71.35.35,0,0,1,.15-.42h0a.35.35,0,0,1,.51.17,1.53,1.53,0,0,1,0,1.32,4.2,4.2,0,0,0-.15,1.4,1.9,1.9,0,0,0,.89-1.82c0-1-.57-1.88-1.26-1.87s-1.22.86-1.21,1.9a2,2,0,0,0,.87,1.77A4.39,4.39,0,0,1,146.51,312.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.18,309.49a.9.9,0,0,0-.25.67.36.36,0,0,1-.31.33h0a.36.36,0,0,1-.4-.37,1.56,1.56,0,0,1,.54-1.2,3.73,3.73,0,0,0,.72-1.22,1.91,1.91,0,0,0-1.56,1.3c-.41,1-.24,1.95.39,2.22s1.47-.28,1.88-1.24a2,2,0,0,0-.07-2A4.34,4.34,0,0,1,139.18,309.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.52,308.86c.07.21.34.35.56.43a.38.38,0,0,1,.23.4h0a.36.36,0,0,1-.47.27,1.56,1.56,0,0,1-1-.87,3.94,3.94,0,0,0-1-1,1.91,1.91,0,0,0,.79,1.87c.8.67,1.8.8,2.24.27s.15-1.49-.64-2.16a2,2,0,0,0-1.91-.5A4.36,4.36,0,0,1,144.52,308.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.37,314.35a.9.9,0,0,0-.67.24.35.35,0,0,1-.45,0h0a.35.35,0,0,1,0-.54,1.57,1.57,0,0,1,1.26-.36,3.88,3.88,0,0,0,1.4-.24,1.92,1.92,0,0,0-2-.35c-1,.3-1.65,1.08-1.45,1.73s1.17.94,2.17.64a2,2,0,0,0,1.45-1.33A4.27,4.27,0,0,1,143.37,314.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.58,300.13V299h-8.75v1.14a1.59,1.59,0,0,0-1.49,1.58V314.6a1.59,1.59,0,0,0,1.59,1.58h8.55a1.59,1.59,0,0,0,1.59-1.58V301.71A1.59,1.59,0,0,0,162.58,300.13Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.26,298h7.89a1.33,1.33,0,0,1,1.33,1.33v.19a0,0,0,0,1,0,0H152.93a0,0,0,0,1,0,0v-.19A1.33,1.33,0,0,1,154.26,298Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.13,
    y: 303.93,
    width: 6.15,
    height: 3.25,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.83,313.86c-.21.07-.35.34-.43.57a.34.34,0,0,1-.39.22h0a.35.35,0,0,1-.27-.47,1.54,1.54,0,0,1,.86-1,3.94,3.94,0,0,0,1-1,1.89,1.89,0,0,0-1.86.8c-.67.8-.79,1.8-.26,2.24s1.49.14,2.16-.65a2,2,0,0,0,.49-1.92A4.17,4.17,0,0,1,155.83,313.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.32,311.34a.91.91,0,0,0-.71,0,.36.36,0,0,1-.41-.2h0a.35.35,0,0,1,.23-.49,1.55,1.55,0,0,1,1.31.15,4.07,4.07,0,0,0,1.38.31A1.91,1.91,0,0,0,158.4,310c-1-.1-1.93.37-2,1.05s.72,1.32,1.76,1.41a2,2,0,0,0,1.85-.67A4.17,4.17,0,0,1,158.32,311.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.4,312.55a.85.85,0,0,0,0-.71.35.35,0,0,1,.15-.42h0a.36.36,0,0,1,.52.17,1.6,1.6,0,0,1,0,1.32,3.89,3.89,0,0,0-.16,1.4,1.9,1.9,0,0,0,.9-1.82c0-1-.58-1.88-1.27-1.87s-1.22.86-1.21,1.9a2,2,0,0,0,.87,1.77A4.39,4.39,0,0,1,162.4,312.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.07,309.49a.9.9,0,0,0-.25.67.35.35,0,0,1-.31.33h0a.36.36,0,0,1-.4-.37,1.53,1.53,0,0,1,.55-1.2,3.94,3.94,0,0,0,.71-1.22,1.91,1.91,0,0,0-1.56,1.3c-.41,1-.24,1.95.39,2.22s1.47-.28,1.88-1.24a2,2,0,0,0-.07-2A4.2,4.2,0,0,1,155.07,309.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.41,308.86c.07.21.34.35.57.43a.36.36,0,0,1,.22.4h0a.36.36,0,0,1-.47.27,1.56,1.56,0,0,1-1-.87,3.77,3.77,0,0,0-1-1,1.91,1.91,0,0,0,.79,1.87c.8.67,1.8.8,2.24.27s.16-1.49-.64-2.16a2,2,0,0,0-1.91-.5A4.1,4.1,0,0,1,160.41,308.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.26,314.35a.9.9,0,0,0-.67.24.35.35,0,0,1-.45,0h0a.36.36,0,0,1,0-.54,1.59,1.59,0,0,1,1.27-.36,3.87,3.87,0,0,0,1.39-.24,1.92,1.92,0,0,0-2-.35c-1,.3-1.64,1.08-1.45,1.73s1.17.94,2.17.64a2,2,0,0,0,1.46-1.33A4.31,4.31,0,0,1,159.26,314.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,300.13V299h-8.75v1.14a1.59,1.59,0,0,0-1.49,1.58V314.6a1.59,1.59,0,0,0,1.59,1.58h8.55a1.59,1.59,0,0,0,1.59-1.58V301.71A1.59,1.59,0,0,0,177,300.13Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.71,298h7.89a1.33,1.33,0,0,1,1.33,1.33v.19a0,0,0,0,1,0,0H167.38a0,0,0,0,1,0,0v-.19A1.33,1.33,0,0,1,168.71,298Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.58,
    y: 303.93,
    width: 6.15,
    height: 3.25,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.28,313.86c-.21.07-.35.34-.43.57a.34.34,0,0,1-.39.22h0a.35.35,0,0,1-.27-.47,1.54,1.54,0,0,1,.86-1,3.94,3.94,0,0,0,1-1,1.89,1.89,0,0,0-1.86.8c-.67.8-.79,1.8-.26,2.24s1.49.14,2.16-.65a2,2,0,0,0,.49-1.92A4.17,4.17,0,0,1,170.28,313.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.77,311.34a.91.91,0,0,0-.71,0,.36.36,0,0,1-.41-.2h0a.36.36,0,0,1,.23-.49,1.55,1.55,0,0,1,1.31.15,4.07,4.07,0,0,0,1.38.31,1.91,1.91,0,0,0-1.72-1.09c-1-.1-1.93.37-2,1.05s.72,1.32,1.76,1.41a2,2,0,0,0,1.85-.67A4.17,4.17,0,0,1,172.77,311.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.85,312.55a.85.85,0,0,0,0-.71.35.35,0,0,1,.15-.42h0a.36.36,0,0,1,.52.17,1.6,1.6,0,0,1,0,1.32,3.89,3.89,0,0,0-.16,1.4,1.9,1.9,0,0,0,.9-1.82c0-1-.58-1.88-1.27-1.87s-1.22.86-1.21,1.9a2,2,0,0,0,.87,1.77A4.39,4.39,0,0,1,176.85,312.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.52,309.49a.9.9,0,0,0-.25.67.35.35,0,0,1-.31.33h0a.36.36,0,0,1-.4-.37,1.53,1.53,0,0,1,.55-1.2,3.94,3.94,0,0,0,.71-1.22,1.92,1.92,0,0,0-1.56,1.3c-.41,1-.24,1.95.39,2.22s1.47-.28,1.88-1.24a2,2,0,0,0-.07-2A4.06,4.06,0,0,1,169.52,309.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.86,308.86c.07.21.34.35.57.43a.36.36,0,0,1,.22.4h0a.36.36,0,0,1-.47.27,1.56,1.56,0,0,1-1-.87,3.77,3.77,0,0,0-1-1,1.91,1.91,0,0,0,.79,1.87c.8.67,1.8.8,2.24.27s.16-1.49-.64-2.16a2,2,0,0,0-1.91-.5A4.1,4.1,0,0,1,174.86,308.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.72,314.35a.87.87,0,0,0-.67.24.36.36,0,0,1-.46,0h0a.36.36,0,0,1,0-.54,1.59,1.59,0,0,1,1.27-.36,3.87,3.87,0,0,0,1.39-.24,1.92,1.92,0,0,0-2-.35c-1,.3-1.64,1.08-1.44,1.73s1.16.94,2.16.64a2,2,0,0,0,1.46-1.33A4.29,4.29,0,0,1,173.72,314.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.16,300.13V299h-8.74v1.14a1.59,1.59,0,0,0-1.49,1.58V314.6a1.59,1.59,0,0,0,1.59,1.58h8.55a1.58,1.58,0,0,0,1.58-1.58V301.71A1.59,1.59,0,0,0,192.16,300.13Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.85,298h7.89a1.33,1.33,0,0,1,1.33,1.33v.19a0,0,0,0,1,0,0H182.52a0,0,0,0,1,0,0v-.19A1.33,1.33,0,0,1,183.85,298Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.72,
    y: 303.93,
    width: 6.15,
    height: 3.25,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.42,313.86c-.21.07-.35.34-.43.57a.34.34,0,0,1-.39.22h0a.35.35,0,0,1-.27-.47,1.51,1.51,0,0,1,.86-1,3.94,3.94,0,0,0,1-1,1.89,1.89,0,0,0-1.86.8c-.67.8-.79,1.8-.26,2.24s1.49.14,2.16-.65a2,2,0,0,0,.49-1.92A4.27,4.27,0,0,1,185.42,313.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.91,311.34a.91.91,0,0,0-.71,0,.36.36,0,0,1-.41-.2h0a.35.35,0,0,1,.23-.49,1.53,1.53,0,0,1,1.3.15,4.15,4.15,0,0,0,1.39.31A1.91,1.91,0,0,0,188,310c-1-.1-1.93.37-2,1.05s.72,1.32,1.76,1.41a2,2,0,0,0,1.85-.67A4.17,4.17,0,0,1,187.91,311.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,312.55a.85.85,0,0,0,0-.71.35.35,0,0,1,.15-.42h0a.35.35,0,0,1,.51.17,1.56,1.56,0,0,1,0,1.32,3.89,3.89,0,0,0-.16,1.4,1.88,1.88,0,0,0,.89-1.82c0-1-.57-1.88-1.26-1.87s-1.22.86-1.21,1.9a2,2,0,0,0,.87,1.77A4.39,4.39,0,0,1,192,312.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.66,309.49a.9.9,0,0,0-.25.67.35.35,0,0,1-.31.33h0a.36.36,0,0,1-.4-.37,1.56,1.56,0,0,1,.54-1.2,3.73,3.73,0,0,0,.72-1.22,1.91,1.91,0,0,0-1.56,1.3c-.41,1-.24,1.95.39,2.22s1.47-.28,1.88-1.24a2,2,0,0,0-.07-2A4.2,4.2,0,0,1,184.66,309.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,308.86c.07.21.34.35.57.43a.37.37,0,0,1,.22.4h0a.36.36,0,0,1-.47.27,1.56,1.56,0,0,1-1-.87,3.94,3.94,0,0,0-1-1,1.91,1.91,0,0,0,.79,1.87c.8.67,1.8.8,2.24.27s.15-1.49-.64-2.16a2,2,0,0,0-1.91-.5A4.1,4.1,0,0,1,190,308.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.85,314.35a.9.9,0,0,0-.67.24.35.35,0,0,1-.45,0h0a.36.36,0,0,1,0-.54,1.58,1.58,0,0,1,1.26-.36,3.88,3.88,0,0,0,1.4-.24,1.92,1.92,0,0,0-2-.35c-1,.3-1.64,1.08-1.45,1.73s1.17.94,2.17.64a2,2,0,0,0,1.46-1.33A4.33,4.33,0,0,1,188.85,314.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.76,300.13V299H199v1.14a1.59,1.59,0,0,0-1.49,1.58V314.6a1.58,1.58,0,0,0,1.58,1.58h8.56a1.58,1.58,0,0,0,1.58-1.58V301.71A1.59,1.59,0,0,0,207.76,300.13Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.44,298h7.89a1.33,1.33,0,0,1,1.33,1.33v.19a0,0,0,0,1,0,0H198.11a0,0,0,0,1,0,0v-.19A1.33,1.33,0,0,1,199.44,298Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.31,
    y: 303.93,
    width: 6.15,
    height: 3.25,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,313.86c-.21.07-.35.34-.43.57a.35.35,0,0,1-.39.22h0a.35.35,0,0,1-.27-.47,1.51,1.51,0,0,1,.86-1,3.94,3.94,0,0,0,1-1,1.9,1.9,0,0,0-1.87.8c-.66.8-.78,1.8-.26,2.24s1.5.14,2.16-.65a2,2,0,0,0,.49-1.92A4.14,4.14,0,0,1,201,313.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.5,311.34a.91.91,0,0,0-.71,0,.36.36,0,0,1-.4-.2h0a.35.35,0,0,1,.23-.49,1.53,1.53,0,0,1,1.3.15,4.15,4.15,0,0,0,1.39.31,1.92,1.92,0,0,0-1.72-1.09c-1-.1-1.93.37-2,1.05s.73,1.32,1.76,1.41a2,2,0,0,0,1.86-.67A4.22,4.22,0,0,1,203.5,311.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.59,312.55a.93.93,0,0,0,0-.71.35.35,0,0,1,.15-.42h0a.35.35,0,0,1,.51.17,1.53,1.53,0,0,1,0,1.32,3.94,3.94,0,0,0-.15,1.4,1.91,1.91,0,0,0,.89-1.82c0-1-.58-1.88-1.26-1.87s-1.23.86-1.21,1.9a2,2,0,0,0,.87,1.77A4.21,4.21,0,0,1,207.59,312.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.26,309.49a.9.9,0,0,0-.25.67.36.36,0,0,1-.31.33h0a.36.36,0,0,1-.4-.37,1.56,1.56,0,0,1,.54-1.2,4.12,4.12,0,0,0,.72-1.22A1.91,1.91,0,0,0,199,309c-.41,1-.24,1.95.39,2.22s1.47-.28,1.88-1.24a2,2,0,0,0-.08-2A4.19,4.19,0,0,1,200.26,309.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.6,308.86c.07.21.34.35.56.43a.36.36,0,0,1,.22.4h0a.36.36,0,0,1-.47.27,1.54,1.54,0,0,1-1-.87,4.13,4.13,0,0,0-1-1,1.89,1.89,0,0,0,.79,1.87c.79.67,1.8.8,2.24.27s.15-1.49-.64-2.16a2,2,0,0,0-1.91-.5A4.36,4.36,0,0,1,205.6,308.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.45,314.35a.9.9,0,0,0-.67.24.35.35,0,0,1-.45,0h0a.35.35,0,0,1,0-.54,1.57,1.57,0,0,1,1.26-.36,3.88,3.88,0,0,0,1.4-.24,1.92,1.92,0,0,0-2-.35c-1,.3-1.65,1.08-1.45,1.73s1.17.94,2.17.64a2,2,0,0,0,1.45-1.33A4.29,4.29,0,0,1,204.45,314.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.54,275.57v-1.14h-6.4v1.14a1.59,1.59,0,0,0-1.49,1.58V290a1.58,1.58,0,0,0,1.58,1.58h6.21A1.59,1.59,0,0,0,133,290V277.15A1.59,1.59,0,0,0,131.54,275.57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.56,273.4h5.55a1.33,1.33,0,0,1,1.33,1.33v.19a0,0,0,0,1,0,0h-8.21a0,0,0,0,1,0,0v-.19A1.33,1.33,0,0,1,125.56,273.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,288.4c-.21.07-.35.34-.43.56a.37.37,0,0,1-.39.23h0a.36.36,0,0,1-.28-.47,1.56,1.56,0,0,1,.87-1,4,4,0,0,0,1-1,1.92,1.92,0,0,0-1.87.8c-.66.8-.78,1.8-.26,2.24s1.49.15,2.16-.65a2,2,0,0,0,.49-1.91A4.27,4.27,0,0,1,127,288.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.48,285.87a.91.91,0,0,0-.71,0,.35.35,0,0,1-.41-.2h0a.36.36,0,0,1,.24-.49,1.56,1.56,0,0,1,1.3.15,3.84,3.84,0,0,0,1.38.31,1.91,1.91,0,0,0-1.71-1.09c-1-.09-1.93.38-2,1.06s.72,1.31,1.76,1.41a2,2,0,0,0,1.86-.68A4.06,4.06,0,0,1,129.48,285.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.24,284a.89.89,0,0,0-.25.66.36.36,0,0,1-.32.33h0a.35.35,0,0,1-.39-.37,1.55,1.55,0,0,1,.54-1.2,3.82,3.82,0,0,0,.71-1.22,1.91,1.91,0,0,0-1.55,1.3c-.42,1-.24,2,.39,2.23s1.47-.29,1.88-1.25a2,2,0,0,0-.08-2A4.34,4.34,0,0,1,126.24,284Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.43,288.88a.93.93,0,0,0-.67.24.35.35,0,0,1-.45,0h0a.36.36,0,0,1,0-.55,1.52,1.52,0,0,1,1.26-.35A4.2,4.2,0,0,0,132,288a1.94,1.94,0,0,0-2-.35c-1,.31-1.64,1.08-1.44,1.74s1.17.93,2.16.63a2,2,0,0,0,1.46-1.33A4.12,4.12,0,0,1,130.43,288.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.35,
    y: 280.78,
    width: 6.15,
    height: 3.25,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.74,275.57v-1.14h-6.4v1.14a1.59,1.59,0,0,0-1.49,1.58V290a1.59,1.59,0,0,0,1.59,1.58h6.2a1.59,1.59,0,0,0,1.59-1.58V277.15A1.59,1.59,0,0,0,143.74,275.57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.77,273.4h5.55a1.33,1.33,0,0,1,1.33,1.33v.19a0,0,0,0,1,0,0h-8.21a0,0,0,0,1,0,0v-.19A1.33,1.33,0,0,1,137.77,273.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.2,288.4c-.21.07-.35.34-.43.56a.36.36,0,0,1-.39.23h0a.35.35,0,0,1-.27-.47,1.54,1.54,0,0,1,.86-1,4,4,0,0,0,1-1,1.91,1.91,0,0,0-1.86.8c-.67.8-.79,1.8-.26,2.24s1.49.15,2.16-.65a2,2,0,0,0,.49-1.91A4.29,4.29,0,0,1,139.2,288.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.69,285.87a.91.91,0,0,0-.71,0,.34.34,0,0,1-.41-.2h0a.36.36,0,0,1,.23-.49,1.59,1.59,0,0,1,1.31.15,3.84,3.84,0,0,0,1.38.31,1.93,1.93,0,0,0-1.72-1.09c-1-.09-1.93.38-2,1.06s.72,1.31,1.76,1.41a2,2,0,0,0,1.85-.68A4,4,0,0,1,141.69,285.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.44,284a.89.89,0,0,0-.25.66.35.35,0,0,1-.31.33h0a.36.36,0,0,1-.4-.37,1.56,1.56,0,0,1,.55-1.2,3.82,3.82,0,0,0,.71-1.22,1.91,1.91,0,0,0-1.56,1.3c-.41,1-.24,2,.39,2.23s1.47-.29,1.88-1.25a2,2,0,0,0-.07-2A4.34,4.34,0,0,1,138.44,284Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.64,288.88a1,1,0,0,0-.68.24.35.35,0,0,1-.45,0h0a.37.37,0,0,1,0-.55,1.55,1.55,0,0,1,1.27-.35,4.19,4.19,0,0,0,1.39-.25,1.92,1.92,0,0,0-2-.35c-1,.31-1.64,1.08-1.45,1.74s1.17.93,2.17.63a2,2,0,0,0,1.46-1.33A4.12,4.12,0,0,1,142.64,288.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.55,
    y: 280.78,
    width: 6.15,
    height: 3.25,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.53,275.57v-1.14h-6.4v1.14a1.59,1.59,0,0,0-1.49,1.58V290a1.59,1.59,0,0,0,1.59,1.58h6.2A1.59,1.59,0,0,0,157,290V277.15A1.59,1.59,0,0,0,155.53,275.57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.56,273.4h5.55a1.33,1.33,0,0,1,1.33,1.33v.19a0,0,0,0,1,0,0h-8.21a0,0,0,0,1,0,0v-.19A1.33,1.33,0,0,1,149.56,273.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,288.4c-.21.07-.35.34-.43.56a.36.36,0,0,1-.39.23h0a.35.35,0,0,1-.27-.47,1.54,1.54,0,0,1,.86-1,4,4,0,0,0,1-1,1.91,1.91,0,0,0-1.86.8c-.67.8-.79,1.8-.26,2.24s1.49.15,2.16-.65a2,2,0,0,0,.49-1.91A4.29,4.29,0,0,1,151,288.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.48,285.87a.91.91,0,0,0-.71,0,.34.34,0,0,1-.41-.2h0a.36.36,0,0,1,.23-.49,1.59,1.59,0,0,1,1.31.15,3.84,3.84,0,0,0,1.38.31,1.93,1.93,0,0,0-1.72-1.09c-1-.09-1.93.38-2,1.06s.72,1.31,1.76,1.41a2,2,0,0,0,1.85-.68A4,4,0,0,1,153.48,285.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.23,284a.89.89,0,0,0-.25.66.35.35,0,0,1-.31.33h0a.36.36,0,0,1-.4-.37,1.56,1.56,0,0,1,.55-1.2,3.82,3.82,0,0,0,.71-1.22,1.92,1.92,0,0,0-1.56,1.3c-.41,1-.24,2,.39,2.23s1.47-.29,1.88-1.25a2,2,0,0,0-.07-2A4.2,4.2,0,0,1,150.23,284Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.43,288.88a1,1,0,0,0-.68.24.35.35,0,0,1-.45,0h0a.37.37,0,0,1,0-.55,1.55,1.55,0,0,1,1.27-.35A4.19,4.19,0,0,0,156,288a1.92,1.92,0,0,0-2-.35c-1,.31-1.64,1.08-1.44,1.74s1.16.93,2.16.63a2,2,0,0,0,1.46-1.33A4.12,4.12,0,0,1,154.43,288.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.34,
    y: 280.78,
    width: 6.15,
    height: 3.25,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.47,275.57v-1.14h-6.4v1.14a1.59,1.59,0,0,0-1.49,1.58V290a1.59,1.59,0,0,0,1.59,1.58h6.2A1.59,1.59,0,0,0,169,290V277.15A1.59,1.59,0,0,0,167.47,275.57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.5,273.4H167a1.33,1.33,0,0,1,1.33,1.33v.19a0,0,0,0,1,0,0h-8.21a0,0,0,0,1,0,0v-.19A1.33,1.33,0,0,1,161.5,273.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.93,288.4c-.21.07-.35.34-.43.56a.36.36,0,0,1-.39.23h0a.35.35,0,0,1-.27-.47,1.54,1.54,0,0,1,.86-1,4,4,0,0,0,1-1,1.91,1.91,0,0,0-1.86.8c-.67.8-.79,1.8-.26,2.24s1.49.15,2.16-.65a2,2,0,0,0,.49-1.91A4.29,4.29,0,0,1,162.93,288.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.42,285.87a.91.91,0,0,0-.71,0,.34.34,0,0,1-.41-.2h0a.35.35,0,0,1,.23-.49,1.59,1.59,0,0,1,1.31.15,3.84,3.84,0,0,0,1.38.31,1.93,1.93,0,0,0-1.72-1.09c-1-.09-1.93.38-2,1.06s.72,1.31,1.76,1.41a2,2,0,0,0,1.85-.68A4,4,0,0,1,165.42,285.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.17,284a.89.89,0,0,0-.25.66.35.35,0,0,1-.31.33h0a.36.36,0,0,1-.4-.37,1.56,1.56,0,0,1,.55-1.2,3.82,3.82,0,0,0,.71-1.22,1.91,1.91,0,0,0-1.56,1.3c-.41,1-.24,2,.39,2.23s1.47-.29,1.88-1.25a2,2,0,0,0-.07-2A4.34,4.34,0,0,1,162.17,284Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.36,288.88a.94.94,0,0,0-.67.24.35.35,0,0,1-.45,0h0a.37.37,0,0,1,0-.55,1.54,1.54,0,0,1,1.26-.35,4.2,4.2,0,0,0,1.4-.25,1.92,1.92,0,0,0-2-.35c-1,.31-1.64,1.08-1.45,1.74s1.17.93,2.17.63a2,2,0,0,0,1.46-1.33A4.14,4.14,0,0,1,166.36,288.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.28,
    y: 280.78,
    width: 6.15,
    height: 3.25,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,275.57v-1.14h-6.4v1.14a1.59,1.59,0,0,0-1.49,1.58V290a1.59,1.59,0,0,0,1.59,1.58h6.21a1.58,1.58,0,0,0,1.58-1.58V277.15A1.59,1.59,0,0,0,180,275.57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,273.4h5.55a1.33,1.33,0,0,1,1.33,1.33v.19a0,0,0,0,1,0,0h-8.21a0,0,0,0,1,0,0v-.19A1.33,1.33,0,0,1,174,273.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.49,288.4a.86.86,0,0,0-.43.56.38.38,0,0,1-.4.23h0a.35.35,0,0,1-.27-.47,1.54,1.54,0,0,1,.86-1,4,4,0,0,0,1-1,1.91,1.91,0,0,0-1.87.8c-.67.8-.79,1.8-.26,2.24s1.49.15,2.16-.65a2,2,0,0,0,.49-1.91A4.39,4.39,0,0,1,175.49,288.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,285.87a.91.91,0,0,0-.71,0,.34.34,0,0,1-.41-.2h0a.36.36,0,0,1,.23-.49,1.59,1.59,0,0,1,1.31.15,3.84,3.84,0,0,0,1.38.31,1.93,1.93,0,0,0-1.72-1.09c-1-.09-1.93.38-2,1.06s.72,1.31,1.76,1.41a2,2,0,0,0,1.85-.68A4,4,0,0,1,178,285.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.72,284a.89.89,0,0,0-.25.66.35.35,0,0,1-.31.33h0a.36.36,0,0,1-.4-.37,1.56,1.56,0,0,1,.55-1.2,3.82,3.82,0,0,0,.71-1.22,1.92,1.92,0,0,0-1.56,1.3c-.41,1-.24,2,.39,2.23s1.47-.29,1.88-1.25a2,2,0,0,0-.07-2A4.2,4.2,0,0,1,174.72,284Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.92,288.88a.93.93,0,0,0-.67.24.35.35,0,0,1-.45,0h0a.36.36,0,0,1,0-.55,1.55,1.55,0,0,1,1.27-.35,4.15,4.15,0,0,0,1.39-.25,1.92,1.92,0,0,0-2-.35c-1,.31-1.64,1.08-1.44,1.74s1.16.93,2.16.63a2,2,0,0,0,1.46-1.33A4.12,4.12,0,0,1,178.92,288.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.83,
    y: 280.78,
    width: 6.15,
    height: 3.25,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.39,275.57v-1.14H186v1.14a1.59,1.59,0,0,0-1.49,1.58V290a1.59,1.59,0,0,0,1.59,1.58h6.2a1.59,1.59,0,0,0,1.59-1.58V277.15A1.59,1.59,0,0,0,192.39,275.57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.42,273.4H192a1.33,1.33,0,0,1,1.33,1.33v.19a0,0,0,0,1,0,0h-8.21a0,0,0,0,1,0,0v-.19A1.33,1.33,0,0,1,186.42,273.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.85,288.4c-.21.07-.35.34-.43.56a.36.36,0,0,1-.39.23h0a.35.35,0,0,1-.27-.47,1.54,1.54,0,0,1,.86-1,4,4,0,0,0,1-1,1.91,1.91,0,0,0-1.86.8c-.67.8-.79,1.8-.26,2.24s1.49.15,2.16-.65a2,2,0,0,0,.49-1.91A4.29,4.29,0,0,1,187.85,288.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.34,285.87a.91.91,0,0,0-.71,0,.34.34,0,0,1-.41-.2h0a.35.35,0,0,1,.23-.49,1.59,1.59,0,0,1,1.31.15,3.84,3.84,0,0,0,1.38.31,1.93,1.93,0,0,0-1.72-1.09c-1-.09-1.93.38-2,1.06s.72,1.31,1.76,1.41a2,2,0,0,0,1.85-.68A4,4,0,0,1,190.34,285.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.09,284a.89.89,0,0,0-.25.66.35.35,0,0,1-.31.33h0a.36.36,0,0,1-.4-.37,1.56,1.56,0,0,1,.55-1.2,3.82,3.82,0,0,0,.71-1.22,1.91,1.91,0,0,0-1.56,1.3c-.41,1-.24,2,.39,2.23s1.47-.29,1.88-1.25a2,2,0,0,0-.07-2A4.34,4.34,0,0,1,187.09,284Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.28,288.88a.94.94,0,0,0-.67.24.35.35,0,0,1-.45,0h0a.37.37,0,0,1,0-.55,1.54,1.54,0,0,1,1.26-.35,4.2,4.2,0,0,0,1.4-.25,1.92,1.92,0,0,0-2-.35c-1,.31-1.64,1.08-1.45,1.74s1.17.93,2.17.63a2,2,0,0,0,1.46-1.33A4.16,4.16,0,0,1,191.28,288.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.2,
    y: 280.78,
    width: 6.15,
    height: 3.25,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.23,275.57v-1.14h-6.4v1.14a1.59,1.59,0,0,0-1.49,1.58V290a1.58,1.58,0,0,0,1.58,1.58h6.21a1.59,1.59,0,0,0,1.59-1.58V277.15A1.59,1.59,0,0,0,204.23,275.57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.25,273.4h5.55a1.33,1.33,0,0,1,1.33,1.33v.19a0,0,0,0,1,0,0h-8.21a0,0,0,0,1,0,0v-.19A1.33,1.33,0,0,1,198.25,273.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.69,288.4c-.21.07-.35.34-.43.56a.36.36,0,0,1-.39.23h0a.35.35,0,0,1-.27-.47,1.51,1.51,0,0,1,.86-1,4,4,0,0,0,1-1,1.92,1.92,0,0,0-1.87.8c-.66.8-.78,1.8-.26,2.24s1.49.15,2.16-.65a2,2,0,0,0,.49-1.91A4.27,4.27,0,0,1,199.69,288.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.17,285.87a.91.91,0,0,0-.71,0,.33.33,0,0,1-.4-.2h0a.35.35,0,0,1,.23-.49,1.56,1.56,0,0,1,1.3.15,3.91,3.91,0,0,0,1.39.31,1.94,1.94,0,0,0-1.72-1.09c-1-.09-1.93.38-2,1.06S201,286.89,202,287a2,2,0,0,0,1.86-.68A4.06,4.06,0,0,1,202.17,285.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.93,284a.89.89,0,0,0-.25.66.36.36,0,0,1-.32.33h0a.35.35,0,0,1-.39-.37,1.58,1.58,0,0,1,.54-1.2,4,4,0,0,0,.72-1.22,1.91,1.91,0,0,0-1.56,1.3c-.42,1-.24,2,.39,2.23s1.47-.29,1.88-1.25a2,2,0,0,0-.08-2A4.34,4.34,0,0,1,198.93,284Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.12,288.88a.94.94,0,0,0-.67.24.35.35,0,0,1-.45,0h0a.36.36,0,0,1,0-.55,1.52,1.52,0,0,1,1.26-.35,4.2,4.2,0,0,0,1.4-.25,1.94,1.94,0,0,0-2-.35c-1,.31-1.64,1.08-1.44,1.74s1.17.93,2.16.63a2,2,0,0,0,1.46-1.33A4.12,4.12,0,0,1,203.12,288.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.04,
    y: 280.78,
    width: 6.15,
    height: 3.25,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.69,207.66v-7.25h2.49v7.25a1.58,1.58,0,0,0,1.24,1.55h0a1.58,1.58,0,0,1,1.24,1.55v7.65H126.2v-7.65a1.59,1.59,0,0,1,1.24-1.55h0A1.59,1.59,0,0,0,128.69,207.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.09,207.66v-7.25h2.48v7.25a1.59,1.59,0,0,0,1.25,1.55h0a1.59,1.59,0,0,1,1.24,1.55v7.65H136.6v-7.65a1.58,1.58,0,0,1,1.24-1.55h0A1.59,1.59,0,0,0,139.09,207.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.67,207.66v-7.25h2.49v7.25a1.59,1.59,0,0,0,1.25,1.55h0a1.59,1.59,0,0,1,1.24,1.55v7.65h-7.46v-7.65a1.58,1.58,0,0,1,1.24-1.55h0A1.58,1.58,0,0,0,149.67,207.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.81,207.66v-7.25h2.49v7.25a1.58,1.58,0,0,0,1.24,1.55h0a1.58,1.58,0,0,1,1.24,1.55v7.65h-7.46v-7.65a1.59,1.59,0,0,1,1.25-1.55h0A1.59,1.59,0,0,0,159.81,207.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.6,207.66v-7.25h2.49v7.25a1.59,1.59,0,0,0,1.24,1.55h0a1.59,1.59,0,0,1,1.25,1.55v7.65h-7.47v-7.65a1.59,1.59,0,0,1,1.25-1.55h0A1.59,1.59,0,0,0,170.6,207.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,207.66v-7.25h2.48v7.25a1.59,1.59,0,0,0,1.25,1.55h0a1.58,1.58,0,0,1,1.24,1.55v7.65h-7.46v-7.65a1.59,1.59,0,0,1,1.24-1.55h0A1.59,1.59,0,0,0,181,207.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.38,207.66v-7.25h2.49v7.25a1.59,1.59,0,0,0,1.24,1.55h0a1.59,1.59,0,0,1,1.25,1.55v7.65h-7.47v-7.65a1.59,1.59,0,0,1,1.25-1.55h0A1.58,1.58,0,0,0,191.38,207.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.29,207.66v-7.25h2.49v7.25a1.58,1.58,0,0,0,1.24,1.55h0a1.59,1.59,0,0,1,1.25,1.55v7.65H199.8v-7.65a1.59,1.59,0,0,1,1.25-1.55h0A1.59,1.59,0,0,0,202.29,207.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.61,230.32v-6.54H128v6.54a4.91,4.91,0,0,0,.6,2.37h0a5,5,0,0,1,.61,2.38v7.66h-4.85v-7.66a5,5,0,0,1,.61-2.38h0A4.92,4.92,0,0,0,125.61,230.32Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.24,230.32v-6.54h2.42v6.54a5,5,0,0,0,.6,2.37h0a5,5,0,0,1,.61,2.38v7.66H133v-7.66a5.06,5.06,0,0,1,.6-2.38h0A4.92,4.92,0,0,0,134.24,230.32Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.44,230.32v-6.54h2.41v6.54a4.92,4.92,0,0,0,.61,2.37h0a5,5,0,0,1,.61,2.38v7.66h-4.85v-7.66a5,5,0,0,1,.61-2.38h0A4.92,4.92,0,0,0,143.44,230.32Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.12,230.32v-6.54h2.41v6.54a4.92,4.92,0,0,0,.61,2.37h0a5,5,0,0,1,.61,2.38v7.66H150.9v-7.66a5,5,0,0,1,.61-2.38h0A4.92,4.92,0,0,0,152.12,230.32Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.66,230.32v-6.54h2.41v6.54a4.92,4.92,0,0,0,.61,2.37h0a5,5,0,0,1,.61,2.38v7.66h-4.85v-7.66a5,5,0,0,1,.61-2.38h0A4.92,4.92,0,0,0,160.66,230.32Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.24,230.36v-6.54h2.42v6.54a5,5,0,0,0,.6,2.37h0a5,5,0,0,1,.61,2.38v7.66H168v-7.66a5.06,5.06,0,0,1,.6-2.38h0A4.89,4.89,0,0,0,169.24,230.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.89,230.32v-6.54h2.41v6.54a4.92,4.92,0,0,0,.61,2.37h0a5,5,0,0,1,.61,2.38v7.66h-4.85v-7.66a5,5,0,0,1,.61-2.38h0A4.92,4.92,0,0,0,177.89,230.32Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.89,230.32v-6.54h2.41v6.54a4.92,4.92,0,0,0,.61,2.37h0a5,5,0,0,1,.61,2.38v7.66h-4.85v-7.66a5,5,0,0,1,.61-2.38h0A4.92,4.92,0,0,0,186.89,230.32Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.35,230.36v-6.54h2.41v6.54a4.89,4.89,0,0,0,.61,2.37h0a5,5,0,0,1,.61,2.38v7.66h-4.85v-7.66a5,5,0,0,1,.61-2.38h0A4.89,4.89,0,0,0,195.35,230.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.57,230.36v-6.54H206v6.54a4.89,4.89,0,0,0,.61,2.37h0a5,5,0,0,1,.61,2.38v7.66h-4.85v-7.66a5,5,0,0,1,.61-2.38h0A4.89,4.89,0,0,0,203.57,230.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.42,253.23v-4.16h1.9v4.16a2.16,2.16,0,0,0,1.36,2h0a2.15,2.15,0,0,1,1.35,2.1l-.48,9.74h-6.36l-.48-9.74a2.15,2.15,0,0,1,1.36-2.1h0A2.17,2.17,0,0,0,127.42,253.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.83,253.23v-4.16h1.91v4.16a2.15,2.15,0,0,0,1.35,2h0a2.15,2.15,0,0,1,1.35,2.1l-.48,9.74h-6.35l-.48-9.74a2.13,2.13,0,0,1,1.35-2.1h0A2.17,2.17,0,0,0,137.83,253.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,253.23v-4.16h1.9v4.16a2.16,2.16,0,0,0,1.36,2h0a2.15,2.15,0,0,1,1.35,2.1l-.48,9.74h-6.36l-.47-9.74a2.13,2.13,0,0,1,1.35-2.1h0A2.17,2.17,0,0,0,148,253.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.71,253.23v-4.16h1.91v4.16a2.15,2.15,0,0,0,1.35,2h0a2.14,2.14,0,0,1,1.35,2.1l-.48,9.74h-6.35l-.48-9.74a2.14,2.14,0,0,1,1.35-2.1h0A2.15,2.15,0,0,0,158.71,253.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.42,253.23v-4.16h1.9v4.16a2.16,2.16,0,0,0,1.36,2h0a2.15,2.15,0,0,1,1.35,2.1l-.48,9.74h-6.36l-.48-9.74a2.15,2.15,0,0,1,1.36-2.1h0A2.17,2.17,0,0,0,169.42,253.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.22,253.23v-4.16h1.91v4.16a2.15,2.15,0,0,0,1.35,2h0a2.15,2.15,0,0,1,1.35,2.1l-.48,9.74H178l-.48-9.74a2.13,2.13,0,0,1,1.35-2.1h0A2.17,2.17,0,0,0,180.22,253.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.76,253.23v-4.16h1.91v4.16a2.15,2.15,0,0,0,1.35,2h0a2.15,2.15,0,0,1,1.35,2.1l-.48,9.74h-6.35l-.48-9.74a2.13,2.13,0,0,1,1.35-2.1h0A2.17,2.17,0,0,0,190.76,253.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.19,253.23v-4.16h1.91v4.16a2.17,2.17,0,0,0,1.35,2h0a2.13,2.13,0,0,1,1.35,2.1l-.48,9.74H199l-.48-9.74a2.15,2.15,0,0,1,1.35-2.1h0A2.15,2.15,0,0,0,201.19,253.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.65,162.65V155H114v7.66a1.3,1.3,0,0,1-.92,1.24h0a1.3,1.3,0,0,0-.91,1.31l.53,10.71H117l.53-10.71a1.3,1.3,0,0,0-.92-1.31h0A1.3,1.3,0,0,1,115.65,162.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.51,164.65v-7.59H123.9v7.59a1.66,1.66,0,0,1-1.3,1.62h0a1.67,1.67,0,0,0-1.3,1.63v8h7.81v-8a1.67,1.67,0,0,0-1.3-1.63h0A1.66,1.66,0,0,1,126.51,164.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.68,161.54v-5.47h-2.13v5.47a1.93,1.93,0,0,1-.72,1.51h0a1.91,1.91,0,0,0-.71,1.5v11.36h5V164.55a1.91,1.91,0,0,0-.71-1.5h0A2,2,0,0,1,136.68,161.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.28,162.91v-6.84h-2.52v6.84a5.16,5.16,0,0,1-.64,2.49h0a5.16,5.16,0,0,0-.64,2.49v8h5.08v-8a5.16,5.16,0,0,0-.64-2.49h0A5.16,5.16,0,0,1,147.28,162.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.42,161.42v-4.36h-2v4.36a2.26,2.26,0,0,1-1.42,2.1h0a2.24,2.24,0,0,0-1.41,2.2l.5,10.19h6.65l.5-10.19a2.24,2.24,0,0,0-1.41-2.2h0A2.27,2.27,0,0,1,157.42,161.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.68,162.65V155H166v7.66a1.3,1.3,0,0,1-.91,1.24h0a1.3,1.3,0,0,0-.92,1.31l.53,10.71H169l.54-10.71a1.32,1.32,0,0,0-.92-1.31h0A1.3,1.3,0,0,1,167.68,162.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.54,164.65v-7.59h-2.6v7.59a1.66,1.66,0,0,1-1.3,1.62h0a1.67,1.67,0,0,0-1.31,1.63v8h7.82v-8a1.67,1.67,0,0,0-1.3-1.63h0A1.66,1.66,0,0,1,178.54,164.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.71,161.54v-5.47h-2.13v5.47a2,2,0,0,1-.71,1.51h0a1.91,1.91,0,0,0-.71,1.5v11.36h5V164.55a1.91,1.91,0,0,0-.71-1.5h0A1.93,1.93,0,0,1,188.71,161.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.32,162.91v-6.84h-2.53v6.84a5.16,5.16,0,0,1-.64,2.49h0a5.26,5.26,0,0,0-.63,2.49v8h5.07v-8a5.26,5.26,0,0,0-.63-2.49h0A5.16,5.16,0,0,1,199.32,162.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.77,
    y: 175.91,
    width: 92.22,
    height: 2.93,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-7",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelves--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.14,
    y: 169.07,
    width: 185.68,
    height: 244.32,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.14,
    y: 169.07,
    width: 185.68,
    height: 244.32,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.14,
    y: 169.07,
    width: 22.78,
    height: 244.32,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.3,
    y: 174.89,
    width: 153.63,
    height: 35.77,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.54,
    y: 216.56,
    width: 153.63,
    height: 35.77,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.79,
    y: 258.23,
    width: 153.63,
    height: 35.77,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.04,
    y: 299.91,
    width: 153.63,
    height: 35.77,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.28,
    y: 341.58,
    width: 153.63,
    height: 35.77,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.74,240.21c-.75-2.8-2.89-10.06-5.79-10.06h-9.61c-2.9,0-5,7.26-5.79,10.06-.48,1.79-.36,6-.21,8.87a3.31,3.31,0,0,0,3.3,3.12h15a3.3,3.3,0,0,0,3.3-3.12C311.11,246.17,311.22,242,310.74,240.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.13,240.21c-.75-2.8-2.89-10.06-5.79-10.06s-5,7.26-5.79,10.06c-.48,1.79-.36,6-.21,8.87a3.31,3.31,0,0,0,3.3,3.12H298a3.31,3.31,0,0,0,3.3-3.12C301.49,246.17,301.61,242,301.13,240.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.34,
    y: 227.47,
    width: 9.61,
    height: 2.69,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.64,
    y: 240.99,
    width: 7.12,
    height: 3.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.34,
    y: 227.47,
    width: 9.61,
    height: 2.69,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.2,240.37c-.75-2.8-2.88-10.06-5.79-10.06H323.8c-2.9,0-5,7.26-5.79,10.06-.47,1.79-.36,5.95-.2,8.87a3.3,3.3,0,0,0,3.3,3.12h15a3.3,3.3,0,0,0,3.3-3.12C339.57,246.32,339.68,242.16,339.2,240.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.59,240.37c-.75-2.8-2.88-10.06-5.79-10.06s-5,7.26-5.79,10.06c-.47,1.79-.36,5.95-.2,8.87a3.3,3.3,0,0,0,3.3,3.12h5.39a3.3,3.3,0,0,0,3.3-3.12C330,246.32,330.07,242.16,329.59,240.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.8,
    y: 227.62,
    width: 9.61,
    height: 2.69,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.1,
    y: 241.15,
    width: 7.12,
    height: 3.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.8,
    y: 227.62,
    width: 9.61,
    height: 2.69,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.57,240.37c-.75-2.8-2.88-10.06-5.79-10.06h-9.61c-2.9,0-5,7.26-5.79,10.06-.47,1.79-.36,5.95-.2,8.87a3.3,3.3,0,0,0,3.3,3.12h15a3.3,3.3,0,0,0,3.3-3.12C367.94,246.32,368.05,242.16,367.57,240.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,240.37c-.75-2.8-2.89-10.06-5.79-10.06s-5,7.26-5.79,10.06c-.47,1.79-.36,5.95-.2,8.87a3.3,3.3,0,0,0,3.3,3.12h5.39a3.3,3.3,0,0,0,3.3-3.12C358.33,246.32,358.44,242.16,358,240.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.17,
    y: 227.62,
    width: 9.61,
    height: 2.69,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.47,
    y: 241.15,
    width: 7.12,
    height: 3.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.17,
    y: 227.62,
    width: 9.61,
    height: 2.69,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.3,240.56c-.75-2.81-2.89-10.06-5.79-10.06H380.9c-2.9,0-5,7.25-5.79,10.06-.48,1.79-.37,5.95-.21,8.86a3.29,3.29,0,0,0,3.3,3.12h15a3.3,3.3,0,0,0,3.3-3.12C396.66,246.51,396.78,242.35,396.3,240.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.69,240.56c-.75-2.81-2.89-10.06-5.79-10.06s-5,7.25-5.79,10.06c-.48,1.79-.37,5.95-.21,8.86a3.29,3.29,0,0,0,3.3,3.12h5.39a3.3,3.3,0,0,0,3.31-3.12C387.05,246.51,387.16,242.35,386.69,240.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.9,
    y: 227.81,
    width: 9.61,
    height: 2.69,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.19,
    y: 241.33,
    width: 7.12,
    height: 3.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.9,
    y: 227.81,
    width: 9.61,
    height: 2.69,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.58,240.37c-.75-2.8-2.89-10.06-5.79-10.06h-9.61c-2.9,0-5,7.26-5.79,10.06-.48,1.79-.36,5.95-.21,8.87a3.31,3.31,0,0,0,3.3,3.12h15a3.31,3.31,0,0,0,3.3-3.12C425.94,246.32,426.06,242.16,425.58,240.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,240.37c-.75-2.8-2.89-10.06-5.79-10.06s-5,7.26-5.79,10.06c-.48,1.79-.36,5.95-.21,8.87a3.31,3.31,0,0,0,3.3,3.12h5.4a3.31,3.31,0,0,0,3.3-3.12C416.33,246.32,416.45,242.16,416,240.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.18,
    y: 227.62,
    width: 9.61,
    height: 2.69,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.48,
    y: 241.15,
    width: 7.12,
    height: 3.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.18,
    y: 227.62,
    width: 9.61,
    height: 2.69,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.88,200.47c-.64-2.39-2.46-8.56-4.92-8.56h-8.18c-2.46,0-4.28,6.17-4.92,8.56-.4,1.52-.31,5.06-.17,7.54a2.8,2.8,0,0,0,2.8,2.65h12.76a2.81,2.81,0,0,0,2.81-2.65C304.19,205.53,304.28,202,303.88,200.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.88,200.47c-.64-2.39-2.46-8.56-4.92-8.56h-8.18c-2.46,0-4.28,6.17-4.92,8.56-.4,1.52-.31,5.06-.17,7.54a2.8,2.8,0,0,0,2.8,2.65h12.76a2.81,2.81,0,0,0,2.81-2.65C304.19,205.53,304.28,202,303.88,200.47Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.71,200.47c-.64-2.39-2.46-8.56-4.92-8.56s-4.29,6.17-4.93,8.56c-.4,1.52-.31,5.06-.17,7.54a2.8,2.8,0,0,0,2.8,2.65h4.59a2.8,2.8,0,0,0,2.8-2.65C296,205.53,296.11,202,295.71,200.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.99,
    y: 201.13,
    width: 6.05,
    height: 2.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.79,
    y: 189.63,
    width: 8.17,
    height: 2.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.79,
    y: 189.63,
    width: 8.17,
    height: 2.28,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.06,200.47c-.63-2.39-2.45-8.56-4.92-8.56H313c-2.47,0-4.28,6.17-4.92,8.56-.41,1.52-.31,5.06-.18,7.54a2.8,2.8,0,0,0,2.81,2.65h12.75a2.8,2.8,0,0,0,2.81-2.65C326.37,205.53,326.47,202,326.06,200.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.06,200.47c-.63-2.39-2.45-8.56-4.92-8.56H313c-2.47,0-4.28,6.17-4.92,8.56-.41,1.52-.31,5.06-.18,7.54a2.8,2.8,0,0,0,2.81,2.65h12.75a2.8,2.8,0,0,0,2.81-2.65C326.37,205.53,326.47,202,326.06,200.47Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.89,200.47c-.63-2.39-2.45-8.56-4.92-8.56s-4.28,6.17-4.92,8.56c-.41,1.52-.31,5.06-.18,7.54a2.8,2.8,0,0,0,2.81,2.65h4.58a2.8,2.8,0,0,0,2.81-2.65C318.2,205.53,318.3,202,317.89,200.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.17,
    y: 201.13,
    width: 6.05,
    height: 2.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.97,
    y: 189.63,
    width: 8.17,
    height: 2.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.97,
    y: 189.63,
    width: 8.17,
    height: 2.28,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.37,200.47c-.64-2.39-2.46-8.56-4.92-8.56h-8.18c-2.46,0-4.28,6.17-4.92,8.56-.4,1.52-.31,5.06-.17,7.54a2.8,2.8,0,0,0,2.8,2.65h12.76a2.81,2.81,0,0,0,2.81-2.65C348.68,205.53,348.77,202,348.37,200.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.37,200.47c-.64-2.39-2.46-8.56-4.92-8.56h-8.18c-2.46,0-4.28,6.17-4.92,8.56-.4,1.52-.31,5.06-.17,7.54a2.8,2.8,0,0,0,2.8,2.65h12.76a2.79,2.79,0,0,0,2.8-2.65C348.68,205.53,348.77,202,348.37,200.47Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.2,200.47c-.64-2.39-2.46-8.56-4.93-8.56s-4.28,6.17-4.92,8.56c-.4,1.52-.31,5.06-.17,7.54a2.8,2.8,0,0,0,2.8,2.65h4.59a2.8,2.8,0,0,0,2.8-2.65C340.51,205.53,340.6,202,340.2,200.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.48,
    y: 201.13,
    width: 6.05,
    height: 2.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.27,
    y: 189.63,
    width: 8.17,
    height: 2.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.27,
    y: 189.63,
    width: 8.17,
    height: 2.28,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.8,200.47c-.64-2.39-2.45-8.56-4.92-8.56h-8.17c-2.47,0-4.29,6.17-4.92,8.56-.41,1.52-.31,5.06-.18,7.54a2.8,2.8,0,0,0,2.8,2.65h12.76A2.81,2.81,0,0,0,371,208C371.11,205.53,371.21,202,370.8,200.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.8,200.47c-.64-2.39-2.45-8.56-4.92-8.56h-8.17c-2.47,0-4.29,6.17-4.92,8.56-.41,1.52-.31,5.06-.18,7.54a2.8,2.8,0,0,0,2.8,2.65h12.76A2.81,2.81,0,0,0,371,208C371.11,205.53,371.21,202,370.8,200.47Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.63,200.47c-.64-2.39-2.46-8.56-4.92-8.56s-4.29,6.17-4.92,8.56c-.41,1.52-.31,5.06-.18,7.54a2.8,2.8,0,0,0,2.8,2.65H360a2.81,2.81,0,0,0,2.81-2.65C362.94,205.53,363,202,362.63,200.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.91,
    y: 201.13,
    width: 6.05,
    height: 2.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.71,
    y: 189.63,
    width: 8.17,
    height: 2.28,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.71,
    y: 189.63,
    width: 8.17,
    height: 2.28,
    style: {
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,200.47c-.64-2.39-2.45-8.56-4.92-8.56h-8.17c-2.47,0-4.29,6.17-4.92,8.56-.41,1.52-.31,5.06-.18,7.54a2.8,2.8,0,0,0,2.8,2.65h12.76a2.8,2.8,0,0,0,2.81-2.65C393.32,205.53,393.42,202,393,200.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,200.47c-.64-2.39-2.45-8.56-4.92-8.56h-8.17c-2.47,0-4.29,6.17-4.92,8.56-.41,1.52-.31,5.06-.18,7.54a2.8,2.8,0,0,0,2.8,2.65h12.76a2.8,2.8,0,0,0,2.81-2.65C393.32,205.53,393.42,202,393,200.47Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.84,200.47c-.64-2.39-2.45-8.56-4.92-8.56s-4.29,6.17-4.92,8.56c-.41,1.52-.31,5.06-.18,7.54a2.8,2.8,0,0,0,2.8,2.65h4.59A2.81,2.81,0,0,0,385,208C385.15,205.53,385.25,202,384.84,200.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.12,
    y: 201.13,
    width: 6.05,
    height: 2.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.92,
    y: 189.63,
    width: 8.17,
    height: 2.28,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.92,
    y: 189.63,
    width: 8.17,
    height: 2.28,
    style: {
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.11,200.47c-.64-2.39-2.46-8.56-4.93-8.56H402c-2.46,0-4.28,6.17-4.92,8.56-.41,1.52-.31,5.06-.18,7.54a2.81,2.81,0,0,0,2.81,2.65h12.76a2.8,2.8,0,0,0,2.8-2.65C415.42,205.53,415.51,202,415.11,200.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.11,200.47c-.64-2.39-2.46-8.56-4.93-8.56H402c-2.46,0-4.28,6.17-4.92,8.56-.41,1.52-.31,5.06-.18,7.54a2.81,2.81,0,0,0,2.81,2.65h12.76a2.8,2.8,0,0,0,2.8-2.65C415.42,205.53,415.51,202,415.11,200.47Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.93,200.47c-.63-2.39-2.45-8.56-4.92-8.56s-4.28,6.17-4.92,8.56c-.41,1.52-.31,5.06-.18,7.54a2.81,2.81,0,0,0,2.81,2.65h4.59a2.8,2.8,0,0,0,2.8-2.65C407.24,205.53,407.34,202,406.93,200.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.22,
    y: 201.13,
    width: 6.05,
    height: 2.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.01,
    y: 189.63,
    width: 8.17,
    height: 2.28,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.01,
    y: 189.63,
    width: 8.17,
    height: 2.28,
    style: {
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.88,200.47c-.64-2.39-2.45-8.56-4.92-8.56h-8.17c-2.47,0-4.29,6.17-4.92,8.56-.41,1.52-.31,5.06-.18,7.54a2.8,2.8,0,0,0,2.8,2.65h12.76a2.81,2.81,0,0,0,2.81-2.65C437.19,205.53,437.29,202,436.88,200.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.88,200.47c-.64-2.39-2.45-8.56-4.92-8.56h-8.17c-2.47,0-4.29,6.17-4.92,8.56-.41,1.52-.31,5.06-.18,7.54a2.8,2.8,0,0,0,2.8,2.65h12.76a2.81,2.81,0,0,0,2.81-2.65C437.19,205.53,437.29,202,436.88,200.47Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.71,200.47c-.64-2.39-2.46-8.56-4.92-8.56s-4.29,6.17-4.92,8.56c-.41,1.52-.31,5.06-.18,7.54a2.8,2.8,0,0,0,2.8,2.65h4.59a2.81,2.81,0,0,0,2.81-2.65C429,205.53,429.12,202,428.71,200.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.99,
    y: 201.13,
    width: 6.05,
    height: 2.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.79,
    y: 189.63,
    width: 8.17,
    height: 2.28,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.79,
    y: 189.63,
    width: 8.17,
    height: 2.28,
    style: {
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.69,270.15v-1.71H390.61v1.71a2.37,2.37,0,0,0-2.23,2.36v19.28a2.38,2.38,0,0,0,2.37,2.38h12.79a2.39,2.39,0,0,0,2.38-2.38V272.51A2.37,2.37,0,0,0,403.69,270.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.69,270.15v-1.71H390.61v1.71a2.37,2.37,0,0,0-2.23,2.36v19.28a2.38,2.38,0,0,0,2.37,2.38h12.79a2.39,2.39,0,0,0,2.38-2.38V272.51A2.37,2.37,0,0,0,403.69,270.15Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.54,
    y: 275.84,
    width: 9.21,
    height: 4.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.58,266.91h13.13a1.33,1.33,0,0,1,1.33,1.33v.94a0,0,0,0,1,0,0H389.25a0,0,0,0,1,0,0v-.94A1.33,1.33,0,0,1,390.58,266.91Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.58,266.91h13.13a1.33,1.33,0,0,1,1.33,1.33v.94a0,0,0,0,1,0,0H389.25a0,0,0,0,1,0,0v-.94A1.33,1.33,0,0,1,390.58,266.91Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.53,270.15v-1.71H364.45v1.71a2.37,2.37,0,0,0-2.23,2.36v19.28a2.38,2.38,0,0,0,2.37,2.38h12.8a2.38,2.38,0,0,0,2.37-2.38V272.51A2.37,2.37,0,0,0,377.53,270.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.53,270.15v-1.71H364.45v1.71a2.37,2.37,0,0,0-2.23,2.36v19.28a2.38,2.38,0,0,0,2.37,2.38h12.8a2.38,2.38,0,0,0,2.37-2.38V272.51A2.37,2.37,0,0,0,377.53,270.15Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.39,
    y: 275.84,
    width: 9.21,
    height: 4.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.43,266.91h13.13a1.33,1.33,0,0,1,1.33,1.33v.94a0,0,0,0,1,0,0H363.1a0,0,0,0,1,0,0v-.94A1.33,1.33,0,0,1,364.43,266.91Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.43,266.91h13.13a1.33,1.33,0,0,1,1.33,1.33v.94a0,0,0,0,1,0,0H363.1a0,0,0,0,1,0,0v-.94A1.33,1.33,0,0,1,364.43,266.91Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.19,270.15v-1.71H415.11v1.71a2.37,2.37,0,0,0-2.23,2.36v19.28a2.38,2.38,0,0,0,2.37,2.38h12.8a2.38,2.38,0,0,0,2.37-2.38V272.51A2.37,2.37,0,0,0,428.19,270.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.19,270.15v-1.71H415.11v1.71a2.37,2.37,0,0,0-2.23,2.36v19.28a2.38,2.38,0,0,0,2.37,2.38h12.8a2.38,2.38,0,0,0,2.37-2.38V272.51A2.37,2.37,0,0,0,428.19,270.15Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.05,
    y: 275.84,
    width: 9.21,
    height: 4.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.09,266.91h13.13a1.33,1.33,0,0,1,1.33,1.33v.94a0,0,0,0,1,0,0H413.76a0,0,0,0,1,0,0v-.94A1.33,1.33,0,0,1,415.09,266.91Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.09,266.91h13.13a1.33,1.33,0,0,1,1.33,1.33v.94a0,0,0,0,1,0,0H413.76a0,0,0,0,1,0,0v-.94A1.33,1.33,0,0,1,415.09,266.91Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.65,270v-1.71H288.57V270a2.37,2.37,0,0,0-2.23,2.36v19.28a2.38,2.38,0,0,0,2.38,2.37h12.79a2.37,2.37,0,0,0,2.37-2.37V272.35A2.36,2.36,0,0,0,301.65,270Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.65,270v-1.71H288.57V270a2.37,2.37,0,0,0-2.23,2.36v19.28a2.38,2.38,0,0,0,2.38,2.37h12.79a2.37,2.37,0,0,0,2.37-2.37V272.35A2.36,2.36,0,0,0,301.65,270Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.51,
    y: 275.68,
    width: 9.21,
    height: 4.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.55,266.74h13.13a1.33,1.33,0,0,1,1.33,1.33V269a0,0,0,0,1,0,0H287.22a0,0,0,0,1,0,0v-.94A1.33,1.33,0,0,1,288.55,266.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.55,266.74h13.13a1.33,1.33,0,0,1,1.33,1.33V269a0,0,0,0,1,0,0H287.22a0,0,0,0,1,0,0v-.94A1.33,1.33,0,0,1,288.55,266.74Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.87,270v-1.71H312.79V270a2.36,2.36,0,0,0-2.23,2.36v19.28a2.37,2.37,0,0,0,2.37,2.37h12.79a2.38,2.38,0,0,0,2.38-2.37V272.35A2.37,2.37,0,0,0,325.87,270Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.87,270v-1.71H312.79V270a2.36,2.36,0,0,0-2.23,2.36v19.28a2.37,2.37,0,0,0,2.37,2.37h12.79a2.38,2.38,0,0,0,2.38-2.37V272.35A2.37,2.37,0,0,0,325.87,270Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.72,
    y: 275.68,
    width: 9.21,
    height: 4.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.76,266.74h13.13a1.33,1.33,0,0,1,1.33,1.33V269a0,0,0,0,1,0,0H311.43a0,0,0,0,1,0,0v-.94A1.33,1.33,0,0,1,312.76,266.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.76,266.74h13.13a1.33,1.33,0,0,1,1.33,1.33V269a0,0,0,0,1,0,0H311.43a0,0,0,0,1,0,0v-.94A1.33,1.33,0,0,1,312.76,266.74Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.7,270v-1.71H338.62V270a2.37,2.37,0,0,0-2.23,2.36v19.28a2.37,2.37,0,0,0,2.37,2.37h12.79a2.38,2.38,0,0,0,2.38-2.37V272.35A2.37,2.37,0,0,0,351.7,270Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.7,270v-1.71H338.62V270a2.37,2.37,0,0,0-2.23,2.36v19.28a2.37,2.37,0,0,0,2.37,2.37h12.79a2.38,2.38,0,0,0,2.38-2.37V272.35A2.37,2.37,0,0,0,351.7,270Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.55,
    y: 275.68,
    width: 9.21,
    height: 4.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.59,266.74h13.13a1.33,1.33,0,0,1,1.33,1.33V269a0,0,0,0,1,0,0H337.27a0,0,0,0,1,0,0v-.94A1.33,1.33,0,0,1,338.59,266.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.59,266.74h13.13a1.33,1.33,0,0,1,1.33,1.33V269a0,0,0,0,1,0,0H337.27a0,0,0,0,1,0,0v-.94A1.33,1.33,0,0,1,338.59,266.74Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.45,355V343.24h3.37V355a9.54,9.54,0,0,0,1.6,4.27h0a8.87,8.87,0,0,1,1.09,4.28v13.78h-8.72V363.56a9,9,0,0,1,1.09-4.28h0A9.59,9.59,0,0,0,285.45,355Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.45,355V343.24h3.37V355a9.54,9.54,0,0,0,1.6,4.27h0a8.87,8.87,0,0,1,1.09,4.28v13.78h-8.72V363.56a9,9,0,0,1,1.09-4.28h0A9.59,9.59,0,0,0,285.45,355Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.17,
    y: 367.45,
    width: 5.96,
    height: 7.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.14,
    y: 343.04,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.14,
    y: 343.04,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.43,355V343.24h3.37V355a9.54,9.54,0,0,0,1.6,4.27h0a9,9,0,0,1,1.09,4.28v13.78h-8.72V363.56a9,9,0,0,1,1.09-4.28h0A9.49,9.49,0,0,0,295.43,355Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.43,355V343.24h3.37V355a9.54,9.54,0,0,0,1.6,4.27h0a9,9,0,0,1,1.09,4.28v13.78h-8.72V363.56a9,9,0,0,1,1.09-4.28h0A9.49,9.49,0,0,0,295.43,355Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.15,
    y: 367.45,
    width: 5.96,
    height: 7.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.11,
    y: 343.04,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.11,
    y: 343.04,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.68,355V343.24h3.37V355a9.54,9.54,0,0,0,1.6,4.27h0a9,9,0,0,1,1.09,4.28v13.78H303V363.56a9,9,0,0,1,1.09-4.28h0A9.49,9.49,0,0,0,305.68,355Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.68,355V343.24h3.37V355a9.54,9.54,0,0,0,1.6,4.27h0a9,9,0,0,1,1.09,4.28v13.78H303V363.56a9,9,0,0,1,1.09-4.28h0A9.49,9.49,0,0,0,305.68,355Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.4,
    y: 367.45,
    width: 5.96,
    height: 7.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.36,
    y: 343.04,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.36,
    y: 343.04,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.29,355V343.24h3.36V355c0,1.49.89,3,1.6,4.27h0a8.88,8.88,0,0,1,1.1,4.28v13.78h-8.72V363.56a8.87,8.87,0,0,1,1.09-4.28h0A9.49,9.49,0,0,0,315.29,355Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.29,355V343.24h3.36V355c0,1.49.89,3,1.6,4.27h0a8.88,8.88,0,0,1,1.1,4.28v13.78h-8.72V363.56a8.87,8.87,0,0,1,1.09-4.28h0A9.49,9.49,0,0,0,315.29,355Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.01,
    y: 367.45,
    width: 5.96,
    height: 7.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.97,
    y: 343.04,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.97,
    y: 343.04,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.26,355V343.24h3.37V355c0,1.49.89,3,1.6,4.27h0a8.88,8.88,0,0,1,1.1,4.28v13.78h-8.72V363.56a8.87,8.87,0,0,1,1.09-4.28h0A9.47,9.47,0,0,0,325.26,355Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.26,355V343.24h3.37V355c0,1.49.89,3,1.6,4.27h0a8.88,8.88,0,0,1,1.1,4.28v13.78h-8.72V363.56a8.87,8.87,0,0,1,1.09-4.28h0A9.47,9.47,0,0,0,325.26,355Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.99,
    y: 367.45,
    width: 5.96,
    height: 7.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.95,
    y: 343.04,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.95,
    y: 343.04,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.51,355V343.24h3.37V355c0,1.49.89,3,1.6,4.27h0a8.88,8.88,0,0,1,1.1,4.28v13.78h-8.72V363.56a8.87,8.87,0,0,1,1.09-4.28h0A9.47,9.47,0,0,0,335.51,355Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.51,355V343.24h3.37V355c0,1.49.89,3,1.6,4.27h0a8.88,8.88,0,0,1,1.1,4.28v13.78h-8.72V363.56a8.87,8.87,0,0,1,1.09-4.28h0A9.47,9.47,0,0,0,335.51,355Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.24,
    y: 367.45,
    width: 5.96,
    height: 7.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.2,
    y: 343.04,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.2,
    y: 343.04,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.49,355.11V343.35h3.37v11.76a9.53,9.53,0,0,0,1.6,4.28h0a8.86,8.86,0,0,1,1.09,4.27v13.79h-8.72V363.66a8.87,8.87,0,0,1,1.1-4.27h0A9.47,9.47,0,0,0,345.49,355.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.49,355.11V343.35h3.37v11.76a9.53,9.53,0,0,0,1.6,4.28h0a8.86,8.86,0,0,1,1.09,4.27v13.79h-8.72V363.66a8.87,8.87,0,0,1,1.1-4.27h0A9.47,9.47,0,0,0,345.49,355.11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.22,
    y: 367.55,
    width: 5.96,
    height: 7.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.18,
    y: 343.14,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.18,
    y: 343.14,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.07,355.11V343.35h3.37v11.76a9.53,9.53,0,0,0,1.6,4.28h0a9,9,0,0,1,1.09,4.27v13.79h-8.72V363.66a9,9,0,0,1,1.09-4.27h0A9.48,9.48,0,0,0,356.07,355.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.07,355.11V343.35h3.37v11.76a9.53,9.53,0,0,0,1.6,4.28h0a9,9,0,0,1,1.09,4.27v13.79h-8.72V363.66a9,9,0,0,1,1.09-4.27h0A9.48,9.48,0,0,0,356.07,355.11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.79,
    y: 367.55,
    width: 5.96,
    height: 7.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.75,
    y: 343.14,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.75,
    y: 343.14,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.24,355.11V343.35h3.37v11.76a9.53,9.53,0,0,0,1.6,4.28h0a8.86,8.86,0,0,1,1.09,4.27v13.79h-8.72V363.66a8.87,8.87,0,0,1,1.1-4.27h0A9.47,9.47,0,0,0,366.24,355.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.24,355.11V343.35h3.37v11.76a9.53,9.53,0,0,0,1.6,4.28h0a8.86,8.86,0,0,1,1.09,4.27v13.79h-8.72V363.66a8.87,8.87,0,0,1,1.1-4.27h0A9.47,9.47,0,0,0,366.24,355.11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.97,
    y: 367.55,
    width: 5.96,
    height: 7.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.93,
    y: 343.14,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.93,
    y: 343.14,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.35,355.11V343.35h3.37v11.76a9.53,9.53,0,0,0,1.6,4.28h0a8.86,8.86,0,0,1,1.09,4.27v13.79h-8.72V363.66a8.87,8.87,0,0,1,1.1-4.27h0A9.58,9.58,0,0,0,376.35,355.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.35,355.11V343.35h3.37v11.76a9.53,9.53,0,0,0,1.6,4.28h0a8.86,8.86,0,0,1,1.09,4.27v13.79h-8.72V363.66a8.87,8.87,0,0,1,1.1-4.27h0A9.58,9.58,0,0,0,376.35,355.11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.07,
    y: 367.55,
    width: 5.96,
    height: 7.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.04,
    y: 343.14,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.04,
    y: 343.14,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.52,355.11V343.35h3.37v11.76c0,1.5.89,3,1.6,4.28h0a8.87,8.87,0,0,1,1.1,4.27v13.79h-8.72V363.66a8.86,8.86,0,0,1,1.09-4.27h0A9.47,9.47,0,0,0,386.52,355.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.52,355.11V343.35h3.37v11.76c0,1.5.89,3,1.6,4.28h0a8.87,8.87,0,0,1,1.1,4.27v13.79h-8.72V363.66a8.86,8.86,0,0,1,1.09-4.27h0A9.47,9.47,0,0,0,386.52,355.11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.25,
    y: 367.55,
    width: 5.96,
    height: 7.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.21,
    y: 343.14,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.21,
    y: 343.14,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.7,355.11V343.35h3.37v11.76a9.53,9.53,0,0,0,1.6,4.28h0a8.86,8.86,0,0,1,1.09,4.27v13.79H394V363.66a9,9,0,0,1,1.09-4.27h0A9.48,9.48,0,0,0,396.7,355.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.7,355.11V343.35h3.37v11.76a9.53,9.53,0,0,0,1.6,4.28h0a8.86,8.86,0,0,1,1.09,4.27v13.79H394V363.66a9,9,0,0,1,1.09-4.27h0A9.48,9.48,0,0,0,396.7,355.11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.42,
    y: 367.55,
    width: 5.96,
    height: 7.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.38,
    y: 343.14,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.38,
    y: 343.14,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.87,355.11V343.35h3.37v11.76a9.53,9.53,0,0,0,1.6,4.28h0a8.87,8.87,0,0,1,1.1,4.27v13.79h-8.73V363.66a8.87,8.87,0,0,1,1.1-4.27h0A9.47,9.47,0,0,0,406.87,355.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.87,355.11V343.35h3.37v11.76a9.53,9.53,0,0,0,1.6,4.28h0a8.87,8.87,0,0,1,1.1,4.27v13.79h-8.73V363.66a8.87,8.87,0,0,1,1.1-4.27h0A9.47,9.47,0,0,0,406.87,355.11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.6,
    y: 367.55,
    width: 5.96,
    height: 7.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.56,
    y: 343.14,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.56,
    y: 343.14,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,355.11V343.35h3.37v11.76a9.53,9.53,0,0,0,1.6,4.28h0a8.86,8.86,0,0,1,1.09,4.27v13.79h-8.72V363.66a8.87,8.87,0,0,1,1.1-4.27h0A9.58,9.58,0,0,0,417,355.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,355.11V343.35h3.37v11.76a9.53,9.53,0,0,0,1.6,4.28h0a8.86,8.86,0,0,1,1.09,4.27v13.79h-8.72V363.66a8.87,8.87,0,0,1,1.1-4.27h0A9.58,9.58,0,0,0,417,355.11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.7,
    y: 367.55,
    width: 5.96,
    height: 7.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.67,
    y: 343.14,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.67,
    y: 343.14,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.16,355.11V343.35h3.36v11.76c0,1.5.89,3,1.6,4.28h0a8.87,8.87,0,0,1,1.1,4.27v13.79H424.5V363.66a8.86,8.86,0,0,1,1.09-4.27h0A9.48,9.48,0,0,0,427.16,355.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.16,355.11V343.35h3.36v11.76c0,1.5.89,3,1.6,4.28h0a8.87,8.87,0,0,1,1.1,4.27v13.79H424.5V363.66a8.86,8.86,0,0,1,1.09-4.27h0A9.48,9.48,0,0,0,427.16,355.11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.88,
    y: 367.55,
    width: 5.96,
    height: 7.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.84,
    y: 343.14,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.84,
    y: 343.14,
    width: 4.03,
    height: 1.31,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.81,314.5V303.34h4.12V314.5a8.42,8.42,0,0,0,1,4.05h0a8.45,8.45,0,0,1,1,4.05v13.07h-8.27V322.6a8.33,8.33,0,0,1,1-4.05h0A8.41,8.41,0,0,0,285.81,314.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.81,314.5V303.34h4.12V314.5a8.42,8.42,0,0,0,1,4.05h0a8.45,8.45,0,0,1,1,4.05v13.07h-8.27V322.6a8.33,8.33,0,0,1,1-4.05h0A8.41,8.41,0,0,0,285.81,314.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.18,
    y: 323.39,
    width: 5.38,
    height: 10.42,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.48,
    y: 302.94,
    width: 4.7,
    height: 2.15,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.48,
    y: 302.94,
    width: 4.7,
    height: 2.15,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,314.5V303.34h4.12V314.5a8.42,8.42,0,0,0,1,4.05h0a8.44,8.44,0,0,1,1,4.05v13.07h-8.26V322.6a8.44,8.44,0,0,1,1-4.05h0A8.42,8.42,0,0,0,301,314.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,314.5V303.34h4.12V314.5a8.42,8.42,0,0,0,1,4.05h0a8.44,8.44,0,0,1,1,4.05v13.07h-8.26V322.6a8.44,8.44,0,0,1,1-4.05h0A8.42,8.42,0,0,0,301,314.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.33,
    y: 323.39,
    width: 5.38,
    height: 10.42,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.63,
    y: 302.94,
    width: 4.7,
    height: 2.15,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.63,
    y: 302.94,
    width: 4.7,
    height: 2.15,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.94,314.5V303.34h4.12V314.5a8.42,8.42,0,0,0,1,4.05h0a8.45,8.45,0,0,1,1,4.05v13.07h-8.27V322.6a8.45,8.45,0,0,1,1-4.05h0A8.41,8.41,0,0,0,316.94,314.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.94,314.5V303.34h4.12V314.5a8.42,8.42,0,0,0,1,4.05h0a8.45,8.45,0,0,1,1,4.05v13.07h-8.27V322.6a8.45,8.45,0,0,1,1-4.05h0A8.41,8.41,0,0,0,316.94,314.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.31,
    y: 323.39,
    width: 5.38,
    height: 10.42,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.61,
    y: 302.94,
    width: 4.7,
    height: 2.15,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.61,
    y: 302.94,
    width: 4.7,
    height: 2.15,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,314.5V303.34h4.12V314.5a8.42,8.42,0,0,0,1,4.05h0a8.44,8.44,0,0,1,1,4.05v13.07h-8.26V322.6a8.44,8.44,0,0,1,1-4.05h0A8.42,8.42,0,0,0,333,314.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,314.5V303.34h4.12V314.5a8.42,8.42,0,0,0,1,4.05h0a8.44,8.44,0,0,1,1,4.05v13.07h-8.26V322.6a8.44,8.44,0,0,1,1-4.05h0A8.42,8.42,0,0,0,333,314.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.69,
    y: 324.61,
    width: 6.66,
    height: 7.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.67,
    y: 302.94,
    width: 4.7,
    height: 2.15,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.67,
    y: 302.94,
    width: 4.7,
    height: 2.15,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.59,314.5V303.34h4.12V314.5a8.41,8.41,0,0,0,1,4.05h0a8.45,8.45,0,0,1,1,4.05v13.07h-8.27V322.6a8.45,8.45,0,0,1,1-4.05h0A8.42,8.42,0,0,0,348.59,314.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.59,314.5V303.34h4.12V314.5a8.41,8.41,0,0,0,1,4.05h0a8.45,8.45,0,0,1,1,4.05v13.07h-8.27V322.6a8.45,8.45,0,0,1,1-4.05h0A8.42,8.42,0,0,0,348.59,314.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.32,
    y: 324.61,
    width: 6.66,
    height: 7.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.3,
    y: 302.94,
    width: 4.7,
    height: 2.15,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.3,
    y: 302.94,
    width: 4.7,
    height: 2.15,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.91,314.5V303.34H367V314.5a8.41,8.41,0,0,0,1,4.05h0a8.45,8.45,0,0,1,1,4.05v13.07h-8.27V322.6a8.45,8.45,0,0,1,1-4.05h0A8.42,8.42,0,0,0,362.91,314.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.91,314.5V303.34H367V314.5a8.41,8.41,0,0,0,1,4.05h0a8.45,8.45,0,0,1,1,4.05v13.07h-8.27V322.6a8.45,8.45,0,0,1,1-4.05h0A8.42,8.42,0,0,0,362.91,314.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.64,
    y: 324.61,
    width: 6.66,
    height: 7.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.62,
    y: 302.94,
    width: 4.7,
    height: 2.15,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.62,
    y: 302.94,
    width: 4.7,
    height: 2.15,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.52,317.05V304.69h4.24v12.36a2.72,2.72,0,0,0,2.12,2.65h0a2.7,2.7,0,0,1,2.12,2.64V335.4H374.27V322.34a2.7,2.7,0,0,1,2.12-2.64h0A2.73,2.73,0,0,0,378.52,317.05Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.52,317.05V304.69h4.24v12.36a2.72,2.72,0,0,0,2.12,2.65h0a2.7,2.7,0,0,1,2.12,2.64V335.4H374.27V322.34a2.7,2.7,0,0,1,2.12-2.64h0A2.73,2.73,0,0,0,378.52,317.05Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.8,
    y: 303.62,
    width: 5.67,
    height: 1.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.8,
    y: 303.62,
    width: 5.67,
    height: 1.91,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.57,
    y: 324.21,
    width: 8.14,
    height: 8.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.81,317.05V304.69h4.25v12.36a2.72,2.72,0,0,0,2.12,2.65h0a2.7,2.7,0,0,1,2.12,2.64V335.4H406.57V322.34a2.7,2.7,0,0,1,2.12-2.64h0A2.72,2.72,0,0,0,410.81,317.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.81,317.05V304.69h4.25v12.36a2.72,2.72,0,0,0,2.12,2.65h0a2.7,2.7,0,0,1,2.12,2.64V335.4H406.57V322.34a2.7,2.7,0,0,1,2.12-2.64h0A2.72,2.72,0,0,0,410.81,317.05Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.1,
    y: 303.62,
    width: 5.67,
    height: 1.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.1,
    y: 303.62,
    width: 5.67,
    height: 1.91,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.87,
    y: 324.21,
    width: 8.14,
    height: 8.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.26,317.05V304.69h4.25v12.36a2.72,2.72,0,0,0,2.12,2.65h0a2.7,2.7,0,0,1,2.12,2.64V335.4H390V322.34a2.7,2.7,0,0,1,2.12-2.64h0A2.72,2.72,0,0,0,394.26,317.05Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.26,317.05V304.69h4.25v12.36a2.72,2.72,0,0,0,2.12,2.65h0a2.7,2.7,0,0,1,2.12,2.64V335.4H390V322.34a2.7,2.7,0,0,1,2.12-2.64h0A2.72,2.72,0,0,0,394.26,317.05Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.55,
    y: 303.62,
    width: 5.67,
    height: 1.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.55,
    y: 303.62,
    width: 5.67,
    height: 1.91,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.32,
    y: 324.21,
    width: 8.14,
    height: 8.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.39,317.05V304.69h4.24v12.36a2.72,2.72,0,0,0,2.13,2.65h0a2.7,2.7,0,0,1,2.12,2.64V335.4H422.14V322.34a2.71,2.71,0,0,1,2.13-2.64h0A2.72,2.72,0,0,0,426.39,317.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.39,317.05V304.69h4.24v12.36a2.72,2.72,0,0,0,2.13,2.65h0a2.7,2.7,0,0,1,2.12,2.64V335.4H422.14V322.34a2.71,2.71,0,0,1,2.13-2.64h0A2.72,2.72,0,0,0,426.39,317.05Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.67,
    y: 303.62,
    width: 5.67,
    height: 1.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.67,
    y: 303.62,
    width: 5.67,
    height: 1.91,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.44,
    y: 324.21,
    width: 8.14,
    height: 8.14,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stand--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.24,
    y: 260.61,
    width: 146.56,
    height: 152.52,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.24,
    y: 260.61,
    width: 146.56,
    height: 152.52,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.53,
    y: 290.25,
    width: 137.27,
    height: 32.61,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.25,
    y: 322.86,
    width: 114.04,
    height: 22.72,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.53,
    y: 322.86,
    width: 140.76,
    height: 20.25,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.53,
    y: 260.67,
    width: 140.76,
    height: 22.72,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.71,
    y: 343.11,
    width: 116.83,
    height: 69.9,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.71,
    y: 343.11,
    width: 116.83,
    height: 70.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.71,
    y: 343.11,
    width: 116.83,
    height: 70.02,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.39,265s1.28-5.39,4.84-2.53C159.23,262.48,157.29,265.09,154.39,265Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.39,265s1.28-5.39,4.84-2.53C159.23,262.48,157.29,265.09,154.39,265Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.31,262.46c1.27-.3,1.75-.1,1.88,0-3.53-2.79-4.8,2.56-4.8,2.56S155.74,262.84,157.31,262.46Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,265.7s.45-2.36-.79-3.34c0,0,.23-.44,1-.2a7.48,7.48,0,0,1,.24,3.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,265.7s.45-2.36-.79-3.34c0,0,.23-.44,1-.2a7.48,7.48,0,0,1,.24,3.54Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.83,264.43a3.86,3.86,0,0,0-2.49,1,5,5,0,0,0-2.77-1c-2.56.05-3.1,3.19-2.64,5.19.41,1.79,1.57,5,3.51,5.2a2.82,2.82,0,0,0,1.86-1,2.26,2.26,0,0,0,1.66,1c1.93-.2,3.1-3.41,3.51-5.2C159.93,267.62,159.39,264.48,156.83,264.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.62,268.19c0,1.74-1.58,3.89-3,3.89s-1.24-1.41-2.23-1.41-.93,2.16-1.95,2.16-1.38-1.65-2-1.58c-.37.05-.6.55-.72.9.61,1.34,1.5,2.55,2.66,2.67a2.82,2.82,0,0,0,1.86-1,2.26,2.26,0,0,0,1.66,1c1.93-.2,3.1-3.41,3.51-5.2A6.53,6.53,0,0,0,159.62,268.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.47,268.61s.14-3.3,1.44-3.26S150.16,266.49,149.47,268.61Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.2,262.16c-.73-.24-1,.2-1,.2S154.11,262.75,154.2,262.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.05,265s1.27-5.39,4.84-2.53C169.89,262.48,167.94,265.09,165.05,265Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.05,265s1.27-5.39,4.84-2.53C169.89,262.48,167.94,265.09,165.05,265Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,262.46c1.27-.3,1.74-.1,1.87,0-3.53-2.79-4.79,2.56-4.79,2.56S166.4,262.84,168,262.46Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.69,265.7s.44-2.36-.79-3.34c0,0,.23-.44.95-.2a7.4,7.4,0,0,1,.25,3.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.69,265.7s.44-2.36-.79-3.34c0,0,.23-.44.95-.2a7.4,7.4,0,0,1,.25,3.54Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.49,264.43a3.9,3.9,0,0,0-2.5,1,4.94,4.94,0,0,0-2.77-1c-2.55.05-3.09,3.19-2.64,5.19.41,1.79,1.58,5,3.52,5.2a2.82,2.82,0,0,0,1.85-1,2.29,2.29,0,0,0,1.66,1c1.94-.2,3.11-3.41,3.51-5.2C170.58,267.62,170,264.48,167.49,264.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.27,268.19c0,1.74-1.57,3.89-3,3.89s-1.23-1.41-2.22-1.41-.93,2.16-2,2.16-1.37-1.65-2-1.58c-.37.05-.61.55-.73.9.62,1.34,1.5,2.55,2.67,2.67a2.82,2.82,0,0,0,1.85-1,2.29,2.29,0,0,0,1.66,1c1.94-.2,3.11-3.41,3.51-5.2A6,6,0,0,0,170.27,268.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.13,268.61s.13-3.3,1.44-3.26S160.81,266.49,160.13,268.61Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.85,262.16c-.72-.24-.95.2-.95.2S164.76,262.75,164.85,262.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.7,265s1.28-5.39,4.84-2.53C180.54,262.48,178.6,265.09,175.7,265Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.7,265s1.28-5.39,4.84-2.53C180.54,262.48,178.6,265.09,175.7,265Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.62,262.46c1.27-.3,1.75-.1,1.88,0-3.53-2.79-4.8,2.56-4.8,2.56S177.05,262.84,178.62,262.46Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.34,265.7s.45-2.36-.79-3.34c0,0,.23-.44,1-.2a7.48,7.48,0,0,1,.24,3.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.34,265.7s.45-2.36-.79-3.34c0,0,.23-.44,1-.2a7.48,7.48,0,0,1,.24,3.54Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.14,264.43a3.88,3.88,0,0,0-2.49,1,5,5,0,0,0-2.77-1c-2.56.05-3.1,3.19-2.64,5.19.41,1.79,1.58,5,3.51,5.2a2.82,2.82,0,0,0,1.86-1,2.28,2.28,0,0,0,1.66,1c1.93-.2,3.1-3.41,3.51-5.2C181.24,267.62,180.7,264.48,178.14,264.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.93,268.19c0,1.74-1.58,3.89-3,3.89s-1.23-1.41-2.23-1.41-.93,2.16-1.95,2.16-1.38-1.65-2-1.58c-.37.05-.6.55-.72.9.61,1.34,1.5,2.55,2.66,2.67a2.82,2.82,0,0,0,1.86-1,2.28,2.28,0,0,0,1.66,1c1.93-.2,3.1-3.41,3.51-5.2A6.53,6.53,0,0,0,180.93,268.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.78,268.61s.14-3.3,1.44-3.26S171.47,266.49,170.78,268.61Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51,262.16c-.73-.24-1,.2-1,.2S175.42,262.75,175.51,262.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.06,254.78s1.27-5.39,4.84-2.53C158.9,252.25,157,254.86,154.06,254.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.06,254.78s1.27-5.39,4.84-2.53C158.9,252.25,157,254.86,154.06,254.78Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,252.24c1.27-.31,1.75-.11,1.88,0-3.53-2.78-4.79,2.56-4.79,2.56S155.4,252.61,157,252.24Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.7,255.47s.44-2.36-.79-3.34c0,0,.23-.43,1-.19a7.5,7.5,0,0,1,.25,3.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.7,255.47s.44-2.36-.79-3.34c0,0,.23-.43,1-.19a7.5,7.5,0,0,1,.25,3.53Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.5,254.2a3.9,3.9,0,0,0-2.5,1,4.94,4.94,0,0,0-2.77-1c-2.56.06-3.1,3.19-2.64,5.2.41,1.78,1.58,5,3.52,5.19a2.82,2.82,0,0,0,1.85-1,2.29,2.29,0,0,0,1.66,1c1.94-.2,3.11-3.41,3.51-5.19C159.59,257.39,159.05,254.26,156.5,254.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.28,258c0,1.75-1.58,3.89-3,3.89s-1.23-1.41-2.23-1.41-.92,2.16-1.95,2.16-1.37-1.64-2-1.57c-.37,0-.6.54-.72.9.61,1.33,1.5,2.54,2.67,2.66a2.82,2.82,0,0,0,1.85-1,2.29,2.29,0,0,0,1.66,1c1.94-.2,3.11-3.41,3.51-5.19A6.63,6.63,0,0,0,159.28,258Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.13,258.39s.14-3.31,1.44-3.27S149.82,256.26,149.13,258.39Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.86,251.94c-.72-.24-1,.19-1,.19S153.77,252.52,153.86,251.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.84,254.78s1.28-5.39,4.84-2.53C169.68,252.25,167.73,254.86,164.84,254.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.84,254.78s1.28-5.39,4.84-2.53C169.68,252.25,167.73,254.86,164.84,254.78Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.76,252.24c1.27-.31,1.74-.11,1.88,0-3.53-2.78-4.8,2.56-4.8,2.56S166.19,252.61,167.76,252.24Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.48,255.47s.45-2.36-.79-3.34c0,0,.23-.43,1-.19a7.43,7.43,0,0,1,.24,3.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.48,255.47s.45-2.36-.79-3.34c0,0,.23-.43,1-.19a7.43,7.43,0,0,1,.24,3.53Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.28,254.2a3.86,3.86,0,0,0-2.49,1,5,5,0,0,0-2.78-1c-2.55.06-3.09,3.19-2.63,5.2.4,1.78,1.57,5,3.51,5.19a2.84,2.84,0,0,0,1.86-1,2.26,2.26,0,0,0,1.65,1c1.94-.2,3.11-3.41,3.52-5.19C170.38,257.39,169.84,254.26,167.28,254.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.06,258c0,1.75-1.57,3.89-3,3.89s-1.24-1.41-2.23-1.41-.93,2.16-2,2.16-1.37-1.64-2-1.57c-.37,0-.6.54-.72.9.61,1.33,1.5,2.54,2.66,2.66a2.84,2.84,0,0,0,1.86-1,2.26,2.26,0,0,0,1.65,1c1.94-.2,3.11-3.41,3.52-5.19A6.07,6.07,0,0,0,170.06,258Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.92,258.39s.14-3.31,1.44-3.27S160.61,256.26,159.92,258.39Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.65,251.94c-.73-.24-1,.19-1,.19S164.56,252.52,164.65,251.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.64,255.2s1.27-5.39,4.84-2.53C180.48,252.67,178.53,255.28,175.64,255.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.64,255.2s1.27-5.39,4.84-2.53C180.48,252.67,178.53,255.28,175.64,255.2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.55,252.65c1.27-.3,1.75-.1,1.88,0-3.53-2.79-4.79,2.56-4.79,2.56S177,253,178.55,252.65Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.28,255.89s.44-2.36-.79-3.34c0,0,.23-.43.95-.19a7.5,7.5,0,0,1,.25,3.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.28,255.89s.44-2.36-.79-3.34c0,0,.23-.43.95-.19a7.5,7.5,0,0,1,.25,3.53Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.08,254.62a3.9,3.9,0,0,0-2.5,1,4.94,4.94,0,0,0-2.77-1c-2.56,0-3.1,3.19-2.64,5.19.41,1.79,1.58,5,3.52,5.2a2.82,2.82,0,0,0,1.85-1,2.29,2.29,0,0,0,1.66,1c1.94-.2,3.11-3.41,3.51-5.2C181.17,257.81,180.63,254.67,178.08,254.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.86,258.38c0,1.74-1.58,3.89-3,3.89s-1.23-1.41-2.23-1.41-.92,2.16-2,2.16-1.37-1.64-2-1.58c-.37.05-.6.55-.72.9.61,1.34,1.5,2.55,2.67,2.67a2.82,2.82,0,0,0,1.85-1,2.29,2.29,0,0,0,1.66,1c1.94-.2,3.11-3.41,3.51-5.2A6.53,6.53,0,0,0,180.86,258.38Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.71,258.8s.14-3.3,1.44-3.26S171.4,256.68,170.71,258.8Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.44,252.36c-.72-.24-.95.19-.95.19S175.35,252.94,175.44,252.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.17,272a5.16,5.16,0,0,0-.79,0,4.2,4.2,0,0,1-1.5,0,5,5,0,0,0-.79-.09,4.42,4.42,0,1,0-.24,8.84,3.93,3.93,0,0,0,.49,0,10.54,10.54,0,0,1,2.1.06,3.89,3.89,0,0,0,.49,0,4.42,4.42,0,1,0,.24-8.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.17,272a5.16,5.16,0,0,0-.79,0,4.2,4.2,0,0,1-1.5,0,5,5,0,0,0-.79-.09,4.42,4.42,0,1,0-.24,8.84,3.93,3.93,0,0,0,.49,0,10.54,10.54,0,0,1,2.1.06,3.89,3.89,0,0,0,.49,0,4.42,4.42,0,1,0,.24-8.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,274.2c.36-.65.87-1.17,1.29-1s-.11.73.26.89.74-.51,1.12-.53.25.83.75.87.44-.78.74-.74.18,2-.24,2c-.26,0-.22-.62-.55-.63-.57,0-1,.82-1.49.8s-.14-.9-.52-1-1,1.31-1.52.95S189.76,274.65,190,274.2Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.93,280.81a4.49,4.49,0,0,0,4.69-4.29,4.3,4.3,0,0,0-1.27-3.18,3.69,3.69,0,0,1,.31,4.83c-1.92,2.66-3.8,1.59-6.07,1.9a6.93,6.93,0,0,1-4.43-1.32,4.66,4.66,0,0,0,3.69,2,3.93,3.93,0,0,0,.49,0,10.54,10.54,0,0,1,2.1.06A3.89,3.89,0,0,0,195.93,280.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.33,271.71c-.63.06-1.26-1.55-1.85-1.43a4.29,4.29,0,0,1,1,1.44s-2.29-.45-2.87.21c0,0,3.16-.4,3.09.44,0,.27-.73.3-.74.81a3.09,3.09,0,0,1,1.45-.52c.59,0,.94.9.94.9a1.71,1.71,0,0,1,0-.93c.18-.48,2.08-.62,2.67,0a1.82,1.82,0,0,0-2.07-.79,2.41,2.41,0,0,1,1.92-.62,2.1,2.1,0,0,0-2.29.34.77.77,0,0,1-.89,0l-.19-.12S194.48,271.7,194.33,271.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.46,271.87c-.05-.56.32-1.58-.11-2.24,0,0,.55-.36.86.14a2.66,2.66,0,0,1-.39,2.11C194.77,272,194.48,272.18,194.46,271.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.46,271.87c-.05-.56.32-1.58-.11-2.24,0,0,.55-.36.86.14a2.66,2.66,0,0,1-.39,2.11C194.77,272,194.48,272.18,194.46,271.87Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.21,269.77c-.31-.5-.86-.14-.86-.14S194.77,270.1,195.21,269.77Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,272a5.1,5.1,0,0,0-.79,0,4.2,4.2,0,0,1-1.5,0,5.16,5.16,0,0,0-.79-.09,4.42,4.42,0,1,0-.24,8.84,4,4,0,0,0,.49,0,10.42,10.42,0,0,1,2.09.06,4.21,4.21,0,0,0,.5,0A4.42,4.42,0,1,0,210,272Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,272a5.1,5.1,0,0,0-.79,0,4.2,4.2,0,0,1-1.5,0,5.16,5.16,0,0,0-.79-.09,4.42,4.42,0,1,0-.24,8.84,4,4,0,0,0,.49,0,10.42,10.42,0,0,1,2.09.06,4.21,4.21,0,0,0,.5,0A4.42,4.42,0,1,0,210,272Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.82,274.2c.36-.65.87-1.17,1.29-1s-.11.73.26.89.74-.51,1.11-.53.26.83.75.87.45-.78.75-.74.18,2-.24,2c-.26,0-.22-.62-.55-.63-.57,0-1,.82-1.5.8s-.14-.9-.51-1-1,1.31-1.52.95S203.57,274.65,203.82,274.2Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.74,280.81a4.49,4.49,0,0,0,4.69-4.29,4.3,4.3,0,0,0-1.27-3.18,3.71,3.71,0,0,1,.31,4.83c-1.93,2.66-3.8,1.59-6.07,1.9a6.93,6.93,0,0,1-4.43-1.32,4.66,4.66,0,0,0,3.69,2,4,4,0,0,0,.49,0,10.42,10.42,0,0,1,2.09.06A4.21,4.21,0,0,0,209.74,280.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.14,271.71c-.63.06-1.26-1.55-1.85-1.43a4.17,4.17,0,0,1,1,1.44s-2.28-.45-2.86.21c0,0,3.16-.4,3.09.44,0,.27-.73.3-.75.81a3.1,3.1,0,0,1,1.46-.52c.58,0,.93.9.93.9a1.76,1.76,0,0,1,0-.93c.18-.48,2.07-.62,2.67,0a1.82,1.82,0,0,0-2.07-.79,2.41,2.41,0,0,1,1.92-.62,2.1,2.1,0,0,0-2.29.34.77.77,0,0,1-.89,0l-.19-.12S208.28,271.7,208.14,271.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.27,271.87c-.05-.56.32-1.58-.12-2.24,0,0,.56-.36.87.14a2.7,2.7,0,0,1-.39,2.11C208.58,272,208.29,272.18,208.27,271.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.27,271.87c-.05-.56.32-1.58-.12-2.24,0,0,.56-.36.87.14a2.7,2.7,0,0,1-.39,2.11C208.58,272,208.29,272.18,208.27,271.87Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,269.77c-.31-.5-.87-.14-.87-.14S208.58,270.1,209,269.77Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.68,256a5.16,5.16,0,0,0-.79,0,4.38,4.38,0,0,1-1.49,0,5.16,5.16,0,0,0-.79-.09,4.42,4.42,0,1,0-.25,8.83h.5a9.74,9.74,0,0,1,2.09.05,2.7,2.7,0,0,0,.49,0,4.42,4.42,0,1,0,.24-8.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.68,256a5.16,5.16,0,0,0-.79,0,4.38,4.38,0,0,1-1.49,0,5.16,5.16,0,0,0-.79-.09,4.42,4.42,0,1,0-.25,8.83h.5a9.74,9.74,0,0,1,2.09.05,2.7,2.7,0,0,0,.49,0,4.42,4.42,0,1,0,.24-8.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.52,258.19c.37-.65.87-1.16,1.3-1s-.12.72.25.88.74-.51,1.12-.52.26.82.75.86.44-.77.75-.74.17,2-.25,2c-.26,0-.22-.62-.54-.63-.57,0-1,.82-1.5.81s-.14-.91-.51-1-1,1.32-1.53.95S189.27,258.65,189.52,258.19Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.44,264.8a4.5,4.5,0,0,0,4.7-4.29,4.36,4.36,0,0,0-1.27-3.17,3.69,3.69,0,0,1,.3,4.83c-1.92,2.65-3.8,1.59-6.07,1.89a6.86,6.86,0,0,1-4.42-1.32,4.59,4.59,0,0,0,3.68,2h.5a9.74,9.74,0,0,1,2.09.05A2.7,2.7,0,0,0,195.44,264.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.85,255.7c-.64.06-1.27-1.54-1.86-1.43a4.26,4.26,0,0,1,1,1.45s-2.28-.45-2.86.2c0,0,3.15-.39,3.08.44,0,.28-.73.3-.74.81a3.21,3.21,0,0,1,1.45-.52c.59,0,.94.91.94.91a1.69,1.69,0,0,1,0-.94c.17-.47,2.07-.61,2.66.05a1.82,1.82,0,0,0-2.06-.8,2.43,2.43,0,0,1,1.92-.62,2.13,2.13,0,0,0-2.3.35.8.8,0,0,1-.89,0l-.18-.13S194,255.69,193.85,255.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,255.86c0-.56.33-1.57-.11-2.24,0,0,.56-.36.86.15a2.63,2.63,0,0,1-.39,2.1C194.28,256,194,256.17,194,255.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,255.86c0-.56.33-1.57-.11-2.24,0,0,.56-.36.86.15a2.63,2.63,0,0,1-.39,2.1C194.28,256,194,256.17,194,255.86Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.72,253.77c-.3-.51-.86-.15-.86-.15S194.28,254.09,194.72,253.77Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,256.29a4.14,4.14,0,0,0-.79,0,4.14,4.14,0,0,1-1.49,0,5.16,5.16,0,0,0-.79-.09,4.42,4.42,0,1,0-.25,8.83,4.17,4.17,0,0,0,.5,0,9.14,9.14,0,0,1,2.09.06l.49,0a4.42,4.42,0,1,0,.24-8.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,256.29a4.14,4.14,0,0,0-.79,0,4.14,4.14,0,0,1-1.49,0,5.16,5.16,0,0,0-.79-.09,4.42,4.42,0,1,0-.25,8.83,4.17,4.17,0,0,0,.5,0,9.14,9.14,0,0,1,2.09.06l.49,0a4.42,4.42,0,1,0,.24-8.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.81,258.51c.37-.66.87-1.17,1.3-1s-.12.73.25.88.74-.5,1.12-.52.26.82.75.87.44-.78.75-.74.17,2-.25,2c-.26,0-.22-.62-.54-.63-.57,0-1,.82-1.5.8s-.14-.91-.51-1-1,1.31-1.53.95S204.56,259,204.81,258.51Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.73,265.12a4.5,4.5,0,0,0,4.7-4.29,4.38,4.38,0,0,0-1.27-3.18,3.69,3.69,0,0,1,.3,4.83c-1.92,2.65-3.8,1.59-6.07,1.9a6.84,6.84,0,0,1-4.42-1.33,4.59,4.59,0,0,0,3.68,2,4.17,4.17,0,0,0,.5,0,9.14,9.14,0,0,1,2.09.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.14,256c-.64.05-1.27-1.55-1.86-1.43a4.29,4.29,0,0,1,1,1.44s-2.28-.45-2.86.21c0,0,3.15-.4,3.08.44,0,.27-.73.3-.74.8a3.21,3.21,0,0,1,1.45-.52c.59.05.94.91.94.91a1.65,1.65,0,0,1,0-.93c.17-.48,2.07-.62,2.66,0a1.82,1.82,0,0,0-2.06-.8,2.43,2.43,0,0,1,1.92-.62,2.13,2.13,0,0,0-2.3.35.77.77,0,0,1-.89,0l-.18-.12S209.28,256,209.14,256Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.26,256.18c0-.56.33-1.58-.11-2.24,0,0,.56-.36.86.14a2.66,2.66,0,0,1-.39,2.11C209.57,256.26,209.29,256.49,209.26,256.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.26,256.18c0-.56.33-1.58-.11-2.24,0,0,.56-.36.86.14a2.66,2.66,0,0,1-.39,2.11C209.57,256.26,209.29,256.49,209.26,256.18Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,254.08c-.3-.5-.86-.14-.86-.14S209.57,254.41,210,254.08Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.94,263.74a4.14,4.14,0,0,0-.79.05,4.45,4.45,0,0,1-1.5-.05,5,5,0,0,0-.79-.09,4.42,4.42,0,1,0-.24,8.84,3.93,3.93,0,0,0,.49,0,10.54,10.54,0,0,1,2.1.06,3.89,3.89,0,0,0,.49,0,4.42,4.42,0,1,0,.24-8.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.94,263.74a4.14,4.14,0,0,0-.79.05,4.45,4.45,0,0,1-1.5-.05,5,5,0,0,0-.79-.09,4.42,4.42,0,1,0-.24,8.84,3.93,3.93,0,0,0,.49,0,10.54,10.54,0,0,1,2.1.06,3.89,3.89,0,0,0,.49,0,4.42,4.42,0,1,0,.24-8.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.78,266c.36-.65.87-1.17,1.29-1s-.11.73.26.89.74-.51,1.12-.53.25.83.75.87.44-.78.74-.74.18,2-.24,2c-.26,0-.22-.62-.55-.63-.57,0-1,.82-1.49.81s-.14-.91-.52-1-1,1.31-1.52.95S196.53,266.41,196.78,266Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.7,272.57a4.5,4.5,0,0,0,4.7-4.29,4.35,4.35,0,0,0-1.28-3.18,3.69,3.69,0,0,1,.31,4.83c-1.92,2.66-3.8,1.59-6.07,1.9a6.93,6.93,0,0,1-4.43-1.32,4.66,4.66,0,0,0,3.69,2,3.93,3.93,0,0,0,.49,0,10.54,10.54,0,0,1,2.1.06A3.89,3.89,0,0,0,202.7,272.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.1,263.47c-.63.06-1.26-1.55-1.85-1.43a4.29,4.29,0,0,1,1,1.44s-2.29-.45-2.87.21c0,0,3.16-.4,3.09.44,0,.27-.73.3-.74.81a3.09,3.09,0,0,1,1.45-.52c.59,0,.94.9.94.9a1.71,1.71,0,0,1,0-.93c.18-.48,2.08-.62,2.67.05a1.82,1.82,0,0,0-2.07-.8,2.41,2.41,0,0,1,1.92-.62,2.1,2.1,0,0,0-2.29.34.77.77,0,0,1-.89,0l-.19-.12S201.25,263.46,201.1,263.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.23,263.63c0-.56.32-1.58-.11-2.24,0,0,.55-.36.86.14a2.66,2.66,0,0,1-.39,2.11C201.54,263.71,201.25,263.94,201.23,263.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.23,263.63c0-.56.32-1.58-.11-2.24,0,0,.55-.36.86.14a2.66,2.66,0,0,1-.39,2.11C201.54,263.71,201.25,263.94,201.23,263.63Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,261.53c-.31-.5-.86-.14-.86-.14S201.54,261.86,202,261.53Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.93,
    y: 281.36,
    width: 10.56,
    height: 7.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.25,
    y: 281.36,
    width: 10.56,
    height: 7.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.66,
    y: 281.36,
    width: 10.56,
    height: 7.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.15,
    y: 345.17,
    width: 10.56,
    height: 7.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.43,
    y: 345.17,
    width: 10.56,
    height: 7.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.24,
    y: 260.61,
    width: 9.29,
    height: 152.52,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,260.14a1.18,1.18,0,0,1,.84-.61l.33.38-.71.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.8,260.09c-.17-1.45,0-2.77-.31-4l-.63-3.07a.43.43,0,0,0-.39-.39c-.21,0-.18.29-.13.48a20.47,20.47,0,0,1,.65,7.39C119.22,260.29,119.55,259.92,119.8,260.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.8,260.09c-.17-1.45,0-2.77-.31-4l-.63-3.07a.43.43,0,0,0-.39-.39c-.21,0-.18.29-.13.48a20.47,20.47,0,0,1,.65,7.39C119.22,260.29,119.55,259.92,119.8,260.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.84,260.06c.26-1.43.76-2.66.87-3.93L122,253a.41.41,0,0,0-.27-.48c-.19-.07-.25.21-.26.42a20,20,0,0,1-1.52,7.26C120.23,260.09,120.65,259.84,120.84,260.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.84,260.06c.26-1.43.76-2.66.87-3.93L122,253a.41.41,0,0,0-.27-.48c-.19-.07-.25.21-.26.42a20,20,0,0,1-1.52,7.26C120.23,260.09,120.65,259.84,120.84,260.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.94,252a.29.29,0,0,0-.24-.22c-.12,0-.14.07-.19.18l0,4.49-.06,3.84a.54.54,0,0,0,.54.05C120.28,260.15,119.94,252,119.94,252Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.94,252a.29.29,0,0,0-.24-.22c-.12,0-.14.07-.19.18l0,4.49-.06,3.84a.54.54,0,0,0,.54.05C120.28,260.15,119.94,252,119.94,252Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.78,252a.3.3,0,0,1,.25-.21c.12,0,.14.08.18.19l-.34,4.48-.21,3.84a.53.53,0,0,1-.54,0C119.87,260.16,120.78,252,120.78,252Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.56 280.75 120.11 280.87 119.95 281.36 117.67 281.25 117.56 280.75",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.74,262.75c-.12,1.88-.23,3.48-.34,5,0,.2,0,.4-.05.6-.27,3.27-.59,6-1.24,9.9l0,.28c-.07.37-.13.75-.2,1.14a1.74,1.74,0,0,1-.86,1.22,1.61,1.61,0,0,1-.92.22l-.52,0a1.74,1.74,0,0,1-1.67-1.63c-.17-2.77-.29-5-.32-7h0v-.53a61.9,61.9,0,0,1,.68-9.47l0-.23a2.57,2.57,0,0,1,.11-.48,2.78,2.78,0,0,1,1.63-1.78,2.24,2.24,0,0,1,.46-.14l.28,0h.4a2.25,2.25,0,0,1,.52.08,1.06,1.06,0,0,1,.19.06A2.82,2.82,0,0,1,122.74,262.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.74,262.75c-.12,1.88-.23,3.48-.34,5,0,.2,0,.4-.05.6-.27,3.27-.59,6-1.24,9.9l0,.28c-.07.37-.13.75-.2,1.14a1.74,1.74,0,0,1-.86,1.22,1.61,1.61,0,0,1-.92.22l-.52,0a1.74,1.74,0,0,1-1.67-1.63c-.17-2.77-.29-5-.32-7h0v-.53a61.9,61.9,0,0,1,.68-9.47l0-.23a2.57,2.57,0,0,1,.11-.48,2.78,2.78,0,0,1,1.63-1.78,2.24,2.24,0,0,1,.46-.14l.28,0h.4a2.25,2.25,0,0,1,.52.08,1.06,1.06,0,0,1,.19.06A2.82,2.82,0,0,1,122.74,262.75Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.4,261.71a12.73,12.73,0,0,1,3.22.9,6.38,6.38,0,0,0-3.36-.19l0-.23A2.57,2.57,0,0,1,117.4,261.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.67,262.62h0S120.66,262.61,120.67,262.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.71,262.64s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.35,267.63h0S119.38,267.66,119.35,267.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.44,267.63h0S119.4,267.61,119.44,267.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.4,267.72c0,.2,0,.4-.05.6a6.26,6.26,0,0,0-2.9-.69A13.26,13.26,0,0,1,122.4,267.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.33,272.08a6.13,6.13,0,0,0-2.75.34v-.53A12.05,12.05,0,0,1,119.33,272.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.38,272.08h0S119.37,272.07,119.38,272.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.42,272.08s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.15,278.25h0S119.18,278.27,119.15,278.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.07,278.5a5.9,5.9,0,0,0-1.88-.26s0,0,0,0a13.12,13.12,0,0,1,1.88,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.56,260.17a5.67,5.67,0,0,1,.81,2.47c.27,5.84.7,15,.58,15.86a7.24,7.24,0,0,1-.91,2.82l-1.37-.06-.27-19.55A2.87,2.87,0,0,1,118.56,260.17Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.3,259.93c-.38-1.41-.45-2.74-.89-3.93s-1.08-2.94-1.08-2.94a.42.42,0,0,0-.44-.33c-.21,0-.14.31-.06.49a20.26,20.26,0,0,1,1.73,7.22C113.75,260.22,114,259.8,114.3,259.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.3,259.93c-.38-1.41-.45-2.74-.89-3.93s-1.08-2.94-1.08-2.94a.42.42,0,0,0-.44-.33c-.21,0-.14.31-.06.49a20.26,20.26,0,0,1,1.73,7.22C113.75,260.22,114,259.8,114.3,259.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.33,259.75c0-1.45.36-2.75.28-4s-.17-3.13-.17-3.13a.43.43,0,0,0-.34-.44c-.2,0-.22.26-.19.46a20.18,20.18,0,0,1-.44,7.4C114.72,259.87,115.11,259.55,115.33,259.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.33,259.75c0-1.45.36-2.75.28-4s-.17-3.13-.17-3.13a.43.43,0,0,0-.34-.44c-.2,0-.22.26-.19.46a20.18,20.18,0,0,1-.44,7.4C114.72,259.87,115.11,259.55,115.33,259.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.24,251.88a.28.28,0,0,0-.26-.19c-.12,0-.14.09-.16.21l.69,4.44.5,3.8a.53.53,0,0,0,.54,0C114.79,259.92,113.24,251.88,113.24,251.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.24,251.88a.28.28,0,0,0-.26-.19c-.12,0-.14.09-.16.21l.69,4.44.5,3.8a.53.53,0,0,0,.54,0C114.79,259.92,113.24,251.88,113.24,251.88Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.09,251.81a.28.28,0,0,1,.22-.24c.11,0,.14.06.2.16l.32,4.49.36,3.82a.52.52,0,0,1-.53.09C114.39,260,114.09,251.81,114.09,251.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.12 280.7 117.67 280.44 117.58 280.94 115.31 281.18 115.12 280.7",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.61,262.13c.15,1.87.28,3.48.38,5,0,.2,0,.4,0,.59.22,3.28.31,6.06.24,10V278c0,.37,0,.76,0,1.15a1.72,1.72,0,0,1-1.56,1.69l-.51.05a1.85,1.85,0,0,1-.94-.16,1.76,1.76,0,0,1-1-1.2c-.57-2.72-1-4.86-1.35-6.89h0c0-.18-.05-.36-.08-.53a62,62,0,0,1-.71-9.47,1.69,1.69,0,0,1,0-.23,2.59,2.59,0,0,1,0-.48,2.83,2.83,0,0,1,1.34-2,2.48,2.48,0,0,1,.44-.2l.27-.08a1.65,1.65,0,0,1,.32-.06h.08a3.11,3.11,0,0,1,.53,0l.19,0A2.84,2.84,0,0,1,117.61,262.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.61,262.13c.15,1.87.28,3.48.38,5,0,.2,0,.4,0,.59.22,3.28.31,6.06.24,10V278c0,.37,0,.76,0,1.15a1.72,1.72,0,0,1-1.56,1.69l-.51.05a1.85,1.85,0,0,1-.94-.16,1.76,1.76,0,0,1-1-1.2c-.57-2.72-1-4.86-1.35-6.89h0c0-.18-.05-.36-.08-.53a62,62,0,0,1-.71-9.47,1.69,1.69,0,0,1,0-.23,2.59,2.59,0,0,1,0-.48,2.83,2.83,0,0,1,1.34-2,2.48,2.48,0,0,1,.44-.2l.27-.08a1.65,1.65,0,0,1,.32-.06h.08a3.11,3.11,0,0,1,.53,0l.19,0A2.84,2.84,0,0,1,117.61,262.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.17,261.89a12.75,12.75,0,0,1,3.32.41,6.49,6.49,0,0,0-3.35.3,1.69,1.69,0,0,1,0-.23A2.59,2.59,0,0,1,112.17,261.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.53,262.31h0S115.53,262.29,115.53,262.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.58,262.32s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,267.46h0S115,267.48,115,267.46Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,267.44h0S115,267.42,115.05,267.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,267.1c0,.2,0,.4,0,.59a6.37,6.37,0,0,0-3-.25A12.55,12.55,0,0,1,118,267.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.6,271.85a6.22,6.22,0,0,0-2.67.75c0-.18-.05-.36-.08-.53A13.37,13.37,0,0,1,115.6,271.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.65,271.85h0S115.64,271.84,115.65,271.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,271.85s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.33,278h0S116.37,278,116.33,278Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.27,278a5.77,5.77,0,0,0-1.9,0s0,0,0,0a11.63,11.63,0,0,1,1.86-.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.51,259.88a2.54,2.54,0,0,1,1.56,2.76,107.46,107.46,0,0,1-1.53,13.26l-1.41-9.65C111.88,263.43,111.76,260.74,113.51,259.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.49,259.93c-.39-1.41-.45-2.74-.9-3.93l-1.07-2.94a.43.43,0,0,0-.45-.33c-.2,0-.14.31-.06.49a20.26,20.26,0,0,1,1.73,7.22C87.94,260.22,88.22,259.8,88.49,259.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.49,259.93c-.39-1.41-.45-2.74-.9-3.93l-1.07-2.94a.43.43,0,0,0-.45-.33c-.2,0-.14.31-.06.49a20.26,20.26,0,0,1,1.73,7.22C87.94,260.22,88.22,259.8,88.49,259.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.52,259.75c0-1.45.36-2.75.28-4s-.18-3.13-.18-3.13a.42.42,0,0,0-.33-.44c-.2,0-.22.26-.2.46a20.18,20.18,0,0,1-.43,7.4C88.91,259.87,89.3,259.55,89.52,259.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.52,259.75c0-1.45.36-2.75.28-4s-.18-3.13-.18-3.13a.42.42,0,0,0-.33-.44c-.2,0-.22.26-.2.46a20.18,20.18,0,0,1-.43,7.4C88.91,259.87,89.3,259.55,89.52,259.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.43,251.88a.29.29,0,0,0-.27-.19c-.12,0-.13.09-.16.21l.69,4.44.51,3.8a.53.53,0,0,0,.54,0C89,259.92,87.43,251.88,87.43,251.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.43,251.88a.29.29,0,0,0-.27-.19c-.12,0-.13.09-.16.21l.69,4.44.51,3.8a.53.53,0,0,0,.54,0C89,259.92,87.43,251.88,87.43,251.88Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.27,251.81a.29.29,0,0,1,.22-.24c.12,0,.15.06.2.16l.33,4.49.36,3.82a.53.53,0,0,1-.53.09C88.57,260,88.27,251.81,88.27,251.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.31 280.7 91.85 280.44 91.76 280.94 89.5 281.18 89.31 280.7",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.79,262.13c.15,1.87.28,3.48.39,5,0,.2,0,.4,0,.59.22,3.28.31,6.06.24,10V278c0,.37,0,.76,0,1.15a1.77,1.77,0,0,1-.68,1.34,1.8,1.8,0,0,1-.88.35l-.51.05a1.89,1.89,0,0,1-1-.16,1.75,1.75,0,0,1-.94-1.2c-.58-2.72-1-4.86-1.35-6.89h0c0-.18-.06-.36-.08-.53a63.17,63.17,0,0,1-.72-9.47v-.23a2.58,2.58,0,0,1,0-.48,2.82,2.82,0,0,1,1.35-2,2.19,2.19,0,0,1,.44-.2l.27-.08a1.55,1.55,0,0,1,.31-.06h.09a3,3,0,0,1,.52,0l.2,0A2.83,2.83,0,0,1,91.79,262.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.79,262.13c.15,1.87.28,3.48.39,5,0,.2,0,.4,0,.59.22,3.28.31,6.06.24,10V278c0,.37,0,.76,0,1.15a1.77,1.77,0,0,1-.68,1.34,1.8,1.8,0,0,1-.88.35l-.51.05a1.89,1.89,0,0,1-1-.16,1.75,1.75,0,0,1-.94-1.2c-.58-2.72-1-4.86-1.35-6.89h0c0-.18-.06-.36-.08-.53a63.17,63.17,0,0,1-.72-9.47v-.23a2.58,2.58,0,0,1,0-.48,2.82,2.82,0,0,1,1.35-2,2.19,2.19,0,0,1,.44-.2l.27-.08a1.55,1.55,0,0,1,.31-.06h.09a3,3,0,0,1,.52,0l.2,0A2.83,2.83,0,0,1,91.79,262.13Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.35,261.89a12.69,12.69,0,0,1,3.32.41,6.49,6.49,0,0,0-3.35.3v-.23A2.58,2.58,0,0,1,86.35,261.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.72,262.31h0S89.71,262.29,89.72,262.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.76,262.32s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.16,267.46h0S89.19,267.48,89.16,267.46Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.24,267.44h0S89.2,267.42,89.24,267.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.18,267.1c0,.2,0,.4,0,.59a6.37,6.37,0,0,0-3-.25A12.49,12.49,0,0,1,92.18,267.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.78,271.85a6.22,6.22,0,0,0-2.66.75c0-.18-.06-.36-.08-.53A13.28,13.28,0,0,1,89.78,271.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.84,271.85h0S89.83,271.84,89.84,271.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.88,271.85s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.52,278h0S90.55,278,90.52,278Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.45,278a5.71,5.71,0,0,0-1.89,0s0,0,0,0a11.63,11.63,0,0,1,1.86-.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.33,259.54c-.92.46-1.41,1.43-1.45,2.94-.08,3.69,1.25,10.89,2.49,17.86.1.41.91.59,1.39.61l.29-7.32-1.19-13.1A2.06,2.06,0,0,0,89.33,259.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,260.09c-.18-1.45,0-2.77-.31-4s-.63-3.07-.63-3.07a.43.43,0,0,0-.4-.39c-.2,0-.18.29-.13.48a20,20,0,0,1,.65,7.39C94.4,260.29,94.74,259.92,95,260.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,260.09c-.18-1.45,0-2.77-.31-4s-.63-3.07-.63-3.07a.43.43,0,0,0-.4-.39c-.2,0-.18.29-.13.48a20,20,0,0,1,.65,7.39C94.4,260.29,94.74,259.92,95,260.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,260.06c.25-1.43.76-2.66.87-3.93s.29-3.12.29-3.12a.42.42,0,0,0-.27-.48c-.19-.07-.25.21-.26.42a20.44,20.44,0,0,1-1.52,7.26C95.41,260.09,95.84,259.84,96,260.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,260.06c.25-1.43.76-2.66.87-3.93s.29-3.12.29-3.12a.42.42,0,0,0-.27-.48c-.19-.07-.25.21-.26.42a20.44,20.44,0,0,1-1.52,7.26C95.41,260.09,95.84,259.84,96,260.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.12,252a.28.28,0,0,0-.24-.22c-.11,0-.14.07-.18.18l0,4.49-.06,3.84a.53.53,0,0,0,.54.05C95.47,260.15,95.12,252,95.12,252Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.12,252a.28.28,0,0,0-.24-.22c-.11,0-.14.07-.18.18l0,4.49-.06,3.84a.53.53,0,0,0,.54.05C95.47,260.15,95.12,252,95.12,252Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,252a.28.28,0,0,1,.25-.21c.12,0,.14.08.17.19l-.34,4.48-.2,3.84a.53.53,0,0,1-.54,0C95.06,260.16,96,252,96,252Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.74 280.75 95.3 280.87 95.13 281.36 92.86 281.25 92.74 280.75",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.93,262.75c-.13,1.88-.23,3.48-.35,5,0,.2,0,.4,0,.6-.26,3.27-.58,6-1.23,9.9l0,.28c-.06.37-.12.75-.19,1.14a1.76,1.76,0,0,1-.87,1.22,1.59,1.59,0,0,1-.92.22l-.52,0a1.74,1.74,0,0,1-1.66-1.63c-.17-2.77-.3-5-.32-7h0c0-.18,0-.36,0-.53a62,62,0,0,1,.69-9.47,1.6,1.6,0,0,1,0-.23,2.56,2.56,0,0,1,.1-.48,2.81,2.81,0,0,1,1.63-1.78,2.54,2.54,0,0,1,.47-.14l.27,0h.41a2.34,2.34,0,0,1,.52.08l.18.06A2.81,2.81,0,0,1,97.93,262.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.93,262.75c-.13,1.88-.23,3.48-.35,5,0,.2,0,.4,0,.6-.26,3.27-.58,6-1.23,9.9l0,.28c-.06.37-.12.75-.19,1.14a1.76,1.76,0,0,1-.87,1.22,1.59,1.59,0,0,1-.92.22l-.52,0a1.74,1.74,0,0,1-1.66-1.63c-.17-2.77-.3-5-.32-7h0c0-.18,0-.36,0-.53a62,62,0,0,1,.69-9.47,1.6,1.6,0,0,1,0-.23,2.56,2.56,0,0,1,.1-.48,2.81,2.81,0,0,1,1.63-1.78,2.54,2.54,0,0,1,.47-.14l.27,0h.41a2.34,2.34,0,0,1,.52.08l.18.06A2.81,2.81,0,0,1,97.93,262.75Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.58,261.71a12.69,12.69,0,0,1,3.23.9,6.39,6.39,0,0,0-3.36-.19,1.6,1.6,0,0,1,0-.23A2.56,2.56,0,0,1,92.58,261.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.85,262.62h0S95.85,262.61,95.85,262.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.89,262.64s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.54,267.63h0S94.57,267.66,94.54,267.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.62,267.63h0S94.59,267.61,94.62,267.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.58,267.72c0,.2,0,.4,0,.6a6.23,6.23,0,0,0-2.9-.69A13.25,13.25,0,0,1,97.58,267.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.51,272.08a6.07,6.07,0,0,0-2.74.34c0-.18,0-.36,0-.53A12,12,0,0,1,94.51,272.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.56,272.08h0S94.56,272.07,94.56,272.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.61,272.08s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.33,278.25h0S94.37,278.27,94.33,278.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.25,278.5a5.87,5.87,0,0,0-1.87-.26s0,0,0,0a13.09,13.09,0,0,1,1.88,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,260c.61.26.91,1.2,1,2.62l.31,14.17c0,2.09-.07,4.25-.78,4.49l-1.66,0-.79-2.2.67-17.74A2.84,2.84,0,0,1,94,260Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.86,259.93c-.38-1.41-.45-2.74-.9-3.93l-1.07-2.94a.43.43,0,0,0-.45-.33c-.2,0-.14.31-.06.49a20.26,20.26,0,0,1,1.73,7.22C90.31,260.22,90.59,259.8,90.86,259.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.86,259.93c-.38-1.41-.45-2.74-.9-3.93l-1.07-2.94a.43.43,0,0,0-.45-.33c-.2,0-.14.31-.06.49a20.26,20.26,0,0,1,1.73,7.22C90.31,260.22,90.59,259.8,90.86,259.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.89,259.75c0-1.45.36-2.75.28-4S92,252.6,92,252.6a.42.42,0,0,0-.33-.44c-.2,0-.22.26-.2.46A20.18,20.18,0,0,1,91,260C91.28,259.87,91.67,259.55,91.89,259.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.89,259.75c0-1.45.36-2.75.28-4S92,252.6,92,252.6a.42.42,0,0,0-.33-.44c-.2,0-.22.26-.2.46A20.18,20.18,0,0,1,91,260C91.28,259.87,91.67,259.55,91.89,259.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8,251.88a.29.29,0,0,0-.27-.19c-.12,0-.13.09-.16.21l.69,4.44.51,3.8a.53.53,0,0,0,.54,0C91.35,259.92,89.8,251.88,89.8,251.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8,251.88a.29.29,0,0,0-.27-.19c-.12,0-.13.09-.16.21l.69,4.44.51,3.8a.53.53,0,0,0,.54,0C91.35,259.92,89.8,251.88,89.8,251.88Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.64,251.81a.29.29,0,0,1,.22-.24c.12,0,.15.06.2.16l.33,4.49.36,3.82a.53.53,0,0,1-.53.09C90.94,260,90.64,251.81,90.64,251.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.68 280.7 94.22 280.44 94.13 280.94 91.87 281.18 91.68 280.7",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.16,262.13c.15,1.87.28,3.48.39,5,0,.2,0,.4,0,.59.22,3.28.31,6.06.24,10V278c0,.37,0,.76,0,1.15a1.74,1.74,0,0,1-1.56,1.69l-.51.05a1.89,1.89,0,0,1-1-.16,1.77,1.77,0,0,1-.94-1.2c-.58-2.72-1-4.86-1.35-6.89h0c0-.18-.06-.36-.08-.53a63.17,63.17,0,0,1-.72-9.47v-.23a2.58,2.58,0,0,1,0-.48,2.82,2.82,0,0,1,1.35-2,2.19,2.19,0,0,1,.44-.2l.27-.08a1.55,1.55,0,0,1,.31-.06h.09a3,3,0,0,1,.52,0l.2,0A2.83,2.83,0,0,1,94.16,262.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.16,262.13c.15,1.87.28,3.48.39,5,0,.2,0,.4,0,.59.22,3.28.31,6.06.24,10V278c0,.37,0,.76,0,1.15a1.74,1.74,0,0,1-1.56,1.69l-.51.05a1.89,1.89,0,0,1-1-.16,1.77,1.77,0,0,1-.94-1.2c-.58-2.72-1-4.86-1.35-6.89h0c0-.18-.06-.36-.08-.53a63.17,63.17,0,0,1-.72-9.47v-.23a2.58,2.58,0,0,1,0-.48,2.82,2.82,0,0,1,1.35-2,2.19,2.19,0,0,1,.44-.2l.27-.08a1.55,1.55,0,0,1,.31-.06h.09a3,3,0,0,1,.52,0l.2,0A2.83,2.83,0,0,1,94.16,262.13Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.72,261.89a12.82,12.82,0,0,1,3.33.41,6.52,6.52,0,0,0-3.36.3v-.23A2.58,2.58,0,0,1,88.72,261.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.09,262.31h0S92.08,262.29,92.09,262.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.13,262.32s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.53,267.46h0S91.56,267.48,91.53,267.46Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.61,267.44h0S91.57,267.42,91.61,267.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.55,267.1c0,.2,0,.4,0,.59a6.37,6.37,0,0,0-3-.25A12.49,12.49,0,0,1,94.55,267.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.15,271.85a6.22,6.22,0,0,0-2.66.75c0-.18-.06-.36-.08-.53A13.28,13.28,0,0,1,92.15,271.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.21,271.85h0S92.2,271.84,92.21,271.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.25,271.85s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.89,278h0S92.92,278,92.89,278Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.82,278a5.71,5.71,0,0,0-1.89,0s0,0,0,0a11.63,11.63,0,0,1,1.86-.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.69,260.21c-.84.6-1.07,1.65-.88,3l1.5,7.58.35-4-.29-5.95A2.75,2.75,0,0,0,96.69,260.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.35,260.24c-.51-1.36-.71-2.67-1.26-3.82s-1.35-2.83-1.35-2.83a.43.43,0,0,0-.48-.28c-.2.05-.11.32,0,.5a20.18,20.18,0,0,1,2.41,7C97.84,260.59,98.08,260.15,98.35,260.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.35,260.24c-.51-1.36-.71-2.67-1.26-3.82s-1.35-2.83-1.35-2.83a.43.43,0,0,0-.48-.28c-.2.05-.11.32,0,.5a20.18,20.18,0,0,1,2.41,7C97.84,260.59,98.08,260.15,98.35,260.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.36,260c-.1-1.45.1-2.77-.1-4s-.47-3.09-.47-3.09a.43.43,0,0,0-.38-.41c-.2,0-.19.27-.15.47a20.25,20.25,0,0,1,.27,7.41C98.77,260.15,99.12,259.8,99.36,260Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.36,260c-.1-1.45.1-2.77-.1-4s-.47-3.09-.47-3.09a.43.43,0,0,0-.38-.41c-.2,0-.19.27-.15.47a20.25,20.25,0,0,1,.27,7.41C98.77,260.15,99.12,259.8,99.36,260Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.53,252.33a.28.28,0,0,0-.28-.15c-.12,0-.12.1-.14.21l1.11,4.36.87,3.74a.51.51,0,0,0,.53-.09C98.84,260.19,96.53,252.33,96.53,252.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.53,252.33a.28.28,0,0,0-.28-.15c-.12,0-.12.1-.14.21l1.11,4.36.87,3.74a.51.51,0,0,0,.53-.09C98.84,260.19,96.53,252.33,96.53,252.33Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.37,252.19a.27.27,0,0,1,.19-.26c.11,0,.15,0,.21.14l.76,4.43.72,3.77a.51.51,0,0,1-.52.14C98.44,260.3,97.37,252.19,97.37,252.19Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.16 280.84 103.66 280.34 103.62 280.85 101.39 281.3 101.16 280.84",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.85,262.12c.33,1.85.62,3.44.87,4.91l.09.59c.53,3.24.89,6,1.19,9.91l0,.28c0,.38.06.76.09,1.16a1.78,1.78,0,0,1-.55,1.39,1.65,1.65,0,0,1-.84.43l-.51.1a1.7,1.7,0,0,1-.95-.07,1.75,1.75,0,0,1-1.06-1.11c-.83-2.64-1.48-4.73-2-6.72h0c0-.18-.09-.35-.13-.52a63.63,63.63,0,0,1-1.62-9.35,2,2,0,0,1,0-.23,2,2,0,0,1,0-.49,2.79,2.79,0,0,1,1.15-2.12A1.87,1.87,0,0,1,98,260l.26-.1a1.58,1.58,0,0,1,.31-.09l.08,0a3.23,3.23,0,0,1,.53,0h.19A2.82,2.82,0,0,1,101.85,262.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.85,262.12c.33,1.85.62,3.44.87,4.91l.09.59c.53,3.24.89,6,1.19,9.91l0,.28c0,.38.06.76.09,1.16a1.78,1.78,0,0,1-.55,1.39,1.65,1.65,0,0,1-.84.43l-.51.1a1.7,1.7,0,0,1-.95-.07,1.75,1.75,0,0,1-1.06-1.11c-.83-2.64-1.48-4.73-2-6.72h0c0-.18-.09-.35-.13-.52a63.63,63.63,0,0,1-1.62-9.35,2,2,0,0,1,0-.23,2,2,0,0,1,0-.49,2.79,2.79,0,0,1,1.15-2.12A1.87,1.87,0,0,1,98,260l.26-.1a1.58,1.58,0,0,1,.31-.09l.08,0a3.23,3.23,0,0,1,.53,0h.19A2.82,2.82,0,0,1,101.85,262.12Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.42,262.4a12.86,12.86,0,0,1,3.34.09,6.44,6.44,0,0,0-3.31.63,2,2,0,0,1,0-.23A2,2,0,0,1,96.42,262.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.81,262.5h0S99.8,262.48,99.81,262.5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.85,262.5s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.74,267.68l0,0S99.78,267.69,99.74,267.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.82,267.66h0S99.78,267.64,99.82,267.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.72,267l.09.59a6.39,6.39,0,0,0-3,0A12.83,12.83,0,0,1,102.72,267Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.78,272a6.32,6.32,0,0,0-2.58,1c0-.18-.09-.35-.13-.52A12.63,12.63,0,0,1,100.78,272Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.83,272h0S100.83,272,100.83,272Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.88,272s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.1,278h0S102.13,278,102.1,278Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,277.81a6,6,0,0,0-1.88.2s0,0,0,0a12.46,12.46,0,0,1,1.82-.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.71,267c0,5-.27,11.14.24,12.54a8.22,8.22,0,0,0,.54,1.31l.13,0,0-.51v-6.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.06,260.09c-.17-1.45,0-2.77-.31-4l-.63-3.07a.43.43,0,0,0-.39-.39c-.2,0-.18.29-.13.48a20.47,20.47,0,0,1,.65,7.39C105.48,260.29,105.81,259.92,106.06,260.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.06,260.09c-.17-1.45,0-2.77-.31-4l-.63-3.07a.43.43,0,0,0-.39-.39c-.2,0-.18.29-.13.48a20.47,20.47,0,0,1,.65,7.39C105.48,260.29,105.81,259.92,106.06,260.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.11,260.06c.25-1.43.76-2.66.87-3.93s.28-3.12.28-3.12a.42.42,0,0,0-.26-.48c-.2-.07-.26.21-.27.42a20,20,0,0,1-1.52,7.26C106.49,260.09,106.92,259.84,107.11,260.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.11,260.06c.25-1.43.76-2.66.87-3.93s.28-3.12.28-3.12a.42.42,0,0,0-.26-.48c-.2-.07-.26.21-.27.42a20,20,0,0,1-1.52,7.26C106.49,260.09,106.92,259.84,107.11,260.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2,252a.28.28,0,0,0-.24-.22c-.12,0-.14.07-.19.18l0,4.49-.06,3.84a.54.54,0,0,0,.54.05C106.54,260.15,106.2,252,106.2,252Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2,252a.28.28,0,0,0-.24-.22c-.12,0-.14.07-.19.18l0,4.49-.06,3.84a.54.54,0,0,0,.54.05C106.54,260.15,106.2,252,106.2,252Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,252a.3.3,0,0,1,.26-.21c.11,0,.13.08.17.19l-.34,4.48-.2,3.84a.53.53,0,0,1-.54,0C106.13,260.16,107,252,107,252Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.82 280.75 106.37 280.87 106.21 281.36 103.94 281.25 103.82 280.75",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,262.75c-.13,1.88-.24,3.48-.35,5,0,.2,0,.4,0,.6-.27,3.27-.58,6-1.24,9.9l0,.28c-.06.37-.13.75-.2,1.14a1.72,1.72,0,0,1-.86,1.22,1.61,1.61,0,0,1-.92.22l-.52,0a1.79,1.79,0,0,1-.91-.3,1.72,1.72,0,0,1-.75-1.33c-.18-2.77-.3-5-.33-7h0v-.53a63.2,63.2,0,0,1,.68-9.47l0-.23a3.72,3.72,0,0,1,.11-.48,2.81,2.81,0,0,1,1.63-1.78,2.44,2.44,0,0,1,.46-.14l.28,0h.4a2.17,2.17,0,0,1,.52.08,1.06,1.06,0,0,1,.19.06A2.84,2.84,0,0,1,109,262.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,262.75c-.13,1.88-.24,3.48-.35,5,0,.2,0,.4,0,.6-.27,3.27-.58,6-1.24,9.9l0,.28c-.06.37-.13.75-.2,1.14a1.72,1.72,0,0,1-.86,1.22,1.61,1.61,0,0,1-.92.22l-.52,0a1.79,1.79,0,0,1-.91-.3,1.72,1.72,0,0,1-.75-1.33c-.18-2.77-.3-5-.33-7h0v-.53a63.2,63.2,0,0,1,.68-9.47l0-.23a3.72,3.72,0,0,1,.11-.48,2.81,2.81,0,0,1,1.63-1.78,2.44,2.44,0,0,1,.46-.14l.28,0h.4a2.17,2.17,0,0,1,.52.08,1.06,1.06,0,0,1,.19.06A2.84,2.84,0,0,1,109,262.75Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.66,261.71a12.69,12.69,0,0,1,3.23.9,6.42,6.42,0,0,0-3.37-.19l0-.23A3.72,3.72,0,0,1,103.66,261.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.93,262.62h0S106.92,262.61,106.93,262.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,262.64s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.61,267.63h0S105.65,267.66,105.61,267.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.7,267.63h0S105.67,267.61,105.7,267.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.66,267.72c0,.2,0,.4,0,.6a6.23,6.23,0,0,0-2.9-.69A13.25,13.25,0,0,1,108.66,267.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.59,272.08a6.13,6.13,0,0,0-2.75.34v-.53A12.05,12.05,0,0,1,105.59,272.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.64,272.08h0S105.64,272.07,105.64,272.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.68,272.08s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.41,278.25h0S105.44,278.27,105.41,278.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.33,278.5a5.9,5.9,0,0,0-1.88-.26s0,0,0,0a13.12,13.12,0,0,1,1.88,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.88,261.71a22.06,22.06,0,0,0-.81,5.39v6.45c.28-2.28.5-4.4.59-6.12A17.14,17.14,0,0,0,108.88,261.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.57,260.09c-.17-1.45,0-2.77-.31-4l-.63-3.07a.43.43,0,0,0-.39-.39c-.2,0-.18.29-.13.48a20.47,20.47,0,0,1,.65,7.39C111,260.29,111.32,259.92,111.57,260.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.57,260.09c-.17-1.45,0-2.77-.31-4l-.63-3.07a.43.43,0,0,0-.39-.39c-.2,0-.18.29-.13.48a20.47,20.47,0,0,1,.65,7.39C111,260.29,111.32,259.92,111.57,260.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.62,260.06c.25-1.43.76-2.66.87-3.93s.28-3.12.28-3.12a.42.42,0,0,0-.26-.48c-.2-.07-.26.21-.27.42a20,20,0,0,1-1.52,7.26C112,260.09,112.43,259.84,112.62,260.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.62,260.06c.25-1.43.76-2.66.87-3.93s.28-3.12.28-3.12a.42.42,0,0,0-.26-.48c-.2-.07-.26.21-.27.42a20,20,0,0,1-1.52,7.26C112,260.09,112.43,259.84,112.62,260.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.71,252a.29.29,0,0,0-.24-.22c-.12,0-.14.07-.19.18l0,4.49-.06,3.84a.54.54,0,0,0,.54.05C112.05,260.15,111.71,252,111.71,252Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.71,252a.29.29,0,0,0-.24-.22c-.12,0-.14.07-.19.18l0,4.49-.06,3.84a.54.54,0,0,0,.54.05C112.05,260.15,111.71,252,111.71,252Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.55,252a.3.3,0,0,1,.25-.21c.12,0,.14.08.18.19l-.34,4.48-.21,3.84a.51.51,0,0,1-.53,0,30,30,0,0,1,.29-4.83C112.37,253.68,112.55,252,112.55,252Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.33 280.75 111.88 280.87 111.72 281.36 109.44 281.25 109.33 280.75",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.52,262.75c-.13,1.88-.24,3.48-.35,5,0,.2,0,.4,0,.6-.27,3.27-.58,6-1.24,9.9l0,.28c-.07.37-.13.75-.2,1.14a1.74,1.74,0,0,1-.86,1.22,1.61,1.61,0,0,1-.92.22l-.52,0a1.74,1.74,0,0,1-1.67-1.63c-.17-2.77-.29-5-.32-7h0v-.53a63.2,63.2,0,0,1,.68-9.47l0-.23a2.57,2.57,0,0,1,.11-.48,2.78,2.78,0,0,1,1.63-1.78,2.24,2.24,0,0,1,.46-.14l.28,0h.4a2.17,2.17,0,0,1,.52.08,1.06,1.06,0,0,1,.19.06A2.84,2.84,0,0,1,114.52,262.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.52,262.75c-.13,1.88-.24,3.48-.35,5,0,.2,0,.4,0,.6-.27,3.27-.58,6-1.24,9.9l0,.28c-.07.37-.13.75-.2,1.14a1.74,1.74,0,0,1-.86,1.22,1.61,1.61,0,0,1-.92.22l-.52,0a1.74,1.74,0,0,1-1.67-1.63c-.17-2.77-.29-5-.32-7h0v-.53a63.2,63.2,0,0,1,.68-9.47l0-.23a2.57,2.57,0,0,1,.11-.48,2.78,2.78,0,0,1,1.63-1.78,2.24,2.24,0,0,1,.46-.14l.28,0h.4a2.17,2.17,0,0,1,.52.08,1.06,1.06,0,0,1,.19.06A2.84,2.84,0,0,1,114.52,262.75Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.17,261.71a12.81,12.81,0,0,1,3.23.9,6.42,6.42,0,0,0-3.37-.19l0-.23A2.57,2.57,0,0,1,109.17,261.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.44,262.62h0S112.43,262.61,112.44,262.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.48,262.64s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.12,267.63h0S111.15,267.66,111.12,267.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.21,267.63h0S111.18,267.61,111.21,267.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.17,267.72c0,.2,0,.4,0,.6a6.26,6.26,0,0,0-2.9-.69A13.26,13.26,0,0,1,114.17,267.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1,272.08a6.13,6.13,0,0,0-2.75.34v-.53A12.05,12.05,0,0,1,111.1,272.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.15,272.08h0S111.14,272.07,111.15,272.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.19,272.08s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.92,278.25h0S111,278.27,110.92,278.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.84,278.5a5.9,5.9,0,0,0-1.88-.26s0,0,0,0a13.12,13.12,0,0,1,1.88,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,273l1,5.27a5.14,5.14,0,0,0,1.36,2.82l.53-.06-2.6-9.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.57,260.43a4.46,4.46,0,0,0-.45,2.29l.75,8.34c.32-2.92.56-5.71.65-8.31A2.74,2.74,0,0,0,113.57,260.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.67,259.93c-.38-1.41-.45-2.74-.89-3.93s-1.08-2.94-1.08-2.94a.42.42,0,0,0-.44-.33c-.21,0-.14.31-.06.49a20.26,20.26,0,0,1,1.73,7.22C115.12,260.22,115.4,259.8,115.67,259.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.67,259.93c-.38-1.41-.45-2.74-.89-3.93s-1.08-2.94-1.08-2.94a.42.42,0,0,0-.44-.33c-.21,0-.14.31-.06.49a20.26,20.26,0,0,1,1.73,7.22C115.12,260.22,115.4,259.8,115.67,259.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.7,259.75c0-1.45.36-2.75.28-4s-.17-3.13-.17-3.13a.43.43,0,0,0-.34-.44c-.2,0-.22.26-.19.46a20.18,20.18,0,0,1-.44,7.4C116.09,259.87,116.48,259.55,116.7,259.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.7,259.75c0-1.45.36-2.75.28-4s-.17-3.13-.17-3.13a.43.43,0,0,0-.34-.44c-.2,0-.22.26-.19.46a20.18,20.18,0,0,1-.44,7.4C116.09,259.87,116.48,259.55,116.7,259.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.61,251.88a.28.28,0,0,0-.26-.19c-.12,0-.14.09-.16.21l.69,4.44.5,3.8a.53.53,0,0,0,.54,0C116.16,259.92,114.61,251.88,114.61,251.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.61,251.88a.28.28,0,0,0-.26-.19c-.12,0-.14.09-.16.21l.69,4.44.5,3.8a.53.53,0,0,0,.54,0C116.16,259.92,114.61,251.88,114.61,251.88Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.46,251.81a.28.28,0,0,1,.22-.24c.11,0,.14.06.2.16l.32,4.49.36,3.82a.52.52,0,0,1-.53.09C115.76,260,115.46,251.81,115.46,251.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.49 280.7 119.04 280.44 118.95 280.94 116.69 281.18 116.49 280.7",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,262.13c.15,1.87.28,3.48.39,5l0,.59c.22,3.28.31,6.06.24,10V278c0,.37,0,.76,0,1.15a1.72,1.72,0,0,1-1.55,1.69l-.52.05a1.85,1.85,0,0,1-.94-.16,1.76,1.76,0,0,1-.95-1.2c-.57-2.72-1-4.86-1.35-6.89h0c0-.18,0-.36-.08-.53a62,62,0,0,1-.71-9.47,1.69,1.69,0,0,1,0-.23,2.59,2.59,0,0,1,0-.48,2.83,2.83,0,0,1,1.34-2,2.48,2.48,0,0,1,.44-.2l.27-.08a1.65,1.65,0,0,1,.32-.06H116a3.11,3.11,0,0,1,.53,0l.19,0A2.84,2.84,0,0,1,119,262.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,262.13c.15,1.87.28,3.48.39,5l0,.59c.22,3.28.31,6.06.24,10V278c0,.37,0,.76,0,1.15a1.72,1.72,0,0,1-1.55,1.69l-.52.05a1.85,1.85,0,0,1-.94-.16,1.76,1.76,0,0,1-.95-1.2c-.57-2.72-1-4.86-1.35-6.89h0c0-.18,0-.36-.08-.53a62,62,0,0,1-.71-9.47,1.69,1.69,0,0,1,0-.23,2.59,2.59,0,0,1,0-.48,2.83,2.83,0,0,1,1.34-2,2.48,2.48,0,0,1,.44-.2l.27-.08a1.65,1.65,0,0,1,.32-.06H116a3.11,3.11,0,0,1,.53,0l.19,0A2.84,2.84,0,0,1,119,262.13Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.54,261.89a12.75,12.75,0,0,1,3.32.41,6.49,6.49,0,0,0-3.35.3,1.69,1.69,0,0,1,0-.23A2.59,2.59,0,0,1,113.54,261.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.9,262.31h0S116.9,262.29,116.9,262.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,262.32s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.34,267.46h0S116.38,267.48,116.34,267.46Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.42,267.44h0S116.39,267.42,116.42,267.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.37,267.1l0,.59a6.36,6.36,0,0,0-3-.25A12.57,12.57,0,0,1,119.37,267.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,271.85a6.22,6.22,0,0,0-2.67.75c0-.18,0-.36-.08-.53A13.37,13.37,0,0,1,117,271.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,271.85h0S117,271.84,117,271.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.06,271.85s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.7,278h0S117.74,278,117.7,278Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.64,278a5.77,5.77,0,0,0-1.9,0s0,0,0,0a11.63,11.63,0,0,1,1.86-.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.16,260.82a7.67,7.67,0,0,0,0,3l.35,2.38.23-3.47A3,3,0,0,0,122.16,260.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.17,260.24c-.52-1.36-.71-2.67-1.27-3.82s-1.35-2.83-1.35-2.83a.43.43,0,0,0-.47-.28c-.2.05-.11.32,0,.5a20.36,20.36,0,0,1,2.4,7C123.65,260.59,123.89,260.15,124.17,260.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.17,260.24c-.52-1.36-.71-2.67-1.27-3.82s-1.35-2.83-1.35-2.83a.43.43,0,0,0-.47-.28c-.2.05-.11.32,0,.5a20.36,20.36,0,0,1,2.4,7C123.65,260.59,123.89,260.15,124.17,260.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.18,260c-.1-1.45.09-2.77-.11-4s-.47-3.09-.47-3.09a.42.42,0,0,0-.37-.41c-.21,0-.2.27-.16.47a20.48,20.48,0,0,1,.28,7.41C124.58,260.15,124.94,259.8,125.18,260Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.18,260c-.1-1.45.09-2.77-.11-4s-.47-3.09-.47-3.09a.42.42,0,0,0-.37-.41c-.21,0-.2.27-.16.47a20.48,20.48,0,0,1,.28,7.41C124.58,260.15,124.94,259.8,125.18,260Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.35,252.33a.28.28,0,0,0-.29-.15c-.11,0-.12.1-.14.21l1.12,4.36.86,3.74a.53.53,0,0,0,.54-.09C124.65,260.19,122.35,252.33,122.35,252.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.35,252.33a.28.28,0,0,0-.29-.15c-.11,0-.12.1-.14.21l1.12,4.36.86,3.74a.53.53,0,0,0,.54-.09C124.65,260.19,122.35,252.33,122.35,252.33Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.18,252.19a.27.27,0,0,1,.2-.26c.11,0,.15,0,.21.14l.75,4.43.73,3.77a.52.52,0,0,1-.52.14C124.26,260.3,123.18,252.19,123.18,252.19Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.97 280.84 129.48 280.34 129.44 280.85 127.21 281.3 126.97 280.84",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.67,262.12c.33,1.85.61,3.44.86,4.91l.09.59c.53,3.24.89,6,1.19,9.91l0,.28c0,.38,0,.76.08,1.16a1.74,1.74,0,0,1-.54,1.39,1.72,1.72,0,0,1-.85.43l-.5.1a1.73,1.73,0,0,1-2-1.18c-.84-2.64-1.48-4.73-2-6.72h0c0-.18-.08-.35-.13-.52a62.43,62.43,0,0,1-1.61-9.35l0-.23a2.68,2.68,0,0,1,0-.49,2.82,2.82,0,0,1,1.15-2.12,2.22,2.22,0,0,1,.42-.25l.26-.1a1.4,1.4,0,0,1,.31-.09l.08,0a3,3,0,0,1,.52,0h.2A2.84,2.84,0,0,1,127.67,262.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.67,262.12c.33,1.85.61,3.44.86,4.91l.09.59c.53,3.24.89,6,1.19,9.91l0,.28c0,.38,0,.76.08,1.16a1.74,1.74,0,0,1-.54,1.39,1.72,1.72,0,0,1-.85.43l-.5.1a1.73,1.73,0,0,1-2-1.18c-.84-2.64-1.48-4.73-2-6.72h0c0-.18-.08-.35-.13-.52a62.43,62.43,0,0,1-1.61-9.35l0-.23a2.68,2.68,0,0,1,0-.49,2.82,2.82,0,0,1,1.15-2.12,2.22,2.22,0,0,1,.42-.25l.26-.1a1.4,1.4,0,0,1,.31-.09l.08,0a3,3,0,0,1,.52,0h.2A2.84,2.84,0,0,1,127.67,262.12Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.23,262.4a12.94,12.94,0,0,1,3.35.09,6.44,6.44,0,0,0-3.31.63l0-.23A2.68,2.68,0,0,1,122.23,262.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.62,262.5h0S125.61,262.48,125.62,262.5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.66,262.5s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.55,267.68l0,0S125.59,267.69,125.55,267.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.63,267.66h0S125.6,267.64,125.63,267.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.53,267l.09.59a6.39,6.39,0,0,0-3,0A12.83,12.83,0,0,1,128.53,267Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6,272a6.37,6.37,0,0,0-2.59,1c0-.18-.08-.35-.13-.52A12.62,12.62,0,0,1,126.6,272Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.65,272h0S126.64,272,126.65,272Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.69,272s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.91,278h0S128,278,127.91,278Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.84,277.81a6.06,6.06,0,0,0-1.89.2s0,0,0,0a12.46,12.46,0,0,1,1.82-.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.53,267c-.2,4.78-.94,10.6.12,12.91a3.29,3.29,0,0,0,.79.91l0-.51,0-6.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.88,260.09c-.18-1.45,0-2.77-.31-4s-.63-3.07-.63-3.07a.43.43,0,0,0-.4-.39c-.2,0-.18.29-.13.48a20,20,0,0,1,.65,7.39C131.29,260.29,131.63,259.92,131.88,260.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.88,260.09c-.18-1.45,0-2.77-.31-4s-.63-3.07-.63-3.07a.43.43,0,0,0-.4-.39c-.2,0-.18.29-.13.48a20,20,0,0,1,.65,7.39C131.29,260.29,131.63,259.92,131.88,260.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.92,260.06c.25-1.43.76-2.66.87-3.93s.29-3.12.29-3.12a.42.42,0,0,0-.27-.48c-.19-.07-.25.21-.26.42a20.44,20.44,0,0,1-1.52,7.26C132.3,260.09,132.73,259.84,132.92,260.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.92,260.06c.25-1.43.76-2.66.87-3.93s.29-3.12.29-3.12a.42.42,0,0,0-.27-.48c-.19-.07-.25.21-.26.42a20.44,20.44,0,0,1-1.52,7.26C132.3,260.09,132.73,259.84,132.92,260.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,252a.28.28,0,0,0-.24-.22c-.11,0-.14.07-.18.18l0,4.49-.06,3.84a.53.53,0,0,0,.54.05C132.36,260.15,132,252,132,252Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,252a.28.28,0,0,0-.24-.22c-.11,0-.14.07-.18.18l0,4.49-.06,3.84a.53.53,0,0,0,.54.05C132.36,260.15,132,252,132,252Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.86,252a.28.28,0,0,1,.25-.21c.12,0,.14.08.17.19l-.34,4.48-.2,3.84a.53.53,0,0,1-.54,0C132,260.16,132.86,252,132.86,252Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.63 280.75 132.19 280.87 132.02 281.36 129.75 281.25 129.63 280.75",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.82,262.75c-.13,1.88-.23,3.48-.35,5,0,.2,0,.4-.05.6-.26,3.27-.58,6-1.23,9.9l-.05.28c-.06.37-.12.75-.19,1.14a1.77,1.77,0,0,1-.86,1.22,1.65,1.65,0,0,1-.93.22l-.51,0a1.74,1.74,0,0,1-1.67-1.63c-.17-2.77-.3-5-.32-7h0c0-.18,0-.36,0-.53a62,62,0,0,1,.69-9.47l0-.23a2.56,2.56,0,0,1,.1-.48,2.81,2.81,0,0,1,1.63-1.78,2.54,2.54,0,0,1,.47-.14l.27,0h.41a2.25,2.25,0,0,1,.52.08l.19.06A2.82,2.82,0,0,1,134.82,262.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.82,262.75c-.13,1.88-.23,3.48-.35,5,0,.2,0,.4-.05.6-.26,3.27-.58,6-1.23,9.9l-.05.28c-.06.37-.12.75-.19,1.14a1.77,1.77,0,0,1-.86,1.22,1.65,1.65,0,0,1-.93.22l-.51,0a1.74,1.74,0,0,1-1.67-1.63c-.17-2.77-.3-5-.32-7h0c0-.18,0-.36,0-.53a62,62,0,0,1,.69-9.47l0-.23a2.56,2.56,0,0,1,.1-.48,2.81,2.81,0,0,1,1.63-1.78,2.54,2.54,0,0,1,.47-.14l.27,0h.41a2.25,2.25,0,0,1,.52.08l.19.06A2.82,2.82,0,0,1,134.82,262.75Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.47,261.71a12.69,12.69,0,0,1,3.23.9,6.39,6.39,0,0,0-3.36-.19l0-.23A2.56,2.56,0,0,1,129.47,261.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.74,262.62h0S132.74,262.61,132.74,262.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.78,262.64s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.43,267.63h0S131.46,267.66,131.43,267.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.51,267.63h0S131.48,267.61,131.51,267.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.47,267.72c0,.2,0,.4-.05.6a6.23,6.23,0,0,0-2.9-.69A13.25,13.25,0,0,1,134.47,267.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.4,272.08a6.07,6.07,0,0,0-2.74.34c0-.18,0-.36,0-.53A12,12,0,0,1,131.4,272.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45,272.08h0S131.45,272.07,131.45,272.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5,272.08s0,0-.05,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.23,278.25h0S131.26,278.27,131.23,278.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.14,278.5a5.87,5.87,0,0,0-1.87-.26s0,0,0,0a13.09,13.09,0,0,1,1.88,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.57,261.37c-.39,3.51-1,8-.77,9,.08.31.15.92.29,1.47l.73-9.13A2.89,2.89,0,0,0,134.57,261.37Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.38,260.09c-.17-1.45,0-2.77-.3-4s-.63-3.07-.63-3.07a.43.43,0,0,0-.4-.39c-.2,0-.18.29-.13.48a20,20,0,0,1,.65,7.39C136.8,260.29,137.14,259.92,137.38,260.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.38,260.09c-.17-1.45,0-2.77-.3-4s-.63-3.07-.63-3.07a.43.43,0,0,0-.4-.39c-.2,0-.18.29-.13.48a20,20,0,0,1,.65,7.39C136.8,260.29,137.14,259.92,137.38,260.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.43,260.06c.25-1.43.76-2.66.87-3.93s.28-3.12.28-3.12a.41.41,0,0,0-.26-.48c-.19-.07-.26.21-.26.42a20.44,20.44,0,0,1-1.52,7.26C137.81,260.09,138.24,259.84,138.43,260.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.43,260.06c.25-1.43.76-2.66.87-3.93s.28-3.12.28-3.12a.41.41,0,0,0-.26-.48c-.19-.07-.26.21-.26.42a20.44,20.44,0,0,1-1.52,7.26C137.81,260.09,138.24,259.84,138.43,260.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.52,252a.28.28,0,0,0-.24-.22c-.11,0-.14.07-.18.18l0,4.49-.06,3.84a.52.52,0,0,0,.53.05C137.87,260.15,137.52,252,137.52,252Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.52,252a.28.28,0,0,0-.24-.22c-.11,0-.14.07-.18.18l0,4.49-.06,3.84a.52.52,0,0,0,.53.05C137.87,260.15,137.52,252,137.52,252Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.37,252a.28.28,0,0,1,.25-.21c.11,0,.14.08.17.19l-.34,4.48-.2,3.84a.53.53,0,0,1-.54,0,30,30,0,0,1,.29-4.83C138.18,253.68,138.37,252,138.37,252Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.14 280.75 137.7 280.87 137.53 281.36 135.26 281.25 135.14 280.75",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.33,262.75c-.13,1.88-.23,3.48-.35,5,0,.2,0,.4,0,.6-.26,3.27-.58,6-1.23,9.9l0,.28c-.06.37-.12.75-.19,1.14a1.76,1.76,0,0,1-.87,1.22,1.59,1.59,0,0,1-.92.22l-.52,0a1.82,1.82,0,0,1-.91-.3,1.75,1.75,0,0,1-.75-1.33c-.17-2.77-.3-5-.33-7h0v-.53a62,62,0,0,1,.69-9.47,1.6,1.6,0,0,1,0-.23,2.56,2.56,0,0,1,.1-.48,2.81,2.81,0,0,1,1.63-1.78,2.44,2.44,0,0,1,.46-.14l.28,0h.41a2.34,2.34,0,0,1,.52.08l.18.06A2.81,2.81,0,0,1,140.33,262.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.33,262.75c-.13,1.88-.23,3.48-.35,5,0,.2,0,.4,0,.6-.26,3.27-.58,6-1.23,9.9l0,.28c-.06.37-.12.75-.19,1.14a1.76,1.76,0,0,1-.87,1.22,1.59,1.59,0,0,1-.92.22l-.52,0a1.82,1.82,0,0,1-.91-.3,1.75,1.75,0,0,1-.75-1.33c-.17-2.77-.3-5-.33-7h0v-.53a62,62,0,0,1,.69-9.47,1.6,1.6,0,0,1,0-.23,2.56,2.56,0,0,1,.1-.48,2.81,2.81,0,0,1,1.63-1.78,2.44,2.44,0,0,1,.46-.14l.28,0h.41a2.34,2.34,0,0,1,.52.08l.18.06A2.81,2.81,0,0,1,140.33,262.75Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,261.71a12.69,12.69,0,0,1,3.23.9,6.39,6.39,0,0,0-3.36-.19,1.6,1.6,0,0,1,0-.23A2.56,2.56,0,0,1,135,261.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.25,262.62h0S138.25,262.61,138.25,262.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.29,262.64s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.94,267.63h0S137,267.66,136.94,267.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,267.63h0S137,267.61,137,267.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,267.72c0,.2,0,.4,0,.6a6.23,6.23,0,0,0-2.9-.69A13.25,13.25,0,0,1,140,267.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.91,272.08a6.13,6.13,0,0,0-2.75.34v-.53A12,12,0,0,1,136.91,272.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,272.08h0S137,272.07,137,272.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,272.08s0,0,0,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.73,278.25h.05S136.77,278.27,136.73,278.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.65,278.5a5.87,5.87,0,0,0-1.87-.26s0,0,0,0a13.09,13.09,0,0,1,1.88,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,303.65a13,13,0,0,1,6.85,14.43,12.69,12.69,0,0,1-1.1,3.07,12.84,12.84,0,0,1-2.82,3.73h0a13,13,0,1,1-16.59-20.07l.53-.37a13.13,13.13,0,0,1,7-2.2h.56A12.94,12.94,0,0,1,182,303.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.63,328.16c-3,1.86-8,1.16-11.53-.87a15.82,15.82,0,0,1-6.79-9.16,10.44,10.44,0,0,1,2.73-10c.88-.82,2.53-.83,3.72-.68a4.29,4.29,0,0,1,3,1.84c.63-.37,1.67.4,2,1.05a3.39,3.39,0,0,1,.2,2.16,7.11,7.11,0,0,0-.16,2.2c.48-.41,1.2,0,1.56.53a3.24,3.24,0,0,1,.4,1.82,4,4,0,0,0,.29,1.86c.35-.54,1.14-.11,1.5.43a6.22,6.22,0,0,1,.54,1.84,3.86,3.86,0,0,0,3.63,2.73,1.31,1.31,0,0,1,.1,2.15,1.13,1.13,0,0,1,.37,1.53C181.88,328.11,181.12,328.49,180.63,328.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.9,308.4a4.27,4.27,0,0,1,.84.91c.61-.36,1.6.35,2,1a.21.21,0,0,1,0,.06,3.38,3.38,0,0,1,.21,2.16h0a7,7,0,0,0-.16,2.19c.48-.41,1.2,0,1.56.53a2.76,2.76,0,0,1,.39,1.5c0,.1,0,.21,0,.32s0,.47,0,.71a2.66,2.66,0,0,0,.27,1.15c.35-.54,1.14-.11,1.5.43a6.25,6.25,0,0,1,.54,1.83,3.62,3.62,0,0,0,.74,1.38,3.77,3.77,0,0,0,.85.74,3.6,3.6,0,0,0,2,.62,1.31,1.31,0,0,1,.1,2.15,1.13,1.13,0,0,1,.37,1.53c-.31.5-1.07.88-1.56.54-3,1.87-8,1.17-11.53-.86a15.82,15.82,0,0,1-6.79-9.16,10.42,10.42,0,0,1,2.74-10,2.9,2.9,0,0,1,1.53-.67,7.37,7.37,0,0,1,1.93,0h0l.25,0a4.54,4.54,0,0,1,1.08.29A4.4,4.4,0,0,1,170.9,308.4Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.65,321.27a.12.12,0,0,1,0,.1,4.76,4.76,0,0,1-.28.49v-.18a1.71,1.71,0,0,0,.09-.3C187.48,321.32,187.62,321.22,187.65,321.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.92,314.76v0S184.9,314.77,184.92,314.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.23,305.07l0,0h0S172.28,305.06,172.23,305.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184.92,314.76v0S184.9,314.77,184.92,314.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.41,329.06a1.17,1.17,0,0,1-.16-.44,8.51,8.51,0,0,1-.13-2.66,4.59,4.59,0,0,1,1-2.43,6.14,6.14,0,0,0,1.12-1.33c.13-.28.28-.66,0-.86a4.23,4.23,0,0,0-2.43,2.2,10.22,10.22,0,0,0-1.28,4.71,2.62,2.62,0,0,0,1.76.89C173.34,329.09,173.45,329.11,173.41,329.06Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.12,320.09a1.25,1.25,0,0,0-.59.4c-.27.29-.54.57-.82.85-.58.61-1.25,1.16-1.29,2a3.94,3.94,0,0,0-.72,1.5.62.62,0,0,1-.33.48,1.92,1.92,0,0,0,.72,1c.14.1.35.17.48.05a1.8,1.8,0,0,1,0-.8,3.8,3.8,0,0,1,.34-1c.54-1.17,1.12-2.31,1.74-3.43,0,0,0-.1,0-.13s-.07.07,0,0a2.43,2.43,0,0,0,.57-.54.65.65,0,0,0,.23-.34C170.42,320.08,170.26,320.07,170.12,320.09Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.33,326.25a7.39,7.39,0,0,1-1.17,1.33c-.41.42-1,.79-1,1.38a.65.65,0,0,1-.59.55,1.13,1.13,0,0,1-.79-.31,3.57,3.57,0,0,1,1.45-2l.62-.56a4.82,4.82,0,0,1,1.42-1c.16-.06.25.15.25.32S180.42,326.1,180.33,326.25Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.82,320a1.93,1.93,0,0,1,.17-1.43,6,6,0,0,1,.86-1.21l2.32-2.73a1.13,1.13,0,0,0,.36-.72l-.38-.26a6.41,6.41,0,0,1-1.09,1.54c-.58.62-1.27,1.12-1.84,1.74a6,6,0,0,0-1,1.38,1.67,1.67,0,0,0,.34,1.75c0,.05.12.1.19.07a.13.13,0,0,0,.05-.19C162.8,319.85,162.89,320,162.82,320Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.24,314.34c-.08,0-.07-.14,0-.21a6.7,6.7,0,0,1,2.45-2.51,5,5,0,0,0,2.21-2.68c0-.07-.16-.08-.23,0a.34.34,0,0,0-.14.19,5.18,5.18,0,0,1-.46.91c-.59.85-1.72,1.1-2.59,1.67a4,4,0,0,0-1.25,1.3c-.26.44-.58.89-.43,1.38a.38.38,0,0,0,.13.22C162,314.63,162.18,314.4,162.24,314.34Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.27,305.66a6.88,6.88,0,0,0,.58,1.59,5.64,5.64,0,0,1,.39.87,3.75,3.75,0,0,1,.06,1.11,1.79,1.79,0,0,1-.2.86l-.25-.11c0-.14,0-.27-.07-.41a7.69,7.69,0,0,0-.46-1.48,5,5,0,0,1-.68-2.23c0-.13,0-.31-.12-.34C184.74,305.42,185.21,305.42,185.27,305.66Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.64,302.72a.13.13,0,0,1,.1-.13,3.41,3.41,0,0,0,.49.31,5.94,5.94,0,0,1,.9.76,2.66,2.66,0,0,1,.39.43.59.59,0,0,1,.13.47c0,.17-.29.18-.45.12a4,4,0,0,0-2.32-1.83c-.11,0-.29,0-.26.08.14-.05.21-.38.35-.45a.35.35,0,0,1,.28,0C172.43,302.59,172.45,302.64,172.64,302.72Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.87,307.66a7.13,7.13,0,0,0-.9.92c-.3.36-.34.89-.71,1.18a1.16,1.16,0,0,0-.34.36.37.37,0,0,0,.08.46c.13.1.63-.09.62-.25a5.05,5.05,0,0,1,.89-1.14c.39-.26.92-.58,1.43-.89A4.28,4.28,0,0,0,169.87,307.66Zm-3.25-.28a.24.24,0,0,0,0,.09l1.94-.13A7.3,7.3,0,0,0,166.62,307.38Zm4,6.49-2.88,3.86c-.39.52-1,1.66-1.13,1.63a.6.6,0,0,0,.45.59,2.22,2.22,0,0,0,.76-.85c.87-1.77,2.43-3.07,3.82-4.47a31.15,31.15,0,0,1,2.38-2.2h0a3.49,3.49,0,0,0-.2-2.17.21.21,0,0,0,0-.06l-.17.16A24,24,0,0,0,170.6,313.87Zm3.79,4.19a.48.48,0,0,0,.56.08l.86-.47c0-.23,0-.47,0-.7s0-.22,0-.33l-1.47.78A.6.6,0,0,0,174.39,318.06Zm3.15,7.05c.16.16.51.29.68.13a15.21,15.21,0,0,0,1.5-2,3.81,3.81,0,0,1-.85-.75A21.87,21.87,0,0,0,177.54,325.11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.05,303.77c-.07,0-.11.07-.14.13s-.23.27-.26.43a9.48,9.48,0,0,0,1.49,5.68,16.46,16.46,0,0,0-2.32-1.43,11.43,11.43,0,0,0-1.53-.63,4.37,4.37,0,0,0-.16-2.42,7.19,7.19,0,0,0-1.38-2.08c-.24-.27-.61-1.11-1-1a1.18,1.18,0,0,0-.39-.19c-.23-.08-.47-.09-.56,0a.17.17,0,0,0,0,.19,9.71,9.71,0,0,1,.83,1.11c.26.7.7,1.32.95,2a1.53,1.53,0,0,1-.24,1.79,2.38,2.38,0,0,0-.88-.28,1.76,1.76,0,0,1-1.37-.37,19.89,19.89,0,0,0-2.72-2.07c-.34-.27-.59-.2-1-.1.21.17.57.33.8.49h0s.09,0,0,0l0,0s0,.08,0,.11c.51.54,1.11,1.09,1.61,1.63a4.93,4.93,0,0,0-1.62-.24c-.23,0-.35-.14-.54-.26-.36-.24-.93-.66-1.27-.92s-1-.39-1.38-.74a.93.93,0,0,0-.18-.16l-.53.37a.1.1,0,0,0,.08.06,2.61,2.61,0,0,1,1.44.84c.26.25.54.42.79.67a5.6,5.6,0,0,0-3.41.67c-.32-.1-.55.1-.63.42a7.37,7.37,0,0,1,1.93,0h0l1.94-.13a6.85,6.85,0,0,0-.61.45,4.4,4.4,0,0,1,1.06.64c.41-.24.8-.48,1.1-.69a9.22,9.22,0,0,1,3.83.58c-.66.68-1.4,1.36-2.11,2a.21.21,0,0,1,0,.06,3.38,3.38,0,0,1,.21,2.16h0a18.46,18.46,0,0,1,4.42-2.78c2.06.67,3.7,2.37,5.12,4-.64.11-1.27.26-1.89.43a8.39,8.39,0,0,0-3.3-.87,4.07,4.07,0,0,1-.61-.05c-.3,0-.58-.18-.88-.22a.85.85,0,0,0-.82.27.82.82,0,0,0,.65.4c.25,0,.28-.2.52-.14.94.24,1.88.52,2.8.83a.87.87,0,0,0,.55.06,1.12,1.12,0,0,1,.27,0,19.07,19.07,0,0,0-1.95.74c-.83.37-1.64.8-2.44,1.22l-.65.35c0,.1,0,.21,0,.32s0,.47,0,.71a14,14,0,0,1,2.76-1.19c2-.59,4-1.18,6-1.61a17,17,0,0,1,1.85,2.78,3.66,3.66,0,0,0-1.24.35l-2.53,1.07a7.94,7.94,0,0,0-2.06,1.13,6.76,6.76,0,0,0-1.29,1.57c-.14.23-.28.45-.42.69a3.77,3.77,0,0,0,.85.74c.11-.15.22-.3.34-.44a5.68,5.68,0,0,1,1.62-1.43,4.23,4.23,0,0,1,.62-.25l4-1.27a1,1,0,0,0,.72-.5l0-.1a7.52,7.52,0,0,1,.37,2.36,1.58,1.58,0,0,1-.24.39c-.16.17-.36.3-.53.46s-.5.55-.76.81a8.58,8.58,0,0,1-2.38,1.6c.05.16.1.36.27.38a1.17,1.17,0,0,0,.49-.11,5,5,0,0,0,.66-.32h0a7.74,7.74,0,0,0,1.7-1.38,4.16,4.16,0,0,0,.5-.61,23.55,23.55,0,0,0,1.58-3.1,4,4,0,0,0,.14-1.71,5.5,5.5,0,0,0-.28-1.21,5.24,5.24,0,0,0,.12-2.09l-.15-1.61c.1-.16,0-.38-.08-.56-.2-.75-.39-1.51-.59-2.27-.06-.24-.35-.45-.55-.29a19.69,19.69,0,0,1,.56,5.13.57.57,0,0,1,0,.13,15.67,15.67,0,0,0-3.44-4.28,7.9,7.9,0,0,0-.78-2.23,17.9,17.9,0,0,1-1.24-4.71l-.22-.25A.19.19,0,0,0,182.05,303.77Zm2.87,11s0,0,0,0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.71,327.54a13,13,0,0,1-19.13-9.69h0a13,13,0,1,1,25.94-2.21c0,.22,0,.43,0,.65a13.07,13.07,0,0,1-2.17,7c-.1.16-.21.31-.32.46A13,13,0,0,1,209.71,327.54Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.32,312.47c.15-3.5,3.6-7.24,7.28-9a15.82,15.82,0,0,1,11.39-.37,10.41,10.41,0,0,1,6.65,7.93c.18,1.19-.75,2.55-1.55,3.44a4.28,4.28,0,0,1-3.21,1.4c-.06.74-1.28,1.15-2,1.07a3.49,3.49,0,0,1-1.9-1.06,6.91,6.91,0,0,0-1.71-1.39c.06.63-.69,1-1.32,1a3.26,3.26,0,0,1-1.73-.71,4,4,0,0,0-1.69-.82c.24.59-.56,1-1.21,1a6.48,6.48,0,0,1-1.82-.6,3.83,3.83,0,0,0-4.31,1.42,1.31,1.31,0,0,1-1.83-1.14,1.14,1.14,0,0,1-1.47-.57C189.65,313.52,189.77,312.68,190.32,312.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.1,315.72a3.91,3.91,0,0,1-1.22.17c-.06.71-1.2,1.12-1.94,1.07a.16.16,0,0,1-.07,0,3.49,3.49,0,0,1-1.9-1.06h0a6.78,6.78,0,0,0-1.7-1.38c.06.63-.69,1-1.32,1a2.82,2.82,0,0,1-1.46-.53l-.27-.18c-.19-.13-.39-.27-.59-.39a2.81,2.81,0,0,0-1.1-.43c.24.6-.56,1-1.21,1a6.48,6.48,0,0,1-1.82-.6,3.68,3.68,0,0,0-1.55-.18,4.16,4.16,0,0,0-1.09.28,3.67,3.67,0,0,0-1.67,1.32,1.31,1.31,0,0,1-1.83-1.14,1.14,1.14,0,0,1-1.47-.57c-.23-.54-.11-1.38.44-1.59.15-3.5,3.6-7.24,7.28-9a15.82,15.82,0,0,1,11.39-.37,10.41,10.41,0,0,1,6.65,7.93,2.9,2.9,0,0,1-.32,1.65,7.1,7.1,0,0,1-1.07,1.6h0l-.16.18a4.34,4.34,0,0,1-2,1.23Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192,322.16a.1.1,0,0,1-.1,0c-.09-.16-.16-.33-.24-.51l.15.1a1.22,1.22,0,0,0,.2.25S192.05,322.17,192,322.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.89,323.63l0,0S198.9,323.61,198.89,323.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.09,318.72l0,0h0S214.07,318.75,214.09,318.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.89,323.63l0,0S198.9,323.61,198.89,323.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.69,306a1.25,1.25,0,0,1,.46.12,8.67,8.67,0,0,1,2.26,1.41,4.53,4.53,0,0,1,1.4,2.24,6.33,6.33,0,0,0,.46,1.68c.16.26.39.6.68.52a4.2,4.2,0,0,0-.42-3.25,10,10,0,0,0-3.15-3.73,2.55,2.55,0,0,0-1.73.94C193.71,305.94,193.63,306,193.69,306Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.94,308.42a1.15,1.15,0,0,0,0-.71c-.07-.38-.15-.77-.23-1.15-.17-.83-.23-1.69-.91-2.2a3.92,3.92,0,0,0-.81-1.45.6.6,0,0,1-.21-.54,1.88,1.88,0,0,0-1.24,0c-.16.06-.35.19-.31.37a1.69,1.69,0,0,1,.67.42,4,4,0,0,1,.62.84c.65,1.1,1.26,2.23,1.82,3.38,0,0,.06.09.11.08s0-.1,0-.05a2.35,2.35,0,0,0,.12.78.7.7,0,0,0,.14.38C202.78,308.68,202.88,308.55,202.94,308.42Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.06,313.31a8.33,8.33,0,0,1-.43-1.72c-.11-.58-.09-1.26-.55-1.62a.62.62,0,0,1-.12-.79,1.16,1.16,0,0,1,.71-.48,3.63,3.63,0,0,1,.8,2.32l.1.83a4.8,4.8,0,0,1,0,1.73c0,.17-.27.13-.41,0S192.14,313.46,192.06,313.31Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.19,302.49a2,2,0,0,1,1.09,1,6.06,6.06,0,0,1,.5,1.39l.93,3.47a1.18,1.18,0,0,0,.38.71c.07,0,.36-.14.43-.18a6.49,6.49,0,0,1-.65-1.77c-.18-.82-.19-1.68-.37-2.5a6.26,6.26,0,0,0-.59-1.58,1.66,1.66,0,0,0-1.63-.72c-.07,0-.15,0-.17.11a.14.14,0,0,0,.13.16C207.31,302.55,207.13,302.53,207.19,302.49Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.16,305.22c.06-.05.15,0,.19.09a6.68,6.68,0,0,1,.66,3.44,5,5,0,0,0,1,3.34c.08,0,.16-.08.17-.16a.45.45,0,0,0-.08-.22,6.56,6.56,0,0,1-.49-.9c-.36-1,.08-2,.11-3.08a4,4,0,0,0-.36-1.77c-.22-.46-.4-1-.89-1.14a.39.39,0,0,0-.26,0C212.08,304.83,212.13,305.14,212.16,305.22Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.18,329.09a7.77,7.77,0,0,0-1.64-.43,4.21,4.21,0,0,1-.94-.17,3.27,3.27,0,0,1-.94-.58,1.72,1.72,0,0,1-.6-.66l.23-.13.38.17a7.69,7.69,0,0,0,1.48.46,4.94,4.94,0,0,1,2.22.72c.1.08.25.18.35.09C206.67,328.8,206.41,329.19,206.18,329.09Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.79,320.39a.13.13,0,0,1,.05.15,3.65,3.65,0,0,0-.54.23,6.18,6.18,0,0,1-1.14.31,2.8,2.8,0,0,1-.57.08.71.71,0,0,1-.47-.17c-.11-.12,0-.34.16-.44a4,4,0,0,0,2.83-.86c.1-.06.19-.22.08-.26,0,.15.2.39.17.54a.34.34,0,0,1-.18.21C216,320.29,216,320.28,215.79,320.39Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.3,315.3a6.94,6.94,0,0,0-.24-1.27c-.13-.45-.54-.79-.57-1.25a1,1,0,0,0-.11-.49.36.36,0,0,0-.41-.19c-.16,0-.29.57-.15.65a5.38,5.38,0,0,1,.43,1.38c0,.47-.05,1.09-.08,1.68A4.09,4.09,0,0,0,213.3,315.3Zm2.09-2.51a.46.46,0,0,0-.07-.07l-1,1.67A7.84,7.84,0,0,0,215.39,312.79Zm-7.61-.43-1.53-4.57a12.84,12.84,0,0,1-.7-1.85.62.62,0,0,0-.74,0,2.15,2.15,0,0,0,.27,1.11c1,1.72,1.13,3.75,1.5,5.69q.3,1.58.45,3.21h0a3.41,3.41,0,0,0,1.89,1.07H209l0-.22A24.18,24.18,0,0,0,207.78,312.36Zm-5.6.73a.48.48,0,0,0-.39.41c0,.33-.06.65-.1,1,.2.12.39.25.58.39l.28.18c.06-.55.13-1.1.19-1.65A.59.59,0,0,0,202.18,313.09Zm-7.59-1.42c-.22,0-.53.25-.49.48a14.64,14.64,0,0,0,.81,2.39,3.79,3.79,0,0,1,1.1-.28A23.23,23.23,0,0,0,194.59,311.67Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.56,327.53a.21.21,0,0,0,0-.2c-.09-.14-.09-.34-.21-.45a9.52,9.52,0,0,0-5.52-2,15.93,15.93,0,0,0,2.49-1.1,10.7,10.7,0,0,0,1.4-.89,4.47,4.47,0,0,0,2.08,1.25,7.43,7.43,0,0,0,2.49,0c.36,0,1.27.13,1.38-.21a1.3,1.3,0,0,0,.38-.21c.19-.15.34-.33.32-.46s-.06-.1-.15-.13a10.68,10.68,0,0,1-1.38,0c-.72-.18-1.49-.17-2.2-.37s-1.2-.48-1.34-1.21a2.44,2.44,0,0,0,.73-.57,1.75,1.75,0,0,1,1.09-.91,21.26,21.26,0,0,0,3.25-1.06c.41-.12.5-.37.66-.78-.26.09-.6.28-.87.39h0s-.07.05,0,0l0,0s-.07,0-.11,0c-.73.11-1.52.29-2.25.4a4.74,4.74,0,0,0,1.12-1.2c.13-.18.31-.2.52-.29.4-.16,1.07-.39,1.48-.52s.88-.6,1.39-.71a1.55,1.55,0,0,0,.23-.06c0-.22,0-.43,0-.65a.1.1,0,0,0-.09,0,2.59,2.59,0,0,1-1.51.7c-.35.07-.66.2-1,.27a5.55,5.55,0,0,0,1.38-3.19.47.47,0,0,0,0-.75,7.1,7.1,0,0,1-1.07,1.6h0l-1,1.67a4.92,4.92,0,0,0,0-.77,4,4,0,0,1-1.13.51c0,.47,0,.93-.06,1.3a9,9,0,0,1-2.65,2.82c-.19-.93-.32-1.92-.45-2.88a.16.16,0,0,1-.07,0,3.49,3.49,0,0,1-1.9-1.06h0a18.16,18.16,0,0,1-.23,5.21c-1.71,1.31-4,1.69-6.2,1.93.26-.59.51-1.19.72-1.8a8.22,8.22,0,0,0,2.59-2.22,3,3,0,0,1,.39-.47c.22-.22.48-.38.68-.6a.85.85,0,0,0,.25-.83.83.83,0,0,0-.7.31c-.14.2,0,.35-.19.51-.73.63-1.49,1.24-2.27,1.82a1,1,0,0,0-.37.42.68.68,0,0,1-.12.24,19.85,19.85,0,0,0,.5-2c.17-.89.28-1.8.39-2.7,0-.25,0-.49.08-.73l-.27-.18c-.19-.13-.39-.27-.59-.39a14.69,14.69,0,0,1-.59,2.95c-.65,2-1.29,3.93-2.09,5.83a16.92,16.92,0,0,1-3.34-.06,3.68,3.68,0,0,0,.42-1.22c.18-.9.37-1.79.56-2.69a8,8,0,0,0,.25-2.33,6.76,6.76,0,0,0-.56-2c-.11-.25-.21-.49-.33-.74a4.16,4.16,0,0,0-1.09.28,5.34,5.34,0,0,1,.16.53,5.58,5.58,0,0,1,.26,2.14,5.23,5.23,0,0,1-.15.66l-1.23,4a1,1,0,0,0,0,.88.7.7,0,0,1,.06.09,7.4,7.4,0,0,1-2.15-1.05,1.22,1.22,0,0,1-.18-.42,5.2,5.2,0,0,1-.08-.69,10.08,10.08,0,0,0-.24-1.09,8.59,8.59,0,0,1,0-2.86c-.16-.06-.35-.13-.46,0a.94.94,0,0,0-.19.46,4.48,4.48,0,0,0-.11.72h0a7.69,7.69,0,0,0,.17,2.19,5,5,0,0,0,.21.76,24.49,24.49,0,0,0,1.65,3.06,4,4,0,0,0,1.33,1.09,5.75,5.75,0,0,0,1.15.46,5.41,5.41,0,0,0,1.65,1.29l1.41.79c.08.17.33.19.5.25l2.21.81c.23.09.57,0,.55-.29a19.45,19.45,0,0,1-4.53-2.45l-.11-.09a15.64,15.64,0,0,0,5.48-.39,7.72,7.72,0,0,0,2.28.63,17.41,17.41,0,0,1,4.57,1.67l.33-.05A.25.25,0,0,0,209.56,327.53Zm-10.7-3.93s0,0,0,0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.37,325.13c.76-4.49,3.23-8.75,5.47-10.72,2.94-2.88,6.24-3.19,9.63-3.21,2.73-.13,5.19,1.48,7.6,2.87a14.28,14.28,0,0,1-.33,5.12l-17.45,9.12A16.52,16.52,0,0,1,166.37,325.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.56,314.66a5.59,5.59,0,0,1,2.66,2.64,15.16,15.16,0,0,1,7.89-4.2c3.46-.28,7.73,1.21,11,3.18,1.87,1.43,3,1.92,3.86,3.69a12.83,12.83,0,0,1-1.35,2.94L191,321.25A28.7,28.7,0,0,1,190.56,314.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.65,325.41c.13,4.78-3.56,8.89-8.68,10.15a13,13,0,0,1-2.95.4,13.35,13.35,0,0,1-4.23-.54h0c-4.54-1.33-7.85-5-8-9.35-.15-5.65,5.06-10.37,11.64-10.55a13.38,13.38,0,0,1,5.34.93l.53.22a11.25,11.25,0,0,1,4.8,4c.09.13.16.26.24.39A8.93,8.93,0,0,1,215.65,325.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.31,333.71c-2.79-1.34-4.4-5.08-4.28-8.27a11.88,11.88,0,0,1,4.45-8.12,10.75,10.75,0,0,1,9.23-1.87,4,4,0,0,1,2.15,2.3,2.93,2.93,0,0,1-.2,2.74c.58.3.41,1.31,0,1.79a3.25,3.25,0,0,1-1.65,1,6.76,6.76,0,0,0-1.85.71c.54.18.51.83.25,1.27a2.92,2.92,0,0,1-1.3,1,3.68,3.68,0,0,0-1.37.9c.58,0,.58.75.3,1.19a5.23,5.23,0,0,1-1.25,1.07,2.73,2.73,0,0,0-.64,3.53c0,.72-.9,1.13-1.69.88a1,1,0,0,1-1.07.83C195.88,334.55,195.25,334.17,195.31,333.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,319.58a3.14,3.14,0,0,1-.38.91c.56.29.41,1.24.07,1.74a.1.1,0,0,1,0,0,3.25,3.25,0,0,1-1.65,1h0a7,7,0,0,0-1.84.71c.54.18.51.82.25,1.27a2.41,2.41,0,0,1-1,.83l-.26.13-.56.28a2.43,2.43,0,0,0-.81.62c.58,0,.58.75.3,1.19a5.23,5.23,0,0,1-1.25,1.07,2.88,2.88,0,0,0-.78,1,2.63,2.63,0,0,0-.24.86,2.52,2.52,0,0,0,.38,1.64c0,.72-.9,1.13-1.69.88a1,1,0,0,1-1.07.83c-.54,0-1.17-.41-1.11-.87-2.79-1.34-4.4-5.07-4.28-8.27a11.88,11.88,0,0,1,4.45-8.12,10.75,10.75,0,0,1,9.23-1.87,2.63,2.63,0,0,1,1.21.8,5.63,5.63,0,0,1,.86,1.32h0a1.42,1.42,0,0,1,.08.18,2.56,2.56,0,0,1,.23.85A2.93,2.93,0,0,1,207,319.58Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.89,336s0,.05-.08.06l-.51,0,.14-.06a1.36,1.36,0,0,0,.29-.06C203.78,335.86,203.92,335.91,203.89,336Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,331.63h0S208,331.61,208,331.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.3,319.24a.09.09,0,0,1,0-.05h0S210.32,319.27,210.3,319.24Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208,331.63h0S208,331.61,208,331.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.46,329.08a.86.86,0,0,1,.29-.28,8,8,0,0,1,2.09-1.09,4.9,4.9,0,0,1,2.4-.2,6.46,6.46,0,0,0,1.56.27c.28,0,.65-.06.71-.29a4.2,4.2,0,0,0-2.82-.85,10.72,10.72,0,0,0-4.35.89,1.76,1.76,0,0,0,0,1.55S191.44,329.12,191.46,329.08Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.27,323.44a1.07,1.07,0,0,0-.58-.26l-1-.24a3.47,3.47,0,0,0-2.17-.14,4.32,4.32,0,0,0-1.52.06.65.65,0,0,1-.53,0,1.35,1.35,0,0,0-.5.87c0,.14,0,.31.16.35a1.64,1.64,0,0,1,.63-.32,3.68,3.68,0,0,1,.94-.14q1.76-.1,3.51-.09s.1,0,.11-.05-.09,0,0,0a2.83,2.83,0,0,0,.68.19.78.78,0,0,0,.37,0C197.41,323.63,197.35,323.52,197.27,323.44Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.71,332.78a7.64,7.64,0,0,1-1.57-.3c-.52-.12-1.07-.38-1.56-.18a.62.62,0,0,1-.69-.2.77.77,0,0,1-.09-.66,3.73,3.73,0,0,1,2.22.25l.72.22a4.69,4.69,0,0,1,1.41.6c.13.09,0,.23-.14.29S196.87,332.79,196.71,332.78Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.22,318.36a2,2,0,0,1,1.23-.42,6,6,0,0,1,1.34.14l3.21.57a1.32,1.32,0,0,0,.74,0c0-.06,0-.3,0-.37a7,7,0,0,1-1.71-.16c-.74-.17-1.44-.46-2.19-.62a6.57,6.57,0,0,0-1.53-.15,1.51,1.51,0,0,0-1.27.9s0,.12,0,.15a.14.14,0,0,0,.18,0C194.31,318.3,194.23,318.42,194.22,318.36Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.51,315.84c0-.06.08-.1.16-.1a6.74,6.74,0,0,1,3.07.74,5.13,5.13,0,0,0,3.11.51c.05,0,0-.14-.06-.17a.37.37,0,0,0-.21,0,7.38,7.38,0,0,1-.94,0,7.81,7.81,0,0,1-2.46-1.16,4.21,4.21,0,0,0-1.59-.37,1.9,1.9,0,0,0-1.29.22.32.32,0,0,0-.13.18C198.16,315.76,198.43,315.83,198.51,315.84Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.45,328.44a6.17,6.17,0,0,0-1,1,4.22,4.22,0,0,1-.53.59,3.43,3.43,0,0,1-.87.46,1.76,1.76,0,0,1-.78.19c0-.06,0-.15,0-.21l.29-.21a6.44,6.44,0,0,0,1-.87,4.44,4.44,0,0,1,1.51-1.31c.11,0,.25-.11.21-.21C215.42,328,215.62,328.31,215.45,328.44Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.37,318.63a.14.14,0,0,1,.14,0,3.57,3.57,0,0,0,0,.46,3.66,3.66,0,0,1-.22.91,1.68,1.68,0,0,1-.17.42.53.53,0,0,1-.33.27c-.15,0-.27-.13-.29-.26a2.8,2.8,0,0,0,.47-2.29c0-.09-.1-.21-.17-.15.1.08.4,0,.51.08s.08.12.09.2S212.35,318.48,212.37,318.63Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.19,318.59a8.11,8.11,0,0,0-1.13-.28c-.42-.07-.87.1-1.26,0a1.13,1.13,0,0,0-.44-.1c-.15,0-.31.09-.33.22s.34.41.47.34a5,5,0,0,1,1.3.19c.38.16.86.41,1.33.64A2.65,2.65,0,0,0,207.19,318.59ZM206,316.24l-.08,0,.94,1.29A5,5,0,0,0,206,316.24Zm-3.51,5.18-4.36-.53a13.16,13.16,0,0,1-1.8-.16.45.45,0,0,0-.28.53,2.31,2.31,0,0,0,1,.2,19,19,0,0,1,5.26,1c.93.23,1.88.5,2.79.82h0a3.31,3.31,0,0,0,1.65-1s0,0,0,0l-.19-.06A27,27,0,0,0,202.5,321.42Zm-1.75,4.19a.36.36,0,0,0,.18.42l.75.42.56-.28.26-.13-1.26-.72A.58.58,0,0,0,200.75,325.61Zm-4.32,4.82c-.06.17,0,.47.18.52a15.58,15.58,0,0,0,2.29.27,3,3,0,0,1,.23-.87A24.35,24.35,0,0,0,196.43,330.43Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.58,325.52c0-.06-.1-.06-.17-.06s-.31-.06-.45,0a8.43,8.43,0,0,0-3.94,3.17,11,11,0,0,0,.15-2.13,7.1,7.1,0,0,0-.15-1.3,4.15,4.15,0,0,0,1.89-1,5.56,5.56,0,0,0,1.07-1.73c.12-.26.64-.84.41-1a1,1,0,0,0,0-.34c0-.19-.13-.36-.24-.39a.19.19,0,0,0-.16.06,10.42,10.42,0,0,1-.54,1c-.45.44-.76,1-1.22,1.42a1.56,1.56,0,0,1-1.55.51,1.61,1.61,0,0,0-.16-.72,1.22,1.22,0,0,1-.28-1.08,14.06,14.06,0,0,0,.49-2.65c.08-.34-.09-.49-.36-.74,0,.21,0,.52,0,.74h0s0,.08,0,.05a.09.09,0,0,1,0-.05s-.06,0-.08.07c-.22.55-.4,1.17-.61,1.72a3.4,3.4,0,0,0-.51-1.21c-.1-.15,0-.29,0-.47,0-.34.13-.88.19-1.22s-.12-.83,0-1.23c0-.05,0-.12,0-.18l-.53-.22a.06.06,0,0,0,0,.07,1.76,1.76,0,0,1-.06,1.31c-.08.27-.11.53-.19.8a4.51,4.51,0,0,0-2-2.1c-.05-.26-.32-.34-.6-.28a5.63,5.63,0,0,1,.86,1.32h0l.94,1.29a4.91,4.91,0,0,0-.63-.26,2.93,2.93,0,0,1-.05,1c.37.18.73.36,1,.49a6.65,6.65,0,0,1,1.19,2.86c-.84-.2-1.71-.45-2.53-.7a.1.1,0,0,1,0,0,3.25,3.25,0,0,1-1.65,1h0a17.06,17.06,0,0,1,4.14,2c.36,1.66-.31,3.43-1,5a15.74,15.74,0,0,0-1.17-1.14,5.82,5.82,0,0,0-.72-2.6,3.09,3.09,0,0,1-.23-.44c-.08-.23-.1-.47-.2-.69a.72.72,0,0,0-.57-.46.53.53,0,0,0,0,.59c.1.18.28.13.34.31.21.74.39,1.49.53,2.24a.74.74,0,0,0,.19.41.73.73,0,0,1,.14.16,17.07,17.07,0,0,0-1.43-1.06c-.66-.43-1.35-.82-2-1.22l-.56-.32-.26.13-.56.28a13.05,13.05,0,0,1,2.15,1.45c1.33,1.15,2.66,2.29,3.88,3.52a14.24,14.24,0,0,1-1.44,2.32,3.06,3.06,0,0,0-.83-.72l-2-1.34a7.83,7.83,0,0,0-1.79-1,7,7,0,0,0-1.83-.29c-.24,0-.49,0-.73,0a2.63,2.63,0,0,0-.24.86l.5.07a5.64,5.64,0,0,1,1.85.58,2.64,2.64,0,0,1,.47.33l2.75,2.27a1,1,0,0,0,.72.32h.1a7,7,0,0,1-1.75,1.14,1.5,1.5,0,0,1-.42,0c-.2-.05-.39-.13-.59-.2s-.66-.13-1-.21a8.31,8.31,0,0,1-2.31-1c-.11.1-.25.21-.19.33a.86.86,0,0,0,.3.3,4.21,4.21,0,0,0,.55.33h0a7.25,7.25,0,0,0,1.85.65,4.21,4.21,0,0,0,.71.12,26.66,26.66,0,0,0,3.18-.07,4,4,0,0,0,1.44-.56,4.49,4.49,0,0,0,.85-.64,5.26,5.26,0,0,0,1.74-.7l1.24-.71c.17,0,.28-.17.41-.27l1.58-1.26c.17-.13.21-.41,0-.49a18.88,18.88,0,0,1-3.89,2.32l-.11,0a11.5,11.5,0,0,0,2-4,6.83,6.83,0,0,0,1.46-1.38,15.49,15.49,0,0,1,3.26-2.62,2.6,2.6,0,0,0,.1-.25A.09.09,0,0,0,215.58,325.52Zm-7.65,6.12s0,0,0,0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,318.69a17.55,17.55,0,0,1,2,7.49,26.74,26.74,0,0,1-1.36,7.16,12.89,12.89,0,0,1-2.3-2.56v-9.53A17.09,17.09,0,0,1,194,318.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.65,322.68a13.86,13.86,0,0,0,6.46,14.58,12.42,12.42,0,0,0,2.86,1.19,11.46,11.46,0,0,0,4.33.32h0a11.75,11.75,0,0,0,10-9.67c1.38-6.94-2.79-14-9.31-15.77a11.21,11.21,0,0,0-5.54-.12l-.57.16a11.3,11.3,0,0,0-5.66,3.8c-.11.13-.22.27-.32.41A12.69,12.69,0,0,0,169.65,322.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.15,337.71c3.07-1,5.49-5.23,6.06-9.2a17.06,17.06,0,0,0-2.68-11.08c-2-2.95-5.48-4.85-8.8-4.49-1.1.13-2.06,1.35-2.64,2.34a4.46,4.46,0,0,0-.4,3.44c-.64.23-.69,1.51-.42,2.2a3.53,3.53,0,0,0,1.45,1.56,7.15,7.15,0,0,1,1.68,1.32c-.58.09-.69.9-.52,1.51a3.37,3.37,0,0,0,1.09,1.5,4.15,4.15,0,0,1,1.17,1.43c-.59-.09-.74.79-.56,1.4a6.31,6.31,0,0,0,1,1.61,4,4,0,0,1-.12,4.51,1.32,1.32,0,0,0,1.49,1.49,1.18,1.18,0,0,0,.89,1.28C187.39,338.61,188.11,338.29,188.15,337.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.52,317.5a4.11,4.11,0,0,0,.17,1.21c-.62.23-.68,1.44-.44,2.14a.25.25,0,0,0,0,.07,3.53,3.53,0,0,0,1.45,1.56h0a7.26,7.26,0,0,1,1.67,1.31c-.57.09-.69.9-.52,1.51a2.92,2.92,0,0,0,.85,1.28l.24.22.49.47a3,3,0,0,1,.68,1c-.59-.09-.74.78-.56,1.4a6.31,6.31,0,0,0,1,1.61,4.19,4.19,0,0,1,.61,2.58,3.65,3.65,0,0,1-.73,1.93,1.32,1.32,0,0,0,1.49,1.49,1.18,1.18,0,0,0,.89,1.28c.54.08,1.26-.24,1.3-.82,3.07-1,5.49-5.23,6.06-9.2a17.06,17.06,0,0,0-2.68-11.08c-2-2.95-5.48-4.85-8.8-4.49a2.66,2.66,0,0,0-1.38.71,7,7,0,0,0-1.14,1.42h0a1.37,1.37,0,0,0-.13.2,4,4,0,0,0-.41,1A4.13,4.13,0,0,0,179.52,317.5Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.1,338.46a.18.18,0,0,0,.06.09l.52.1a1.42,1.42,0,0,1-.13-.12.84.84,0,0,1-.27-.13C179.23,338.37,179.08,338.4,179.1,338.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,332.16l0,0S176,332.15,176,332.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.33,316.31s0,0,0-.06h0S176.31,316.34,176.33,316.31Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176,332.16l0,0S176,332.15,176,332.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,332.9a.93.93,0,0,0-.23-.41,8.45,8.45,0,0,0-1.84-1.84,4.22,4.22,0,0,0-2.36-.81,5.1,5.1,0,0,1-1.61,0c-.28-.08-.64-.22-.64-.53a3.61,3.61,0,0,1,3-.38,9.63,9.63,0,0,1,4.15,2.13,2.6,2.6,0,0,1-.38,1.9C193.06,332.86,193,333,193,332.9Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.42,324.56a1,1,0,0,1,.63-.18l1.09-.05a2.91,2.91,0,0,1,2.19.34,3.65,3.65,0,0,1,1.5.43.53.53,0,0,0,.54.07,2,2,0,0,1,.31,1.2c0,.17-.08.38-.24.39a1.92,1.92,0,0,0-.55-.55,3.84,3.84,0,0,0-.91-.39c-1.15-.36-2.32-.67-3.49-.94,0,0-.09,0-.09-.08s.09,0,0,0a2.15,2.15,0,0,1-.72.07.55.55,0,0,1-.38-.05C188.23,324.77,188.32,324.65,188.42,324.56Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,336.24a6.43,6.43,0,0,0,1.64,0c.54,0,1.14-.22,1.58.15a.56.56,0,0,0,.74-.08,1.17,1.17,0,0,0,.23-.8,3.13,3.13,0,0,0-2.26-.21l-.77.1a4,4,0,0,0-1.54.41c-.14.08,0,.28.08.39S186.79,336.21,187,336.24Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.57,319a2,2,0,0,0-1.14-.81,4.87,4.87,0,0,0-1.37-.14l-3.32-.06a1,1,0,0,1-.73-.19c0-.08,0-.39,0-.46a6,6,0,0,0,1.74.2c.78,0,1.54-.23,2.32-.25a5.13,5.13,0,0,1,1.56.18,1.72,1.72,0,0,1,1.07,1.4c0,.07,0,.16-.05.19s-.15,0-.18-.08S192.55,319.09,192.57,319Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.83,314.89c0-.07-.06-.14-.13-.17a5.85,5.85,0,0,0-3.23.2,4.36,4.36,0,0,1-3.22-.1c0-.07,0-.17.1-.2a.42.42,0,0,1,.22,0,5.12,5.12,0,0,0,.93.25c1,.11,1.79-.57,2.7-.85a3.5,3.5,0,0,1,1.67-.08c.47.09,1,.15,1.25.58a.41.41,0,0,1,.08.24C189.2,314.87,188.91,314.89,188.83,314.89Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.2,326.46a7.88,7.88,0,0,1,.82,1.48,5,5,0,0,0,.39.85,3.51,3.51,0,0,0,.77.77,1.63,1.63,0,0,0,.74.42,2.27,2.27,0,0,0,.06-.25l-.25-.33a8.34,8.34,0,0,1-.8-1.31,5.42,5.42,0,0,0-1.22-2c-.1-.08-.23-.2-.17-.31C169.33,325.91,169.06,326.26,169.2,326.46Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.4,315.07a.12.12,0,0,0-.15,0,5.23,5.23,0,0,1-.06.57,6.65,6.65,0,0,0,0,1.18,3.75,3.75,0,0,0,.09.57.65.65,0,0,0,.27.41c.14.08.3-.11.35-.26a4.19,4.19,0,0,1,0-2.94c0-.11.14-.23.2-.14-.11.07-.4-.09-.52,0s-.11.14-.14.23S174.46,314.88,174.4,315.07Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.42,317.46c.52-.18,1.06-.37,1.47-.49a4.67,4.67,0,0,1,1.34.07c.12.12.54-.13.55-.3a.39.39,0,0,0-.29-.35.9.9,0,0,0-.46,0c-.42.08-.83-.23-1.26-.25a5.86,5.86,0,0,0-1.19.08A4.49,4.49,0,0,0,179.42,317.46Zm.7-2.43,1.22-1.37-.08-.05A6.65,6.65,0,0,0,180.12,315Zm-.76,5.75-.21,0a.14.14,0,0,1,0,.07,3.53,3.53,0,0,0,1.45,1.56h0c1-.17,2-.28,3-.35,1.82-.11,3.67-.44,5.45.07a1.87,1.87,0,0,0,1,0,.66.66,0,0,0-.17-.73,9.59,9.59,0,0,1-1.83-.22l-4.46-.36A21.14,21.14,0,0,0,179.36,320.78Zm4.69,5.18-1.41.59.23.22.5.47.84-.34a.45.45,0,0,0,.26-.47A.6.6,0,0,0,184.05,326Zm1,6.71a4.65,4.65,0,0,1,.05,1.12,12.37,12.37,0,0,0,2.33.2c.21,0,.32-.36.3-.59A19.7,19.7,0,0,0,185.06,332.67Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.69,323c0,.16,0,.18,0,.33a19.07,19.07,0,0,1,2.69,4,8,8,0,0,0,1.16,2.06,16.8,16.8,0,0,0,1.1,5.37l-.11-.08a21,21,0,0,1-3.38-3.77c-.22,0-.25.39-.1.6.43.64.86,1.29,1.3,1.93.1.15.18.39.35.42l1.08,1.17a5.34,5.34,0,0,0,1.58,1.28,5.75,5.75,0,0,0,.71,1,4,4,0,0,0,1.32,1,21.33,21.33,0,0,0,3.15.85,4.58,4.58,0,0,0,.74,0,6.67,6.67,0,0,0,2-.37h0a4.78,4.78,0,0,0,.61-.28,1,1,0,0,0,.37-.3c.09-.13,0-.3-.12-.45a7.3,7.3,0,0,1-2.53.74c-.34,0-.69,0-1,0s-.42.09-.64.1a1.2,1.2,0,0,1-.42-.08,7.25,7.25,0,0,1-1.49-1.82l.09,0a.89.89,0,0,0,.78-.22l3.24-2.16a4.1,4.1,0,0,1,.54-.3,4.86,4.86,0,0,1,2-.27,4.41,4.41,0,0,1,.52,0,3.82,3.82,0,0,0,0-1.12c-.24-.06-.49-.1-.74-.14a5.66,5.66,0,0,0-1.88-.06,6.71,6.71,0,0,0-2,.8l-2.24,1.2a3.06,3.06,0,0,0-1,.69,18.14,18.14,0,0,1-.94-3.2c1.48-1.23,3.06-2.33,4.63-3.43a13.12,13.12,0,0,1,2.46-1.29l-.49-.47-.24-.22-.62.26c-.78.32-1.55.64-2.3,1a17.22,17.22,0,0,0-1.66,1,1,1,0,0,1,.17-.18.84.84,0,0,0,.28-.46c.31-.89.65-1.76,1-2.63.09-.22.26-.11.41-.3a.83.83,0,0,0,.08-.75.76.76,0,0,0-.67.44c-.14.25-.21.54-.35.8a3.12,3.12,0,0,1-.31.49,7.91,7.91,0,0,0-1.29,3c-.49.36-1,.73-1.41,1.13-.36-2.13-.64-4.48.07-6.45a15.48,15.48,0,0,1,4.58-1.49h0a3.53,3.53,0,0,1-1.45-1.56.25.25,0,0,1,0-.07c-.88.11-1.8.21-2.68.26a8.69,8.69,0,0,1,1.81-3.24l1.14-.37a4.13,4.13,0,0,1,.15-1.22,4,4,0,0,0-.68.17l1.22-1.37h0a7,7,0,0,1,1.14-1.42.42.42,0,0,0-.66.21,4.87,4.87,0,0,0-2.47,2.11c0-.36,0-.68,0-1a2.68,2.68,0,0,1,.23-1.63.09.09,0,0,0,0-.1l-.57.16a1.77,1.77,0,0,0,0,.23,13.41,13.41,0,0,1-.26,1.52c0,.43,0,1.13-.08,1.55,0,.23,0,.41-.12.57a5,5,0,0,0-.76,1.38c-.1-.73-.15-1.54-.25-2.27,0,0,0-.09,0-.1s0,0,0,.06,0-.07,0-.06h0c0-.28.1-.66.11-.93-.32.26-.52.39-.52.83a22.51,22.51,0,0,0-.08,3.38,1.77,1.77,0,0,1-.52,1.28,2.33,2.33,0,0,0-.31.85c-.69,0-1.08-.35-1.44-1s-.55-1.39-.91-2c-.15-.28-.21-1-.32-1.34,0-.09-.1-.12-.15-.11s-.24.19-.32.41a1.1,1.1,0,0,0-.09.42c-.27.19.12,1,.18,1.38a8,8,0,0,0,.69,2.4c.46.85,1.63,1.84,1.66,1.7a12,12,0,0,0-.43,1.56,17.88,17.88,0,0,0-.31,2.67,10.11,10.11,0,0,0-3.24-4.84c-.14-.08-.32,0-.46-.08s-.14,0-.18,0S169.68,322.9,169.69,323Zm6.29,9.21s0,0,0,0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.35,
    y: 260.39,
    width: 4.51,
    height: 19.84,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.35,
    y: 260.39,
    width: 4.51,
    height: 19.84,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.67,
    y: 260.39,
    width: 4.51,
    height: 19.84,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.67,
    y: 260.39,
    width: 4.51,
    height: 19.84,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.53,
    y: 273.65,
    width: 25.82,
    height: 5.61,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.53,
    y: 273.65,
    width: 25.82,
    height: 5.61,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.53,
    y: 264.84,
    width: 25.82,
    height: 5.61,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.53,
    y: 264.84,
    width: 25.82,
    height: 5.61,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.53,
    y: 280.29,
    width: 25.34,
    height: 9.96,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.53,
    y: 280.29,
    width: 25.34,
    height: 9.96,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 79.31,
    y: 343.11,
    width: 25.16,
    height: 70.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.31,
    y: 343.11,
    width: 25.16,
    height: 70.02,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,306.19a4.3,4.3,0,0,1-1.76-4.92,6.87,6.87,0,0,1,3.83-3.78,2.25,2.25,0,0,1,1-.25.89.89,0,0,1,.83.54,5.27,5.27,0,0,1,5.62-3,5.18,5.18,0,0,1,4.3,4.67,4.25,4.25,0,0,1,3.6.71,4,4,0,0,1,1.7,3.15,4.65,4.65,0,0,1,3.31,3.45c1.14,7.7-6.86,9.45-10.18,8.46a8.27,8.27,0,0,1-7.26,1.15C143.79,315.9,139.67,313.86,140,306.19Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,306.19a4.3,4.3,0,0,1-1.76-4.92,6.87,6.87,0,0,1,3.83-3.78,2.25,2.25,0,0,1,1-.25.89.89,0,0,1,.83.54,5.27,5.27,0,0,1,5.62-3,5.18,5.18,0,0,1,4.3,4.67,4.25,4.25,0,0,1,3.6.71,4,4,0,0,1,1.7,3.15,4.65,4.65,0,0,1,3.31,3.45c1.14,7.7-6.86,9.45-10.18,8.46a8.27,8.27,0,0,1-7.26,1.15C143.79,315.9,139.67,313.86,140,306.19Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.73,313a1.67,1.67,0,0,0,.38-2.33,1.55,1.55,0,0,0-.35-.37l.06,0a2.36,2.36,0,0,0-1.6-4.27,2.36,2.36,0,0,0-3.73-1.68,2.39,2.39,0,0,0-.62.65,1.67,1.67,0,0,0-2.66,1.28,1.67,1.67,0,0,0-2,2.28,2.45,2.45,0,0,0,2.77,3.23,1.67,1.67,0,0,0,2.31,1.69,2,2,0,0,0,.29.58,2.14,2.14,0,0,0,3.83-.75A1.64,1.64,0,0,0,158.73,313Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.14,314.71c2-1.86-.09-3.7-.09-3.7.28-2.78-1.88-2.42-1.88-2.42-1-2-2.54-.18-2.54-.18l-2,.3-1.27,1.81.13.21a2.44,2.44,0,0,0,2.46,1,1.67,1.67,0,0,0,2.31,1.69,2,2,0,0,0,.29.58A2.14,2.14,0,0,0,156.14,314.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.84,311.2a2.09,2.09,0,0,0-.13-3,2.12,2.12,0,0,0-1.12-.53,2.92,2.92,0,0,0-.93-2.52,2.85,2.85,0,0,0-1.39-.71,2.94,2.94,0,0,0-5.06-2.57,2.74,2.74,0,0,0-.59,1,2.09,2.09,0,0,0-2.41.48,2.05,2.05,0,0,0-.52,1.76,2.1,2.1,0,0,0-1.59,3.63,2.24,2.24,0,0,0,.69.42,3.06,3.06,0,0,0,4.62,2.81l.1.09a2.07,2.07,0,0,0,2.24.38l.13.13a2.09,2.09,0,0,0,3.42-.95A2.09,2.09,0,0,0,154.84,311.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.84,311.2a2.09,2.09,0,0,0-.13-3,2.12,2.12,0,0,0-1.12-.53,2.92,2.92,0,0,0-.93-2.52,2.85,2.85,0,0,0-1.39-.71,2.94,2.94,0,0,0-5.06-2.57,2.74,2.74,0,0,0-.59,1,2.09,2.09,0,0,0-2.41.48,2.05,2.05,0,0,0-.52,1.76,2.1,2.1,0,0,0-1.59,3.63,2.24,2.24,0,0,0,.69.42,3.06,3.06,0,0,0,4.62,2.81l.1.09a2.07,2.07,0,0,0,2.24.38l.13.13a2.09,2.09,0,0,0,3.42-.95A2.09,2.09,0,0,0,154.84,311.2Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.74,309s-.14-1.89-1.6-2.26c-1.95-.49-3.35,2.15-3.35,2.15s-2.63-1.4-3.85-.16a2.36,2.36,0,0,0-.17,2.85,3.06,3.06,0,0,0,3.64.38l.1.09a2.07,2.07,0,0,0,2.24.38l.13.13a2.09,2.09,0,0,0,3.42-.95,2.09,2.09,0,0,0,2.54-.42C156.09,308.42,151.74,309,151.74,309Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.22,309.67s3.29,3.93-.36,11.67c0,0,1.46,4.66,6.65,2.07,0,0-.2-8.14,6.81-10.46a1.47,1.47,0,0,0-.81-1.31s-3.09,2.67-4.06,2.11,2.4-3.1,2.4-3.1-.88-1.26-1.82-1.08c0,0-1.42,2.72-2.73,2.45s-.48-3.18-.48-3.18a1.77,1.77,0,0,0-1.85,0s.22,3-.44,3S145,309,145,309A1.75,1.75,0,0,0,143.22,309.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.22,309.67s3.29,3.93-.36,11.67c0,0,1.46,4.66,6.65,2.07,0,0-.2-8.14,6.81-10.46a1.47,1.47,0,0,0-.81-1.31s-3.09,2.67-4.06,2.11,2.4-3.1,2.4-3.1-.88-1.26-1.82-1.08c0,0-1.42,2.72-2.73,2.45s-.48-3.18-.48-3.18a1.77,1.77,0,0,0-1.85,0s.22,3-.44,3S145,309,145,309A1.75,1.75,0,0,0,143.22,309.67Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.51,323.41c-3-4.55-6.65-2.07-6.65-2.07S144.32,326,149.51,323.41Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.92,319.54s2-4.79,1.23-6.53S146.76,316.34,145.92,319.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,318.58s1.89-4.72,2.72-4.33S149.78,315.61,148,318.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,315.65s.57-3.1,1.11-2.92S148,315.65,148,315.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.55,319.94c0-1.85-1.88,1.21-2.23-.31-.21-.89-1.11-.38-1.82.19-.18.49-.39,1-.64,1.52,0,0,1.46,4.66,6.65,2.07a12.55,12.55,0,0,1,2.93-8h0C150.13,317.21,147.6,321.79,147.55,319.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.66,298.28a4.45,4.45,0,0,1,3.38,3.85c3.06,1.38,4.13,4,2.58,8.12a8.4,8.4,0,0,1-4,4.52,14.26,14.26,0,0,1-1-1.16l-2.38-14A6,6,0,0,1,140.66,298.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.63,305.82a4.29,4.29,0,0,1-1.76-4.92,6.9,6.9,0,0,1,3.83-3.78,2.47,2.47,0,0,1,1-.25.89.89,0,0,1,.82.55,5.28,5.28,0,0,1,5.63-3.06,5.19,5.19,0,0,1,4.29,4.67,4.26,4.26,0,0,1,3.6.72,4,4,0,0,1,1.7,3.15,4.64,4.64,0,0,1,3.31,3.44c1.14,7.71-6.86,9.45-10.18,8.46a8.21,8.21,0,0,1-7.26,1.15C127.41,315.53,123.29,313.49,123.63,305.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.63,305.82a4.29,4.29,0,0,1-1.76-4.92,6.9,6.9,0,0,1,3.83-3.78,2.47,2.47,0,0,1,1-.25.89.89,0,0,1,.82.55,5.28,5.28,0,0,1,5.63-3.06,5.19,5.19,0,0,1,4.29,4.67,4.26,4.26,0,0,1,3.6.72,4,4,0,0,1,1.7,3.15,4.64,4.64,0,0,1,3.31,3.44c1.14,7.71-6.86,9.45-10.18,8.46a8.21,8.21,0,0,1-7.26,1.15C127.41,315.53,123.29,313.49,123.63,305.82Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.35,312.6a1.68,1.68,0,0,0,.38-2.34,1.71,1.71,0,0,0-.35-.36l.06,0a2.36,2.36,0,0,0-1.6-4.27,2.37,2.37,0,0,0-3.73-1.69,2.43,2.43,0,0,0-.62.66,1.68,1.68,0,0,0-2,0,1.7,1.7,0,0,0-.69,1.3,1.67,1.67,0,0,0-2,2.27,2.46,2.46,0,0,0,2.77,3.24A1.67,1.67,0,0,0,136.9,313a2.1,2.1,0,0,0,.29.58,2.15,2.15,0,0,0,3,.49,2.13,2.13,0,0,0,.83-1.24A1.68,1.68,0,0,0,142.35,312.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.76,314.35c2-1.86-.09-3.71-.09-3.71.28-2.77-1.88-2.41-1.88-2.41-1-2.06-2.54-.18-2.54-.18l-2,.29L132,310.16l.14.21a2.45,2.45,0,0,0,2.45,1A1.67,1.67,0,0,0,136.9,313a2.1,2.1,0,0,0,.29.58A2.17,2.17,0,0,0,139.76,314.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.46,310.83a2.09,2.09,0,0,0-.12-2.95,2.12,2.12,0,0,0-1.12-.53,3,3,0,0,0-.94-2.52,2.87,2.87,0,0,0-1.39-.72,2.95,2.95,0,0,0-5.65-1.61,2.11,2.11,0,0,0-2.41.49,2,2,0,0,0-.52,1.76,2.09,2.09,0,0,0-1.59,3.62,2.07,2.07,0,0,0,.69.42,3.07,3.07,0,0,0,4.63,2.82l.09.09a2.11,2.11,0,0,0,2.24.38,1.59,1.59,0,0,0,.13.13,2.09,2.09,0,0,0,2.95-.13,2,2,0,0,0,.47-.83A2.08,2.08,0,0,0,138.46,310.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.46,310.83a2.09,2.09,0,0,0-.12-2.95,2.12,2.12,0,0,0-1.12-.53,3,3,0,0,0-.94-2.52,2.87,2.87,0,0,0-1.39-.72,2.95,2.95,0,0,0-5.65-1.61,2.11,2.11,0,0,0-2.41.49,2,2,0,0,0-.52,1.76,2.09,2.09,0,0,0-1.59,3.62,2.07,2.07,0,0,0,.69.42,3.07,3.07,0,0,0,4.63,2.82l.09.09a2.11,2.11,0,0,0,2.24.38,1.59,1.59,0,0,0,.13.13,2.09,2.09,0,0,0,2.95-.13,2,2,0,0,0,.47-.83A2.08,2.08,0,0,0,138.46,310.83Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.36,308.64s-.14-1.89-1.59-2.25c-2-.49-3.36,2.14-3.36,2.14s-2.63-1.4-3.85-.15a2.38,2.38,0,0,0-.17,2.85,3.09,3.09,0,0,0,3.65.38l.09.09a2.11,2.11,0,0,0,2.24.38,1.59,1.59,0,0,0,.13.13,2.09,2.09,0,0,0,2.95-.13,2,2,0,0,0,.47-.83,2.08,2.08,0,0,0,2.54-.42C139.72,308.05,135.36,308.64,135.36,308.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.84,309.31s3.29,3.92-.36,11.66c0,0,1.47,4.66,6.65,2.07,0,0-.2-8.13,6.81-10.45a1.47,1.47,0,0,0-.81-1.31s-3.09,2.66-4.06,2.11,2.4-3.1,2.4-3.1-.88-1.27-1.82-1.09c0,0-1.42,2.73-2.73,2.46s-.48-3.18-.48-3.18a1.77,1.77,0,0,0-1.85,0s.22,3-.44,3-1.51-2.9-1.51-2.9A1.77,1.77,0,0,0,126.84,309.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.84,309.31s3.29,3.92-.36,11.66c0,0,1.47,4.66,6.65,2.07,0,0-.2-8.13,6.81-10.45a1.47,1.47,0,0,0-.81-1.31s-3.09,2.66-4.06,2.11,2.4-3.1,2.4-3.1-.88-1.27-1.82-1.09c0,0-1.42,2.73-2.73,2.46s-.48-3.18-.48-3.18a1.77,1.77,0,0,0-1.85,0s.22,3-.44,3-1.51-2.9-1.51-2.9A1.77,1.77,0,0,0,126.84,309.31Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.13,323c-2.95-4.55-6.65-2.07-6.65-2.07S128,325.63,133.13,323Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.54,319.18s2-4.79,1.23-6.53S130.38,316,129.54,319.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.66,318.22s1.89-4.72,2.72-4.33S133.4,315.25,131.66,318.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.57,315.29s.57-3.1,1.11-2.93S131.57,315.29,131.57,315.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.18,319.58c-.05-1.85-1.89,1.21-2.24-.31-.21-.89-1.1-.39-1.81.19-.19.48-.4,1-.65,1.51,0,0,1.47,4.66,6.65,2.07a12.56,12.56,0,0,1,2.93-8h0C133.75,316.85,131.22,321.43,131.18,319.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.35,321.49l2.36-5.76a5.7,5.7,0,0,0,5.14-.63l1-1.32-7.5.41-1.84,5.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.88,323a20.26,20.26,0,0,1,2.13-6.72,14.37,14.37,0,0,0,6.22-1.39,8.68,8.68,0,0,0,4.65-7.68c-.23-2.52-1.24-4.16-3.33-4.58-.76-3.48-2.42-5.33-5-5.42a2.59,2.59,0,0,0-2.07-2.53,4.22,4.22,0,0,0-2.31,1.82L126.48,321A4.67,4.67,0,0,0,127.88,323Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,305a4.29,4.29,0,0,1-2-4.84,6.85,6.85,0,0,1,3.69-3.93,2.36,2.36,0,0,1,1-.29.9.9,0,0,1,.85.51,5.25,5.25,0,0,1,5.49-3.27,5.19,5.19,0,0,1,4.48,4.5,4.19,4.19,0,0,1,3.62.57,4,4,0,0,1,1.83,3.08,4.65,4.65,0,0,1,3.44,3.31c1.44,7.65-6.48,9.72-9.84,8.85a8.23,8.23,0,0,1-7.21,1.44C111.17,314.6,107,312.72,107,305Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,305a4.29,4.29,0,0,1-2-4.84,6.85,6.85,0,0,1,3.69-3.93,2.36,2.36,0,0,1,1-.29.9.9,0,0,1,.85.51,5.25,5.25,0,0,1,5.49-3.27,5.19,5.19,0,0,1,4.48,4.5,4.19,4.19,0,0,1,3.62.57,4,4,0,0,1,1.83,3.08,4.65,4.65,0,0,1,3.44,3.31c1.44,7.65-6.48,9.72-9.84,8.85a8.23,8.23,0,0,1-7.21,1.44C111.17,314.6,107,312.72,107,305Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,311.08a1.67,1.67,0,0,0,.3-2.35,1.53,1.53,0,0,0-.37-.35l.06,0a2.36,2.36,0,0,0-1.77-4.21,2.45,2.45,0,0,0-.47-1.12,2.37,2.37,0,0,0-3.32-.42,2.41,2.41,0,0,0-.59.69,1.67,1.67,0,0,0-2.61,1.38,1.64,1.64,0,0,0-1.44.3,1.66,1.66,0,0,0-.48,2.05,2.45,2.45,0,0,0,2.89,3.13,1.67,1.67,0,0,0,2.38,1.59,2.27,2.27,0,0,0,.31.57,2.14,2.14,0,0,0,3.8-.9A1.64,1.64,0,0,0,126,311.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.47,312.93c1.93-1.94-.24-3.7-.24-3.7.17-2.78-2-2.34-2-2.34-1.11-2-2.53-.08-2.53-.08l-2,.37-1.2,1.87c0,.07.09.14.14.2a2.47,2.47,0,0,0,2.49.89,1.67,1.67,0,0,0,2.38,1.59,2.27,2.27,0,0,0,.31.57A2.16,2.16,0,0,0,123.47,312.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,309.47a2.08,2.08,0,0,0-1.38-3.43,2.95,2.95,0,0,0-2.45-3.15,2.92,2.92,0,0,0-1-2.71,2.94,2.94,0,0,0-4.71,1.33,2.08,2.08,0,0,0-2.39.58,2.05,2.05,0,0,0-.45,1.78,2.07,2.07,0,0,0-1.68.73,2.09,2.09,0,0,0,.24,2.95,2,2,0,0,0,.7.39,3.06,3.06,0,0,0,4.73,2.63l.1.09A2.09,2.09,0,0,0,116,311a1.49,1.49,0,0,0,.14.12,2.09,2.09,0,0,0,3-.24,2.17,2.17,0,0,0,.43-.84A2.08,2.08,0,0,0,122,309.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,309.47a2.08,2.08,0,0,0-1.38-3.43,2.95,2.95,0,0,0-2.45-3.15,2.92,2.92,0,0,0-1-2.71,2.94,2.94,0,0,0-4.71,1.33,2.08,2.08,0,0,0-2.39.58,2.05,2.05,0,0,0-.45,1.78,2.07,2.07,0,0,0-1.68.73,2.09,2.09,0,0,0,.24,2.95,2,2,0,0,0,.7.39,3.06,3.06,0,0,0,4.73,2.63l.1.09A2.09,2.09,0,0,0,116,311a1.49,1.49,0,0,0,.14.12,2.09,2.09,0,0,0,3-.24,2.17,2.17,0,0,0,.43-.84A2.08,2.08,0,0,0,122,309.47Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.84,307.4s-.2-1.88-1.67-2.19c-2-.41-3.28,2.27-3.28,2.27s-2.68-1.29-3.84,0a2.37,2.37,0,0,0-.06,2.86,3.06,3.06,0,0,0,3.65.23l.1.09A2.09,2.09,0,0,0,116,311a1.49,1.49,0,0,0,.14.12,2.09,2.09,0,0,0,3-.24,2.17,2.17,0,0,0,.43-.84,2.08,2.08,0,0,0,2.52-.52C123.18,306.64,118.84,307.4,118.84,307.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.36,308.4s3.44,3.79.1,11.67c0,0,1.64,4.6,6.73,1.81,0,0-.52-8.12,6.39-10.71a1.48,1.48,0,0,0-.86-1.28s-3,2.78-4,2.27S121,309,121,309s-.93-1.23-1.86-1c0,0-1.31,2.78-2.64,2.56s-.59-3.16-.59-3.16a1.78,1.78,0,0,0-1.85.11s.33,3-.33,3-1.62-2.83-1.62-2.83A1.74,1.74,0,0,0,110.36,308.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.36,308.4s3.44,3.79.1,11.67c0,0,1.64,4.6,6.73,1.81,0,0-.52-8.12,6.39-10.71a1.48,1.48,0,0,0-.86-1.28s-3,2.78-4,2.27S121,309,121,309s-.93-1.23-1.86-1c0,0-1.31,2.78-2.64,2.56s-.59-3.16-.59-3.16a1.78,1.78,0,0,0-1.85.11s.33,3-.33,3-1.62-2.83-1.62-2.83A1.74,1.74,0,0,0,110.36,308.4Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.19,321.88c-3.14-4.43-6.73-1.81-6.73-1.81S112.1,324.67,117.19,321.88Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.45,318.15s1.81-4.86,1-6.57S114.16,314.93,113.45,318.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.52,317.11s1.71-4.79,2.56-4.43S117.15,314.08,115.52,317.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.32,314.19s.45-3.12,1-3S115.32,314.19,115.32,314.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.09,318.49c-.11-1.85-1.83,1.28-2.25-.22-.24-.88-1.11-.34-1.8.26-.16.49-.36,1-.58,1.54,0,0,1.64,4.6,6.73,1.81a12.53,12.53,0,0,1,2.61-8.1h0C117.56,315.66,115.21,320.34,115.09,318.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.77,293.94a4.77,4.77,0,0,1,3.63,3.49,4.1,4.1,0,0,1,3.85-1l.23.81-4.93,4.59-5-6.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.4,306.19a4.3,4.3,0,0,1-1.76-4.92,6.87,6.87,0,0,1,3.83-3.78,2.25,2.25,0,0,1,1-.25.89.89,0,0,1,.83.54,5.27,5.27,0,0,1,5.62-3,5.18,5.18,0,0,1,4.3,4.67,4.25,4.25,0,0,1,3.6.71,4,4,0,0,1,1.7,3.15,4.65,4.65,0,0,1,3.31,3.45c1.14,7.7-6.86,9.45-10.18,8.46a8.27,8.27,0,0,1-7.26,1.15C121.18,315.9,117.06,313.86,117.4,306.19Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.4,306.19a4.3,4.3,0,0,1-1.76-4.92,6.87,6.87,0,0,1,3.83-3.78,2.25,2.25,0,0,1,1-.25.89.89,0,0,1,.83.54,5.27,5.27,0,0,1,5.62-3,5.18,5.18,0,0,1,4.3,4.67,4.25,4.25,0,0,1,3.6.71,4,4,0,0,1,1.7,3.15,4.65,4.65,0,0,1,3.31,3.45c1.14,7.7-6.86,9.45-10.18,8.46a8.27,8.27,0,0,1-7.26,1.15C121.18,315.9,117.06,313.86,117.4,306.19Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.12,313a1.67,1.67,0,0,0,.38-2.33,1.55,1.55,0,0,0-.35-.37l.06,0a2.36,2.36,0,0,0-1.6-4.27,2.36,2.36,0,0,0-3.73-1.68,2.39,2.39,0,0,0-.62.65,1.67,1.67,0,0,0-2.66,1.28,1.67,1.67,0,0,0-2,2.28,2.45,2.45,0,0,0,2.77,3.23,1.67,1.67,0,0,0,2.31,1.69,2,2,0,0,0,.29.58,2.14,2.14,0,0,0,3.83-.75A1.64,1.64,0,0,0,136.12,313Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.53,314.71c2-1.86-.09-3.7-.09-3.7.28-2.78-1.88-2.42-1.88-2.42-1-2-2.54-.18-2.54-.18l-2,.3-1.27,1.81.13.21a2.44,2.44,0,0,0,2.46,1,1.67,1.67,0,0,0,2.31,1.69,2,2,0,0,0,.29.58A2.14,2.14,0,0,0,133.53,314.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.23,311.2a2.09,2.09,0,0,0-.13-3,2.13,2.13,0,0,0-1.11-.53,3,3,0,0,0-.94-2.52,2.85,2.85,0,0,0-1.39-.71,2.94,2.94,0,0,0-5.06-2.57,2.74,2.74,0,0,0-.59,1,2.09,2.09,0,0,0-2.41.48,2.05,2.05,0,0,0-.52,1.76,2.1,2.1,0,0,0-1.59,3.63,2.24,2.24,0,0,0,.69.42,3.06,3.06,0,0,0,4.63,2.81l.09.09a2.07,2.07,0,0,0,2.24.38l.13.13a2.09,2.09,0,0,0,3.42-.95A2.09,2.09,0,0,0,132.23,311.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.23,311.2a2.09,2.09,0,0,0-.13-3,2.13,2.13,0,0,0-1.11-.53,3,3,0,0,0-.94-2.52,2.85,2.85,0,0,0-1.39-.71,2.94,2.94,0,0,0-5.06-2.57,2.74,2.74,0,0,0-.59,1,2.09,2.09,0,0,0-2.41.48,2.05,2.05,0,0,0-.52,1.76,2.1,2.1,0,0,0-1.59,3.63,2.24,2.24,0,0,0,.69.42,3.06,3.06,0,0,0,4.63,2.81l.09.09a2.07,2.07,0,0,0,2.24.38l.13.13a2.09,2.09,0,0,0,3.42-.95A2.09,2.09,0,0,0,132.23,311.2Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.13,309s-.14-1.89-1.6-2.26c-2-.49-3.35,2.15-3.35,2.15s-2.63-1.4-3.85-.16a2.36,2.36,0,0,0-.17,2.85,3.06,3.06,0,0,0,3.64.38l.1.09a2.07,2.07,0,0,0,2.24.38l.13.13a2.09,2.09,0,0,0,3.42-.95,2.09,2.09,0,0,0,2.54-.42C133.48,308.42,129.13,309,129.13,309Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.61,309.67s3.29,3.93-.36,11.67c0,0,1.46,4.66,6.65,2.07,0,0-.2-8.14,6.81-10.46a1.47,1.47,0,0,0-.81-1.31s-3.09,2.67-4.06,2.11,2.4-3.1,2.4-3.1-.88-1.26-1.82-1.08c0,0-1.42,2.72-2.73,2.45s-.48-3.18-.48-3.18a1.77,1.77,0,0,0-1.85,0s.22,3-.44,3-1.51-2.89-1.51-2.89A1.75,1.75,0,0,0,120.61,309.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.61,309.67s3.29,3.93-.36,11.67c0,0,1.46,4.66,6.65,2.07,0,0-.2-8.14,6.81-10.46a1.47,1.47,0,0,0-.81-1.31s-3.09,2.67-4.06,2.11,2.4-3.1,2.4-3.1-.88-1.26-1.82-1.08c0,0-1.42,2.72-2.73,2.45s-.48-3.18-.48-3.18a1.77,1.77,0,0,0-1.85,0s.22,3-.44,3-1.51-2.89-1.51-2.89A1.75,1.75,0,0,0,120.61,309.67Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.9,323.41c-3-4.55-6.65-2.07-6.65-2.07S121.71,326,126.9,323.41Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.31,319.54s2-4.79,1.23-6.53S124.15,316.34,123.31,319.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.43,318.58s1.89-4.72,2.72-4.33S127.17,315.61,125.43,318.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.34,315.65s.57-3.1,1.11-2.92S125.34,315.65,125.34,315.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.94,319.94c0-1.85-1.88,1.21-2.23-.31-.21-.89-1.11-.38-1.82.19-.18.49-.39,1-.64,1.52,0,0,1.46,4.66,6.65,2.07a12.55,12.55,0,0,1,2.93-8h0C127.52,317.21,125,321.79,124.94,319.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.75,315.42c3.23-2.31,4.72-5.27,4-9.09-.61-3.22-2.18-3.79-3.89-4.45a5.31,5.31,0,0,0-3-3.43,10.48,10.48,0,0,0-1.42,1.4l2.43,13.39A7.47,7.47,0,0,0,120.75,315.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.82,321.93a12.38,12.38,0,0,1,2-5.54,9.58,9.58,0,0,0,4.54-.36,9.29,9.29,0,0,1,1.44-2.25l-6.8.16-2.54,6.13A4.67,4.67,0,0,0,111.82,321.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,305.82a4.29,4.29,0,0,1-1.76-4.92,6.9,6.9,0,0,1,3.83-3.78,2.47,2.47,0,0,1,1-.25.89.89,0,0,1,.82.55,5.28,5.28,0,0,1,5.63-3.06,5.19,5.19,0,0,1,4.29,4.67,4.26,4.26,0,0,1,3.6.72,4,4,0,0,1,1.7,3.15,4.64,4.64,0,0,1,3.31,3.44c1.14,7.71-6.86,9.45-10.18,8.46A8.21,8.21,0,0,1,106,316C104.8,315.53,100.68,313.49,101,305.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,305.82a4.29,4.29,0,0,1-1.76-4.92,6.9,6.9,0,0,1,3.83-3.78,2.47,2.47,0,0,1,1-.25.89.89,0,0,1,.82.55,5.28,5.28,0,0,1,5.63-3.06,5.19,5.19,0,0,1,4.29,4.67,4.26,4.26,0,0,1,3.6.72,4,4,0,0,1,1.7,3.15,4.64,4.64,0,0,1,3.31,3.44c1.14,7.71-6.86,9.45-10.18,8.46A8.21,8.21,0,0,1,106,316C104.8,315.53,100.68,313.49,101,305.82Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.74,312.6a1.68,1.68,0,0,0,.38-2.34,1.71,1.71,0,0,0-.35-.36l.06,0a2.36,2.36,0,0,0-1.6-4.27,2.37,2.37,0,0,0-3.73-1.69,2.43,2.43,0,0,0-.62.66,1.68,1.68,0,0,0-2,0,1.7,1.7,0,0,0-.69,1.3,1.67,1.67,0,0,0-2,2.27,2.46,2.46,0,0,0,2.77,3.24,1.67,1.67,0,0,0,2.31,1.69,2.1,2.1,0,0,0,.29.58,2.15,2.15,0,0,0,3,.49,2.13,2.13,0,0,0,.83-1.24A1.68,1.68,0,0,0,119.74,312.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.15,314.35c2-1.86-.09-3.71-.09-3.71.28-2.77-1.88-2.41-1.88-2.41-1-2.06-2.54-.18-2.54-.18l-2,.29-1.28,1.82.14.21a2.45,2.45,0,0,0,2.45,1,1.67,1.67,0,0,0,2.31,1.69,2.1,2.1,0,0,0,.29.58A2.17,2.17,0,0,0,117.15,314.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.85,310.83a2.09,2.09,0,0,0-.12-2.95,2.12,2.12,0,0,0-1.12-.53,3,3,0,0,0-.94-2.52,2.87,2.87,0,0,0-1.39-.72,2.95,2.95,0,0,0-5.65-1.61,2.11,2.11,0,0,0-2.41.49,2,2,0,0,0-.52,1.76,2.09,2.09,0,0,0-1.59,3.62,2.07,2.07,0,0,0,.69.42,3.07,3.07,0,0,0,4.63,2.82l.09.09a2.11,2.11,0,0,0,2.24.38,1.59,1.59,0,0,0,.13.13,2.09,2.09,0,0,0,3-.13,2,2,0,0,0,.47-.83A2.08,2.08,0,0,0,115.85,310.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.85,310.83a2.09,2.09,0,0,0-.12-2.95,2.12,2.12,0,0,0-1.12-.53,3,3,0,0,0-.94-2.52,2.87,2.87,0,0,0-1.39-.72,2.95,2.95,0,0,0-5.65-1.61,2.11,2.11,0,0,0-2.41.49,2,2,0,0,0-.52,1.76,2.09,2.09,0,0,0-1.59,3.62,2.07,2.07,0,0,0,.69.42,3.07,3.07,0,0,0,4.63,2.82l.09.09a2.11,2.11,0,0,0,2.24.38,1.59,1.59,0,0,0,.13.13,2.09,2.09,0,0,0,3-.13,2,2,0,0,0,.47-.83A2.08,2.08,0,0,0,115.85,310.83Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75,308.64s-.14-1.89-1.59-2.25c-2-.49-3.36,2.14-3.36,2.14s-2.63-1.4-3.85-.15a2.38,2.38,0,0,0-.17,2.85,3.09,3.09,0,0,0,3.65.38l.09.09a2.11,2.11,0,0,0,2.24.38,1.59,1.59,0,0,0,.13.13,2.09,2.09,0,0,0,3-.13,2,2,0,0,0,.47-.83,2.08,2.08,0,0,0,2.54-.42C117.11,308.05,112.75,308.64,112.75,308.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.23,309.31s3.29,3.92-.36,11.66c0,0,1.47,4.66,6.65,2.07,0,0-.2-8.13,6.81-10.45a1.47,1.47,0,0,0-.81-1.31s-3.09,2.66-4.06,2.11,2.4-3.1,2.4-3.1S114,309,113,309.2c0,0-1.42,2.73-2.73,2.46s-.48-3.18-.48-3.18a1.77,1.77,0,0,0-1.85,0s.22,3-.44,3-1.51-2.9-1.51-2.9A1.77,1.77,0,0,0,104.23,309.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.23,309.31s3.29,3.92-.36,11.66c0,0,1.47,4.66,6.65,2.07,0,0-.2-8.13,6.81-10.45a1.47,1.47,0,0,0-.81-1.31s-3.09,2.66-4.06,2.11,2.4-3.1,2.4-3.1S114,309,113,309.2c0,0-1.42,2.73-2.73,2.46s-.48-3.18-.48-3.18a1.77,1.77,0,0,0-1.85,0s.22,3-.44,3-1.51-2.9-1.51-2.9A1.77,1.77,0,0,0,104.23,309.31Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.52,323c-3-4.55-6.65-2.07-6.65-2.07S105.34,325.63,110.52,323Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.93,319.18s2-4.79,1.23-6.53S107.77,316,106.93,319.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.05,318.22s1.89-4.72,2.72-4.33S110.79,315.25,109.05,318.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,315.29s.57-3.1,1.12-2.93S109,315.29,109,315.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.57,319.58c0-1.85-1.89,1.21-2.24-.31-.21-.89-1.1-.39-1.81.19-.19.48-.4,1-.65,1.51,0,0,1.47,4.66,6.65,2.07a12.56,12.56,0,0,1,2.93-8h0C111.14,316.85,108.61,321.43,108.57,319.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.91,297.76a2.89,2.89,0,0,1,2.67,2.83c2.25,1.52,3.72,3.4,3.41,6.1a9.06,9.06,0,0,1-4.78,7.25c-2.19-2.85-3.09-5.57-2.19-8.12l-.4-7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.37,305.29a4.34,4.34,0,0,1-2-4.86,6.85,6.85,0,0,1,3.63-4,2.21,2.21,0,0,1,1-.31.89.89,0,0,1,.85.5,5.17,5.17,0,0,1,10,1.1,4.24,4.24,0,0,1,3.63.53,4.1,4.1,0,0,1,1.87,3.08,4.68,4.68,0,0,1,3.48,3.31c1.55,7.7-6.35,9.89-9.72,9.06a8.15,8.15,0,0,1-7.19,1.55C88.65,314.88,84.43,313.05,84.37,305.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.37,305.29a4.34,4.34,0,0,1-2-4.86,6.85,6.85,0,0,1,3.63-4,2.21,2.21,0,0,1,1-.31.89.89,0,0,1,.85.5,5.17,5.17,0,0,1,10,1.1,4.24,4.24,0,0,1,3.63.53,4.1,4.1,0,0,1,1.87,3.08,4.68,4.68,0,0,1,3.48,3.31c1.55,7.7-6.35,9.89-9.72,9.06a8.15,8.15,0,0,1-7.19,1.55C88.65,314.88,84.43,313.05,84.37,305.29Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.42,311.13a1.72,1.72,0,0,0,.26-2.38,1.8,1.8,0,0,0-.38-.35l.07,0a2.4,2.4,0,0,0,.37-3.35,2.37,2.37,0,0,0-2.2-.87,2.36,2.36,0,0,0-3.81-1.5,2.45,2.45,0,0,0-.59.7,1.64,1.64,0,0,0-2,.09,1.69,1.69,0,0,0-.63,1.34,1.64,1.64,0,0,0-1.43.32,1.7,1.7,0,0,0-.45,2.08,2.51,2.51,0,0,0,.43,2.26,2.44,2.44,0,0,0,2.5.85,1.71,1.71,0,0,0,.37,1.11,1.66,1.66,0,0,0,2,.47,2,2,0,0,0,.32.57,2.14,2.14,0,0,0,3.79-1A1.63,1.63,0,0,0,103.42,311.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.92,313c1.91-2-.29-3.73-.29-3.73.14-2.81-2-2.34-2-2.34-1.15-2-2.54,0-2.54,0l-2,.4L93,309.22l.14.21a2.44,2.44,0,0,0,2.5.85,1.71,1.71,0,0,0,.37,1.11,1.66,1.66,0,0,0,2,.47,2,2,0,0,0,.32.57A2.14,2.14,0,0,0,100.92,313Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.44,309.56a2.12,2.12,0,0,0-.28-3,2.06,2.06,0,0,0-1.15-.48A3,3,0,0,0,97,303.62a2.88,2.88,0,0,0-1.42-.65,3,3,0,0,0-1-2.72,3,3,0,0,0-4.7,1.4,2.08,2.08,0,0,0-2.38.62,2.12,2.12,0,0,0-.43,1.8,2.08,2.08,0,0,0-1.67.77,2.1,2.1,0,0,0,1,3.35,3.09,3.09,0,0,0,1.11,2.41,3,3,0,0,0,3.66.18l.09.09a2.07,2.07,0,0,0,2.26.26l.14.13A2.07,2.07,0,0,0,96.5,311a1.93,1.93,0,0,0,.42-.86A2.07,2.07,0,0,0,99.44,309.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.44,309.56a2.12,2.12,0,0,0-.28-3,2.06,2.06,0,0,0-1.15-.48A3,3,0,0,0,97,303.62a2.88,2.88,0,0,0-1.42-.65,3,3,0,0,0-1-2.72,3,3,0,0,0-4.7,1.4,2.08,2.08,0,0,0-2.38.62,2.12,2.12,0,0,0-.43,1.8,2.08,2.08,0,0,0-1.67.77,2.1,2.1,0,0,0,1,3.35,3.09,3.09,0,0,0,1.11,2.41,3,3,0,0,0,3.66.18l.09.09a2.07,2.07,0,0,0,2.26.26l.14.13A2.07,2.07,0,0,0,96.5,311a1.93,1.93,0,0,0,.42-.86A2.07,2.07,0,0,0,99.44,309.56Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.23,307.51s-.24-1.89-1.71-2.18c-2-.39-3.24,2.33-3.24,2.33s-2.7-1.27-3.85,0a2.42,2.42,0,0,0,0,2.89,3,3,0,0,0,3.66.18l.09.09a2.07,2.07,0,0,0,2.26.26l.14.13A2.07,2.07,0,0,0,96.5,311a1.93,1.93,0,0,0,.42-.86,2.07,2.07,0,0,0,2.52-.55C100.55,306.68,96.23,307.51,96.23,307.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.76,308.64s3.49,3.78.25,11.77c0,0,1.71,4.62,6.76,1.74,0,0-.63-8.19,6.24-10.9a1.49,1.49,0,0,0-.88-1.28s-2.94,2.85-3.94,2.34,2.24-3.25,2.24-3.25-1-1.23-1.88-1c0,0-1.27,2.82-2.6,2.62s-.64-3.18-.64-3.18a1.77,1.77,0,0,0-1.85.14s.38,3-.28,3.06-1.67-2.84-1.67-2.84A1.74,1.74,0,0,0,87.76,308.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.76,308.64s3.49,3.78.25,11.77c0,0,1.71,4.62,6.76,1.74,0,0-.63-8.19,6.24-10.9a1.49,1.49,0,0,0-.88-1.28s-2.94,2.85-3.94,2.34,2.24-3.25,2.24-3.25-1-1.23-1.88-1c0,0-1.27,2.82-2.6,2.62s-.64-3.18-.64-3.18a1.77,1.77,0,0,0-1.85.14s.38,3-.28,3.06-1.67-2.84-1.67-2.84A1.74,1.74,0,0,0,87.76,308.64Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.77,322.15c-3.2-4.43-6.76-1.74-6.76-1.74S89.72,325,94.77,322.15Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,318.44s1.75-4.93.88-6.65S91.65,315.17,91,318.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,317.36s1.64-4.86,2.49-4.5S94.62,314.28,93,317.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8,314.41s.4-3.15,1-3S92.8,314.41,92.8,314.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.63,318.76c-.14-1.86-1.82,1.32-2.26-.2-.25-.88-1.11-.32-1.79.29q-.24.75-.57,1.56s1.71,4.62,6.76,1.74a12.7,12.7,0,0,1,2.5-8.21h0C95.06,315.87,92.77,320.62,92.63,318.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,320.41c.65-1.65,1.2-3.6,2.69-4.72a5.49,5.49,0,0,1,3.69-1.28A6.14,6.14,0,0,1,98.27,312a8,8,0,0,1,4.66.88,9.83,9.83,0,0,1-4.26,1l-1.59-.16-7.62,8.64A4.82,4.82,0,0,1,88,320.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.12,317.59c1.09-.69,2.12-1.39,3.54-.73a6.34,6.34,0,0,1,4.92-2.16,5,5,0,0,1,4.24-2.79,8.23,8.23,0,0,1,3.7.85l-1.35,1,1.81.68.74-.76c.57.3.69.57,1,1.26a1.46,1.46,0,0,1,1.93.09c1.1-2.47,3.19-3.3,6.32-2.52a9.1,9.1,0,0,1,3.49,2.12l-1,.34.37.49.57-.21.17.29-.39.52-9.46,4.14-12.44-2.93-7.15,2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.87,311.75a7.87,7.87,0,0,1,3.72,1.72,6.12,6.12,0,0,1,1.92,3.13,11.85,11.85,0,0,0-.91,1.6l-6-4.94A6.29,6.29,0,0,0,145.87,311.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.86,324.4a4.28,4.28,0,0,1-1.76-4.92,6.79,6.79,0,0,1,3.83-3.77,2.26,2.26,0,0,1,1-.26.92.92,0,0,1,.83.55,5.28,5.28,0,0,1,5.62-3.06,5.19,5.19,0,0,1,4.3,4.67,4.26,4.26,0,0,1,3.6.72,4.07,4.07,0,0,1,1.7,3.15,4.62,4.62,0,0,1,3.3,3.45c1.15,7.7-6.85,9.45-10.18,8.45a8.21,8.21,0,0,1-7.26,1.15C140.63,334.11,136.52,332.07,136.86,324.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.86,324.4a4.28,4.28,0,0,1-1.76-4.92,6.79,6.79,0,0,1,3.83-3.77,2.26,2.26,0,0,1,1-.26.92.92,0,0,1,.83.55,5.28,5.28,0,0,1,5.62-3.06,5.19,5.19,0,0,1,4.3,4.67,4.26,4.26,0,0,1,3.6.72,4.07,4.07,0,0,1,1.7,3.15,4.62,4.62,0,0,1,3.3,3.45c1.15,7.7-6.85,9.45-10.18,8.45a8.21,8.21,0,0,1-7.26,1.15C140.63,334.11,136.52,332.07,136.86,324.4Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.57,331.18a1.67,1.67,0,0,0,.39-2.34,1.71,1.71,0,0,0-.35-.36l.06,0a2.36,2.36,0,0,0-1.61-4.27,2.44,2.44,0,0,0-.42-1.14,2.37,2.37,0,0,0-3.3-.55,2.42,2.42,0,0,0-.62.66,1.66,1.66,0,0,0-2,0,1.71,1.71,0,0,0-.7,1.29,1.67,1.67,0,0,0-2,2.27,2.45,2.45,0,0,0,2.77,3.24,1.65,1.65,0,0,0,.3,1.12,1.68,1.68,0,0,0,2,.57,2.47,2.47,0,0,0,.3.58,2.14,2.14,0,0,0,3.83-.75A1.65,1.65,0,0,0,155.57,331.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,332.93c2-1.86-.1-3.71-.1-3.71.29-2.77-1.88-2.41-1.88-2.41-1-2.05-2.53-.18-2.53-.18l-2,.29-1.27,1.82a2.39,2.39,0,0,0,.13.21,2.48,2.48,0,0,0,2.46,1,1.65,1.65,0,0,0,.3,1.12,1.68,1.68,0,0,0,2,.57,2.47,2.47,0,0,0,.3.58A2.16,2.16,0,0,0,153,332.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.69,329.42a2.1,2.1,0,0,0-.13-3,2.05,2.05,0,0,0-1.12-.53,2.93,2.93,0,0,0-2.32-3.23,3,3,0,0,0-5.07-2.58,3,3,0,0,0-.59,1,2.08,2.08,0,0,0-2.93,2.24A2.09,2.09,0,0,0,138,327a2.21,2.21,0,0,0,.69.41,3.06,3.06,0,0,0,4.62,2.82l.09.09a2.09,2.09,0,0,0,2.25.38l.13.13a2.09,2.09,0,0,0,3-.13,2,2,0,0,0,.47-.83A2.08,2.08,0,0,0,151.69,329.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.69,329.42a2.1,2.1,0,0,0-.13-3,2.05,2.05,0,0,0-1.12-.53,2.93,2.93,0,0,0-2.32-3.23,3,3,0,0,0-5.07-2.58,3,3,0,0,0-.59,1,2.08,2.08,0,0,0-2.93,2.24A2.09,2.09,0,0,0,138,327a2.21,2.21,0,0,0,.69.41,3.06,3.06,0,0,0,4.62,2.82l.09.09a2.09,2.09,0,0,0,2.25.38l.13.13a2.09,2.09,0,0,0,3-.13,2,2,0,0,0,.47-.83A2.08,2.08,0,0,0,151.69,329.42Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.58,327.22s-.13-1.89-1.59-2.25c-2-.49-3.36,2.14-3.36,2.14s-2.62-1.4-3.84-.15a2.36,2.36,0,0,0-.17,2.85,3.07,3.07,0,0,0,3.64.38l.09.09a2.09,2.09,0,0,0,2.25.38l.13.13a2.09,2.09,0,0,0,3-.13,2,2,0,0,0,.47-.83,2.08,2.08,0,0,0,2.54-.41C152.94,326.63,148.58,327.22,148.58,327.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.07,327.89s3.29,3.92-.36,11.66c0,0,1.46,4.66,6.65,2.07,0,0-.2-8.13,6.81-10.45a1.47,1.47,0,0,0-.81-1.31s-3.09,2.66-4.06,2.11,2.4-3.1,2.4-3.1-.88-1.27-1.83-1.09c0,0-1.41,2.73-2.73,2.46s-.47-3.18-.47-3.18a1.77,1.77,0,0,0-1.85,0s.22,3-.44,3-1.52-2.89-1.52-2.89A1.74,1.74,0,0,0,140.07,327.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.07,327.89s3.29,3.92-.36,11.66c0,0,1.46,4.66,6.65,2.07,0,0-.2-8.13,6.81-10.45a1.47,1.47,0,0,0-.81-1.31s-3.09,2.66-4.06,2.11,2.4-3.1,2.4-3.1-.88-1.27-1.83-1.09c0,0-1.41,2.73-2.73,2.46s-.47-3.18-.47-3.18a1.77,1.77,0,0,0-1.85,0s.22,3-.44,3-1.52-2.89-1.52-2.89A1.74,1.74,0,0,0,140.07,327.89Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.36,341.62c-3-4.55-6.65-2.07-6.65-2.07S141.17,344.21,146.36,341.62Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.77,337.76s2-4.79,1.22-6.53S143.61,334.56,142.77,337.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.88,336.8s1.9-4.72,2.73-4.33S146.63,333.83,144.88,336.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.8,333.87s.57-3.1,1.11-2.93S144.8,333.87,144.8,333.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.4,338.16c0-1.85-1.88,1.21-2.24-.31-.2-.89-1.1-.39-1.81.19-.18.49-.4,1-.64,1.51,0,0,1.46,4.66,6.65,2.07a12.56,12.56,0,0,1,2.93-8h0C147,335.43,144.44,340,144.4,338.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.55,316.47a4.73,4.73,0,0,1,4.5,4.48c3.41,1.36,5,3.5,3.8,6.91-1.36,3.2-3.08,5.27-5.24,6.06a7.08,7.08,0,0,1-1.92-1.85l-2.87-13.43C135.6,318.11,136.35,317.35,137.55,316.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.89,324.7a4.3,4.3,0,0,1-1.76-4.92A6.86,6.86,0,0,1,124,316a2.25,2.25,0,0,1,1-.25.9.9,0,0,1,.83.54,5.26,5.26,0,0,1,5.62-3.05,5.19,5.19,0,0,1,4.3,4.67,4.23,4.23,0,0,1,3.59.71,4.05,4.05,0,0,1,1.71,3.15,4.64,4.64,0,0,1,3.3,3.45c1.15,7.7-6.85,9.45-10.18,8.46a8.27,8.27,0,0,1-7.26,1.15C125.67,334.41,121.55,332.37,121.89,324.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.89,324.7a4.3,4.3,0,0,1-1.76-4.92A6.86,6.86,0,0,1,124,316a2.25,2.25,0,0,1,1-.25.9.9,0,0,1,.83.54,5.26,5.26,0,0,1,5.62-3.05,5.19,5.19,0,0,1,4.3,4.67,4.23,4.23,0,0,1,3.59.71,4.05,4.05,0,0,1,1.71,3.15,4.64,4.64,0,0,1,3.3,3.45c1.15,7.7-6.85,9.45-10.18,8.46a8.27,8.27,0,0,1-7.26,1.15C125.67,334.41,121.55,332.37,121.89,324.7Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.61,331.47a1.68,1.68,0,0,0,.39-2.33,1.81,1.81,0,0,0-.36-.37l.07,0a2.36,2.36,0,0,0-1.61-4.27,2.36,2.36,0,0,0-3.73-1.68,2.39,2.39,0,0,0-.62.65,1.67,1.67,0,0,0-2.66,1.28,1.67,1.67,0,0,0-2,2.28,2.45,2.45,0,0,0,2.77,3.23,1.7,1.7,0,0,0,.31,1.12,1.67,1.67,0,0,0,2,.57,2.25,2.25,0,0,0,.29.58,2.15,2.15,0,0,0,3.84-.75A1.62,1.62,0,0,0,140.61,331.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,333.22c2-1.86-.09-3.7-.09-3.7.28-2.78-1.88-2.42-1.88-2.42-1-2.05-2.54-.18-2.54-.18l-2,.3L130.27,329a2.39,2.39,0,0,0,2.58,1.19,1.7,1.7,0,0,0,.31,1.12,1.67,1.67,0,0,0,2,.57,2.25,2.25,0,0,0,.29.58A2.14,2.14,0,0,0,138,333.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.72,329.71a2.09,2.09,0,0,0-.12-3,2.2,2.2,0,0,0-1.12-.53,2.93,2.93,0,0,0-2.32-3.23,3,3,0,0,0-5.07-2.57,2.74,2.74,0,0,0-.59,1,2.08,2.08,0,0,0-2.93,2.24,2.1,2.1,0,0,0-.9,4.05,3.07,3.07,0,0,0,4.63,2.81l.09.09a2.07,2.07,0,0,0,2.24.38l.13.13a2.1,2.1,0,0,0,3-.12,2.2,2.2,0,0,0,.46-.83A2.09,2.09,0,0,0,136.72,329.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.72,329.71a2.09,2.09,0,0,0-.12-3,2.2,2.2,0,0,0-1.12-.53,2.93,2.93,0,0,0-2.32-3.23,3,3,0,0,0-5.07-2.57,2.74,2.74,0,0,0-.59,1,2.08,2.08,0,0,0-2.93,2.24,2.1,2.1,0,0,0-.9,4.05,3.07,3.07,0,0,0,4.63,2.81l.09.09a2.07,2.07,0,0,0,2.24.38l.13.13a2.1,2.1,0,0,0,3-.12,2.2,2.2,0,0,0,.46-.83A2.09,2.09,0,0,0,136.72,329.71Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.62,327.52s-.14-1.89-1.59-2.26c-2-.49-3.36,2.15-3.36,2.15s-2.63-1.4-3.84-.16a2.36,2.36,0,0,0-.17,2.85,3.05,3.05,0,0,0,3.64.38l.09.09a2.07,2.07,0,0,0,2.24.38l.13.13a2.1,2.1,0,0,0,3-.12,2.2,2.2,0,0,0,.46-.83,2.09,2.09,0,0,0,2.54-.42C138,326.92,133.62,327.52,133.62,327.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.1,328.18s3.29,3.93-.36,11.66c0,0,1.47,4.67,6.66,2.08,0,0-.2-8.14,6.81-10.46a1.49,1.49,0,0,0-.82-1.31s-3.09,2.67-4.06,2.11,2.4-3.1,2.4-3.1-.88-1.26-1.82-1.08c0,0-1.41,2.72-2.73,2.45s-.47-3.18-.47-3.18a1.77,1.77,0,0,0-1.85,0s.21,3-.45,3-1.51-2.89-1.51-2.89A1.75,1.75,0,0,0,125.1,328.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.1,328.18s3.29,3.93-.36,11.66c0,0,1.47,4.67,6.66,2.08,0,0-.2-8.14,6.81-10.46a1.49,1.49,0,0,0-.82-1.31s-3.09,2.67-4.06,2.11,2.4-3.1,2.4-3.1-.88-1.26-1.82-1.08c0,0-1.41,2.72-2.73,2.45s-.47-3.18-.47-3.18a1.77,1.77,0,0,0-1.85,0s.21,3-.45,3-1.51-2.89-1.51-2.89A1.75,1.75,0,0,0,125.1,328.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.4,341.92c-3-4.55-6.66-2.08-6.66-2.08S126.21,344.51,131.4,341.92Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.8,338.05s2-4.79,1.23-6.53S128.65,334.85,127.8,338.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.92,337.09s1.89-4.72,2.72-4.33S131.66,334.12,129.92,337.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.83,334.16s.58-3.1,1.12-2.92S129.83,334.16,129.83,334.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.44,338.45c0-1.85-1.89,1.21-2.24-.31-.21-.89-1.1-.38-1.81.19-.19.49-.4,1-.65,1.51,0,0,1.47,4.67,6.66,2.08a12.51,12.51,0,0,1,2.92-8h0C132,335.72,129.48,340.3,129.44,338.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.91,318a6.81,6.81,0,0,1,1.36,2.77c2.93,1.15,4,3.69,3.64,7.33a12,12,0,0,1-3.64,5,8.56,8.56,0,0,1-4.7,1.07c-2.67-2-3.9-4.43-3.65-7.3l.92-10.39L124,316a.81.81,0,0,1,.9.64A5.43,5.43,0,0,1,128.91,318Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,324.46a4.3,4.3,0,0,1-1.76-4.92,6.87,6.87,0,0,1,3.83-3.78,2.25,2.25,0,0,1,1-.25.88.88,0,0,1,.83.54,5.27,5.27,0,0,1,5.62-3.05,5.18,5.18,0,0,1,4.3,4.67,4.25,4.25,0,0,1,3.6.71,4,4,0,0,1,1.7,3.15A4.65,4.65,0,0,1,132.4,325c1.14,7.7-6.86,9.45-10.18,8.46a8.24,8.24,0,0,1-7.26,1.15C113.74,334.17,109.62,332.13,110,324.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,324.46a4.3,4.3,0,0,1-1.76-4.92,6.87,6.87,0,0,1,3.83-3.78,2.25,2.25,0,0,1,1-.25.88.88,0,0,1,.83.54,5.27,5.27,0,0,1,5.62-3.05,5.18,5.18,0,0,1,4.3,4.67,4.25,4.25,0,0,1,3.6.71,4,4,0,0,1,1.7,3.15A4.65,4.65,0,0,1,132.4,325c1.14,7.7-6.86,9.45-10.18,8.46a8.24,8.24,0,0,1-7.26,1.15C113.74,334.17,109.62,332.13,110,324.46Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.68,331.23a1.67,1.67,0,0,0,.38-2.33,1.55,1.55,0,0,0-.35-.37l.06,0a2.36,2.36,0,0,0-1.6-4.27,2.36,2.36,0,0,0-3.73-1.68,2.39,2.39,0,0,0-.62.65,1.67,1.67,0,0,0-2.66,1.28,1.67,1.67,0,0,0-2,2.28,2.45,2.45,0,0,0,2.77,3.23,1.67,1.67,0,0,0,2.31,1.69,2,2,0,0,0,.29.58,2.14,2.14,0,0,0,3.83-.74A1.68,1.68,0,0,0,128.68,331.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.09,333c2-1.86-.09-3.7-.09-3.7.28-2.78-1.88-2.42-1.88-2.42-1-2.05-2.54-.18-2.54-.18l-2,.3-1.27,1.81a1.53,1.53,0,0,0,.14.21,2.42,2.42,0,0,0,2.45,1,1.67,1.67,0,0,0,2.31,1.69,2,2,0,0,0,.29.58A2.14,2.14,0,0,0,126.09,333Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.79,329.47a2.09,2.09,0,0,0-.13-3,2.13,2.13,0,0,0-1.11-.53,3,3,0,0,0-.94-2.52,2.85,2.85,0,0,0-1.39-.71,2.94,2.94,0,0,0-5.06-2.57,2.74,2.74,0,0,0-.59,1,2.07,2.07,0,0,0-2.41.49,2,2,0,0,0-.52,1.76,2.09,2.09,0,0,0-.9,4,3.06,3.06,0,0,0,4.63,2.81l.09.09a2.07,2.07,0,0,0,2.24.38.8.8,0,0,0,.13.13,2.09,2.09,0,0,0,3.42-.95A2.09,2.09,0,0,0,124.79,329.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.79,329.47a2.09,2.09,0,0,0-.13-3,2.13,2.13,0,0,0-1.11-.53,3,3,0,0,0-.94-2.52,2.85,2.85,0,0,0-1.39-.71,2.94,2.94,0,0,0-5.06-2.57,2.74,2.74,0,0,0-.59,1,2.07,2.07,0,0,0-2.41.49,2,2,0,0,0-.52,1.76,2.09,2.09,0,0,0-.9,4,3.06,3.06,0,0,0,4.63,2.81l.09.09a2.07,2.07,0,0,0,2.24.38.8.8,0,0,0,.13.13,2.09,2.09,0,0,0,3.42-.95A2.09,2.09,0,0,0,124.79,329.47Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.69,327.28s-.14-1.89-1.6-2.26c-2-.49-3.35,2.15-3.35,2.15s-2.63-1.4-3.85-.16a2.37,2.37,0,0,0-.17,2.86,3.08,3.08,0,0,0,3.65.37l.09.09a2.07,2.07,0,0,0,2.24.38.8.8,0,0,0,.13.13,2.09,2.09,0,0,0,3.42-.95,2.09,2.09,0,0,0,2.54-.42C126,326.69,121.69,327.28,121.69,327.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.17,327.94s3.29,3.93-.36,11.67c0,0,1.46,4.66,6.65,2.07,0,0-.2-8.14,6.81-10.46a1.47,1.47,0,0,0-.81-1.31s-3.09,2.67-4.06,2.11,2.4-3.1,2.4-3.1-.88-1.26-1.82-1.08c0,0-1.42,2.72-2.73,2.45s-.48-3.18-.48-3.18a1.77,1.77,0,0,0-1.85,0s.22,3-.44,3-1.51-2.89-1.51-2.89A1.75,1.75,0,0,0,113.17,327.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.17,327.94s3.29,3.93-.36,11.67c0,0,1.46,4.66,6.65,2.07,0,0-.2-8.14,6.81-10.46a1.47,1.47,0,0,0-.81-1.31s-3.09,2.67-4.06,2.11,2.4-3.1,2.4-3.1-.88-1.26-1.82-1.08c0,0-1.42,2.72-2.73,2.45s-.48-3.18-.48-3.18a1.77,1.77,0,0,0-1.85,0s.22,3-.44,3-1.51-2.89-1.51-2.89A1.75,1.75,0,0,0,113.17,327.94Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.46,341.68c-2.95-4.55-6.65-2.07-6.65-2.07S114.27,344.27,119.46,341.68Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.87,337.81s2-4.79,1.23-6.53S116.71,334.61,115.87,337.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,336.85s1.89-4.72,2.72-4.32S119.73,333.88,118,336.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.9,333.92s.57-3.1,1.11-2.92S117.9,333.92,117.9,333.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,338.21c0-1.85-1.88,1.21-2.23-.31-.21-.89-1.1-.38-1.82.19-.18.49-.39,1-.64,1.52,0,0,1.46,4.66,6.65,2.07a12.55,12.55,0,0,1,2.93-8h0C120.08,335.48,117.55,340.06,117.5,338.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.32,317.66a4.9,4.9,0,0,1,1.8,2.9,4.78,4.78,0,0,1,2.59,1.69,7.41,7.41,0,0,1,1.13,4.66,7.73,7.73,0,0,1-1,3.6,7,7,0,0,1-1.84,1.87,6.58,6.58,0,0,1-1.38-2.6l-2.4-10.24A8.16,8.16,0,0,1,109.32,317.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,324.46a4.29,4.29,0,0,1-1.76-4.92,6.81,6.81,0,0,1,3.83-3.78,2.25,2.25,0,0,1,1-.25.89.89,0,0,1,.83.54,5.26,5.26,0,0,1,5.62-3.05,5.18,5.18,0,0,1,4.3,4.67,4.26,4.26,0,0,1,3.6.71,4,4,0,0,1,1.7,3.15,4.62,4.62,0,0,1,3.3,3.45c1.15,7.7-6.85,9.45-10.18,8.46A8.22,8.22,0,0,1,96,334.59C94.8,334.17,90.69,332.13,91,324.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,324.46a4.29,4.29,0,0,1-1.76-4.92,6.81,6.81,0,0,1,3.83-3.78,2.25,2.25,0,0,1,1-.25.89.89,0,0,1,.83.54,5.26,5.26,0,0,1,5.62-3.05,5.18,5.18,0,0,1,4.3,4.67,4.26,4.26,0,0,1,3.6.71,4,4,0,0,1,1.7,3.15,4.62,4.62,0,0,1,3.3,3.45c1.15,7.7-6.85,9.45-10.18,8.46A8.22,8.22,0,0,1,96,334.59C94.8,334.17,90.69,332.13,91,324.46Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.74,331.23a1.66,1.66,0,0,0,.39-2.33,1.55,1.55,0,0,0-.35-.37l.06,0a2.36,2.36,0,0,0-1.61-4.27,2.44,2.44,0,0,0-.42-1.14,2.37,2.37,0,0,0-3.3-.54,2.25,2.25,0,0,0-.62.65,1.67,1.67,0,0,0-2.66,1.28,1.67,1.67,0,0,0-2,2.28A2.45,2.45,0,0,0,102,330a1.63,1.63,0,0,0,.3,1.12,1.68,1.68,0,0,0,2,.57,2,2,0,0,0,.29.58,2.16,2.16,0,0,0,3,.5,2.21,2.21,0,0,0,.83-1.24A1.65,1.65,0,0,0,109.74,331.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.16,333c2-1.86-.1-3.7-.1-3.7.29-2.78-1.88-2.42-1.88-2.42-1-2.05-2.53-.18-2.53-.18l-2,.3-1.27,1.81a1.48,1.48,0,0,0,.13.21,2.44,2.44,0,0,0,2.46,1,1.63,1.63,0,0,0,.3,1.12,1.68,1.68,0,0,0,2,.57,2,2,0,0,0,.29.58A2.14,2.14,0,0,0,107.16,333Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.86,329.47a2.1,2.1,0,0,0-.13-3,2.12,2.12,0,0,0-1.12-.53,2.92,2.92,0,0,0-.93-2.52,2.89,2.89,0,0,0-1.39-.71,2.95,2.95,0,0,0-5.07-2.57,2.9,2.9,0,0,0-.59,1,2.09,2.09,0,0,0-2.93,2.25A2.08,2.08,0,0,0,92.12,327a2.07,2.07,0,0,0,.69.42,3.05,3.05,0,0,0,4.62,2.81l.09.09a2.09,2.09,0,0,0,2.25.38.8.8,0,0,0,.13.13,2.09,2.09,0,0,0,3.42-.95A2.1,2.1,0,0,0,105.86,329.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.86,329.47a2.1,2.1,0,0,0-.13-3,2.12,2.12,0,0,0-1.12-.53,2.92,2.92,0,0,0-.93-2.52,2.89,2.89,0,0,0-1.39-.71,2.95,2.95,0,0,0-5.07-2.57,2.9,2.9,0,0,0-.59,1,2.09,2.09,0,0,0-2.93,2.25A2.08,2.08,0,0,0,92.12,327a2.07,2.07,0,0,0,.69.42,3.05,3.05,0,0,0,4.62,2.81l.09.09a2.09,2.09,0,0,0,2.25.38.8.8,0,0,0,.13.13,2.09,2.09,0,0,0,3.42-.95A2.1,2.1,0,0,0,105.86,329.47Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.75,327.28s-.13-1.89-1.59-2.26c-2-.49-3.36,2.15-3.36,2.15s-2.62-1.4-3.84-.16a2.37,2.37,0,0,0-.17,2.86,3.07,3.07,0,0,0,3.64.37l.09.09a2.09,2.09,0,0,0,2.25.38.8.8,0,0,0,.13.13,2.09,2.09,0,0,0,3.42-.95,2.1,2.1,0,0,0,2.54-.42C107.11,326.69,102.75,327.28,102.75,327.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.24,327.94s3.29,3.93-.36,11.67c0,0,1.46,4.66,6.65,2.07,0,0-.2-8.14,6.81-10.46a1.47,1.47,0,0,0-.81-1.31s-3.09,2.67-4.06,2.11,2.4-3.1,2.4-3.1-.88-1.26-1.83-1.08c0,0-1.41,2.72-2.73,2.45s-.47-3.18-.47-3.18a1.77,1.77,0,0,0-1.85,0s.22,3-.44,3S96,327.27,96,327.27A1.74,1.74,0,0,0,94.24,327.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.24,327.94s3.29,3.93-.36,11.67c0,0,1.46,4.66,6.65,2.07,0,0-.2-8.14,6.81-10.46a1.47,1.47,0,0,0-.81-1.31s-3.09,2.67-4.06,2.11,2.4-3.1,2.4-3.1-.88-1.26-1.83-1.08c0,0-1.41,2.72-2.73,2.45s-.47-3.18-.47-3.18a1.77,1.77,0,0,0-1.85,0s.22,3-.44,3S96,327.27,96,327.27A1.74,1.74,0,0,0,94.24,327.94Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.53,341.68c-3-4.55-6.65-2.07-6.65-2.07S95.34,344.27,100.53,341.68Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.94,337.81s2-4.79,1.22-6.53S97.78,334.61,96.94,337.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.06,336.85s1.89-4.72,2.72-4.32S100.8,333.88,99.06,336.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,333.92s.57-3.1,1.11-2.92S99,333.92,99,333.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.57,338.21c0-1.85-1.88,1.21-2.24-.31-.2-.89-1.1-.38-1.81.19-.18.49-.4,1-.64,1.52,0,0,1.46,4.66,6.65,2.07a12.55,12.55,0,0,1,2.93-8h0C101.15,335.48,98.61,340.06,98.57,338.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.38,
    y: 322.86,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.38,
    y: 322.86,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.87,
    y: 322.86,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.87,
    y: 322.86,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.61,
    y: 327.23,
    width: 22.44,
    height: 5.73,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.61,
    y: 327.23,
    width: 22.44,
    height: 5.73,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.58,
    y: 336.15,
    width: 22.44,
    height: 5.73,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.58,
    y: 336.15,
    width: 22.44,
    height: 5.73,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.25,
    y: 322.86,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.25,
    y: 322.86,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.39,
    y: 322.86,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.39,
    y: 322.86,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.55,
    y: 322.86,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.55,
    y: 322.86,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.87,
    y: 327.23,
    width: 117.2,
    height: 5.73,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.87,
    y: 327.23,
    width: 117.2,
    height: 5.73,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.71,
    y: 336.15,
    width: 117.2,
    height: 5.73,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.71,
    y: 336.15,
    width: 117.2,
    height: 5.73,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.78,
    y: 260.04,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.78,
    y: 260.04,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.16,
    y: 260.04,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.16,
    y: 260.04,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.26,
    y: 273.59,
    width: 38.2,
    height: 5.73,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.26,
    y: 273.59,
    width: 38.2,
    height: 5.73,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.26,
    y: 264.58,
    width: 38.2,
    height: 5.73,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.26,
    y: 264.58,
    width: 38.2,
    height: 5.73,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.3,
    y: 260.04,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.3,
    y: 260.04,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.68,
    y: 260.04,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.68,
    y: 260.04,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.78,
    y: 273.59,
    width: 38.2,
    height: 5.73,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.78,
    y: 273.59,
    width: 38.2,
    height: 5.73,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.78,
    y: 264.58,
    width: 38.2,
    height: 5.73,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.78,
    y: 264.58,
    width: 38.2,
    height: 5.73,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.27,
    y: 260.04,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.27,
    y: 260.04,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.65,
    y: 260.04,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.65,
    y: 260.04,
    width: 4.61,
    height: 20.28,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.27,260V280h37V260Zm26.06,8a3,3,0,0,1-2.11.88h-10.6a3,3,0,1,1,0-6h10.6a3,3,0,0,1,2.11,5.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.27,260V280h37V260Zm26.06,8a3,3,0,0,1-2.11.88h-10.6a3,3,0,1,1,0-6h10.6a3,3,0,0,1,2.11,5.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.48,
    y: 280.29,
    width: 118.4,
    height: 9.96,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.48,
    y: 280.29,
    width: 118.4,
    height: 9.96,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boxes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.38,329.94a4,4,0,0,0-2,1.95,5.11,5.11,0,0,0-3,.09c-2.4,1-1.7,4.23-.49,5.95,1.08,1.54,3.43,4.14,5.35,3.57a2.87,2.87,0,0,0,1.36-1.69,2.35,2.35,0,0,0,2,.33c1.76-.93,1.63-4.44,1.32-6.29C67.55,331.77,65.83,329,63.38,329.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.38,329.94a4,4,0,0,0-2,1.95,5.11,5.11,0,0,0-3,.09c-2.4,1-1.7,4.23-.49,5.95,1.08,1.54,3.43,4.14,5.35,3.57a2.87,2.87,0,0,0,1.36-1.69,2.35,2.35,0,0,0,2,.33c1.76-.93,1.63-4.44,1.32-6.29C67.55,331.77,65.83,329,63.38,329.94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.22,332.23s-.49-2.41-2-2.86c0,0,0-.5.83-.55a7.6,7.6,0,0,1,1.6,3.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.22,332.23s-.49-2.41-2-2.86c0,0,0-.5.83-.55a7.6,7.6,0,0,1,1.6,3.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.48,332.43c.66,1.67,0,4.3-1.32,4.85s-1.72-.86-2.66-.47,0,2.4-1,2.8-1.94-1-2.46-.74c-.34.19-.37.75-.34,1.14,1.1,1,2.41,1.83,3.56,1.49a2.87,2.87,0,0,0,1.36-1.69,2.35,2.35,0,0,0,2,.33c1.76-.93,1.63-4.44,1.32-6.29A6.26,6.26,0,0,0,67.48,332.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,336.76s-1.15-3.18.1-3.65S57.85,334.48,58,336.76Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,328.82c-.78.05-.83.55-.83.55S60.15,329.41,60,328.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.92,334.52a4,4,0,0,0-2.61-.91,5.07,5.07,0,0,0-1.42-2.67c-2-1.7-4.54.34-5.56,2.19-.9,1.64-2.19,4.9-.84,6.37a2.89,2.89,0,0,0,2.12.47,2.36,2.36,0,0,0,.57,1.92c1.62,1.16,4.7-.5,6.23-1.59C108.12,339.07,109.84,336.3,107.92,334.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.92,334.52a4,4,0,0,0-2.61-.91,5.07,5.07,0,0,0-1.42-2.67c-2-1.7-4.54.34-5.56,2.19-.9,1.64-2.19,4.9-.84,6.37a2.89,2.89,0,0,0,2.12.47,2.36,2.36,0,0,0,.57,1.92c1.62,1.16,4.7-.5,6.23-1.59C108.12,339.07,109.84,336.3,107.92,334.52Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.91,333.59s2-1.51,1.67-3.1c0,0,.47-.17.86.51a7.55,7.55,0,0,1-2.21,2.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.91,333.59s2-1.51,1.67-3.1c0,0,.47-.17.86.51a7.55,7.55,0,0,1-2.21,2.87Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5,339.29c-1.2,1.34-3.86,1.91-4.93,1s0-1.92-.75-2.59-2.18,1-3,.32.07-2.19-.42-2.54c-.32-.21-.83,0-1.17.2-.44,1.44-.58,3,.23,3.86a2.89,2.89,0,0,0,2.12.47,2.36,2.36,0,0,0,.57,1.92c1.62,1.16,4.7-.5,6.23-1.59A6.8,6.8,0,0,0,107.5,339.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.43,332.72s2.36-2.44,3.33-1.52S101.41,331.56,99.43,332.72Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.44,331c-.39-.68-.86-.51-.86-.51S107,331.38,107.44,331Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.15,336.39a4,4,0,0,0-2.61-.91,5.14,5.14,0,0,0-1.42-2.68c-2-1.69-4.55.35-5.56,2.19-.9,1.65-2.19,4.91-.84,6.38a2.93,2.93,0,0,0,2.12.47,2.36,2.36,0,0,0,.57,1.92c1.62,1.16,4.7-.51,6.23-1.6C87.35,340.94,89.07,338.17,87.15,336.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.15,336.39a4,4,0,0,0-2.61-.91,5.14,5.14,0,0,0-1.42-2.68c-2-1.69-4.55.35-5.56,2.19-.9,1.65-2.19,4.91-.84,6.38a2.93,2.93,0,0,0,2.12.47,2.36,2.36,0,0,0,.57,1.92c1.62,1.16,4.7-.51,6.23-1.6C87.35,340.94,89.07,338.17,87.15,336.39Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M84.14,335.46s2-1.51,1.67-3.1c0,0,.47-.17.86.5a7.67,7.67,0,0,1-2.21,2.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.14,335.46s2-1.51,1.67-3.1c0,0,.47-.17.86.5a7.67,7.67,0,0,1-2.21,2.88Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.73,341.16c-1.2,1.33-3.86,1.91-4.93,1s0-1.92-.75-2.6-2.18,1-3,.33.07-2.19-.42-2.54c-.32-.22-.83,0-1.17.2-.44,1.44-.58,3,.23,3.86a2.93,2.93,0,0,0,2.12.47,2.36,2.36,0,0,0,.57,1.92c1.62,1.16,4.7-.51,6.23-1.6A6.3,6.3,0,0,0,86.73,341.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.66,334.59S81,332.15,82,333.07,80.64,333.43,78.66,334.59Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.67,332.86c-.39-.67-.86-.5-.86-.5S86.21,333.25,86.67,332.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.48,331.53a4,4,0,0,0-2.76.27A5.06,5.06,0,0,0,71.31,330c-2.52-.71-4,2.2-4.13,4.31-.13,1.87.06,5.37,1.9,6.14a2.91,2.91,0,0,0,2.13-.46c.33.79.82,1.41,1.31,1.5,2,.38,4.07-2.42,5-4C78.56,335.58,79,332.35,76.48,331.53Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.48,331.53a4,4,0,0,0-2.76.27A5.06,5.06,0,0,0,71.31,330c-2.52-.71-4,2.2-4.13,4.31-.13,1.87.06,5.37,1.9,6.14a2.91,2.91,0,0,0,2.13-.46c.33.79.82,1.41,1.31,1.5,2,.38,4.07-2.42,5-4C78.56,335.58,79,332.35,76.48,331.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.35,332s1.14-2.19.22-3.51c0,0,.36-.36,1,.09a7.74,7.74,0,0,1-.81,3.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.35,332s1.14-2.19.22-3.51c0,0,.36-.36,1,.09a7.74,7.74,0,0,1-.81,3.54Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.09,336.05c-.53,1.71-2.71,3.34-4.08,2.93s-.79-1.75-1.77-2.05-1.55,1.85-2.56,1.54-.85-2-1.44-2.13c-.38-.06-.76.36-1,.67.2,1.49.71,2.94,1.82,3.41a2.91,2.91,0,0,0,2.13-.46c.33.79.82,1.41,1.31,1.5,2,.38,4.07-2.42,5-4A7.31,7.31,0,0,0,78.09,336.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,333.45s1.12-3.2,2.39-2.77S69.32,331.57,68,333.45Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.57,328.53c-.64-.45-1-.09-1-.09S74.3,329.08,74.57,328.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2,330.71A4,4,0,0,0,89,332.44a5.18,5.18,0,0,0-3-.21c-2.49.8-2.12,4-1.09,5.87.92,1.64,3,4.46,5,4.1.5-.1,1.08-.73,1.53-1.56a2.31,2.31,0,0,0,1.92.54c1.85-.76,2.07-4.26,2-6.13C95.16,333,93.73,330,91.2,330.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.2,330.71A4,4,0,0,0,89,332.44a5.18,5.18,0,0,0-3-.21c-2.49.8-2.12,4-1.09,5.87.92,1.64,3,4.46,5,4.1.5-.1,1.08-.73,1.53-1.56a2.31,2.31,0,0,0,1.92.54c1.85-.76,2.07-4.26,2-6.13C95.16,333,93.73,330,91.2,330.71Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.81,332.77s-.24-2.45-1.74-3.06c0,0,.1-.49.88-.46a7.59,7.59,0,0,1,1.27,3.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.81,332.77s-.24-2.45-1.74-3.06c0,0,.1-.49.88-.46a7.59,7.59,0,0,1,1.27,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,333.6c.5,1.72-.42,4.28-1.8,4.68s-1.62-1-2.6-.73-.28,2.39-1.29,2.69-1.83-1.22-2.38-1c-.35.15-.43.71-.45,1.1,1,1.13,2.21,2.07,3.39,1.85.5-.1,1.08-.73,1.53-1.56a2.31,2.31,0,0,0,1.92.54c1.85-.76,2.07-4.26,2-6.13A6,6,0,0,0,95,333.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.17,337s-.82-3.28.48-3.62S85.23,334.67,85.17,337Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,329.25c-.78,0-.88.46-.88.46S88,329.85,88,329.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.91,329.56a4,4,0,0,0-2.16,1.74,5.11,5.11,0,0,0-3-.22c-2.49.8-2.12,4-1.09,5.88.92,1.63,3,4.45,5,4.09.5-.1,1.08-.73,1.53-1.55a2.33,2.33,0,0,0,1.92.53c1.85-.76,2.07-4.26,2-6.13C101.87,331.8,100.44,328.88,97.91,329.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.91,329.56a4,4,0,0,0-2.16,1.74,5.11,5.11,0,0,0-3-.22c-2.49.8-2.12,4-1.09,5.88.92,1.63,3,4.45,5,4.09.5-.1,1.08-.73,1.53-1.55a2.33,2.33,0,0,0,1.92.53c1.85-.76,2.07-4.26,2-6.13C101.87,331.8,100.44,328.88,97.91,329.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.52,331.62s-.24-2.45-1.74-3.06c0,0,.1-.49.88-.46a7.59,7.59,0,0,1,1.27,3.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.52,331.62s-.24-2.45-1.74-3.06c0,0,.1-.49.88-.46a7.59,7.59,0,0,1,1.27,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.73,332.45c.5,1.72-.42,4.28-1.8,4.69s-1.62-1-2.6-.74-.28,2.39-1.29,2.69-1.83-1.22-2.38-1c-.35.15-.43.71-.45,1.1,1,1.13,2.21,2.07,3.39,1.85.5-.1,1.08-.73,1.53-1.55a2.33,2.33,0,0,0,1.92.53c1.85-.76,2.07-4.26,2-6.13A6,6,0,0,0,101.73,332.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.88,335.81s-.82-3.29.48-3.63S91.94,333.52,91.88,335.81Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.66,328.1c-.78,0-.88.46-.88.46S94.74,328.7,94.66,328.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.94,335.8a41.51,41.51,0,0,0,6,.28,11,11,0,0,0,4.2-.94l0,.76a55.86,55.86,0,0,0,6.79.55,21.64,21.64,0,0,0,4.11-.32l.16-.68a7.41,7.41,0,0,0,3,.84,5.93,5.93,0,0,0,3-.83l.09.73a18.81,18.81,0,0,0,3.58.15,11.13,11.13,0,0,0,3.3-.67l.15.44a43,43,0,0,0,10.69.11l.08-1.15a14.38,14.38,0,0,0,3.24,1.19,10.2,10.2,0,0,0,3.42-.5,3.09,3.09,0,0,1-.41,2.4l-50.39-.23A6.43,6.43,0,0,1,56.94,335.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.44,
    y: 336.68,
    width: 55.58,
    height: 38.48,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 336.68,
    width: 5.5,
    height: 7.33,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.03 336.68 67.05 336.68 67.05 338.51 72.14 350.73 111.03 350.73 111.03 336.68",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.05 336.68 63.99 336.68 63.99 344.01 58.5 344.01 58.5 336.68 55.44 336.68 55.44 375.16 67.05 375.16 67.05 336.68",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.44 336.68 67.05 336.68 61.96 348.89 50.34 348.89 55.44 336.68",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.03 336.68 67.05 336.68 72.14 348.89 116.13 348.89 111.03 336.68",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.92,
    y: 375.16,
    width: 55.55,
    height: 37.97,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.97,
    y: 375.16,
    width: 5.5,
    height: 7.33,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.47 375.16 100.47 382.49 94.97 382.49 94.97 375.16 91.92 375.16 91.92 413.03 103.53 413.03 103.53 375.16 100.47 375.16",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 375.16,
    width: 55.55,
    height: 37.97,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 375.16,
    width: 55.55,
    height: 37.97,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.55,
    y: 375.16,
    width: 5.5,
    height: 7.33,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.05 375.16 51.05 382.49 45.55 382.49 45.55 375.16 42.5 375.16 42.5 413.03 54.1 413.03 54.1 375.16 51.05 375.16",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Poster--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.3,
    y: 64.65,
    width: 1.73,
    height: 8.54,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.3,
    y: 64.65,
    width: 1.73,
    height: 8.54,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.41,
    y: 64.65,
    width: 1.73,
    height: 8.54,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.41,
    y: 64.65,
    width: 1.73,
    height: 8.54,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.55 157.72 123.78 157.72 123.12 74.25 178.89 74.25 179.55 157.72",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.8 85.38 155.68 78.73 158.75 87.72 167.44 85.2 165.71 94.13 174.88 96.41 168.81 102.88 176.02 109.35 167.24 111.63 170.54 120.56 161.4 118.04 159.91 127.03 152.87 120.38 146.99 127.03 143.92 118.04 135.23 120.56 136.97 111.63 127.78 109.35 133.86 102.88 126.65 96.41 135.43 94.13 132.13 85.2 141.27 87.72 142.76 78.73 149.8 85.38",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.11,94.42a2.16,2.16,0,0,1,.7,1.87,2.61,2.61,0,0,1-.48,1.38,2.91,2.91,0,0,1-1.22,1,4.57,4.57,0,0,1-1.94.37,6.47,6.47,0,0,1-1.71-.23,3.9,3.9,0,0,1-1.39-.66l.86-1.47a3.28,3.28,0,0,0,1,.55,4,4,0,0,0,1.25.2,2.07,2.07,0,0,0,1.16-.29,1,1,0,0,0,.47-.79.83.83,0,0,0-.37-.81,2.91,2.91,0,0,0-1.48-.27h-2.12l.75-4.67h5.07l-.11,1.54h-3.46l-.25,1.58h.68A3.76,3.76,0,0,1,145.11,94.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.15,98.53A3.05,3.05,0,0,1,147,97.06a5.24,5.24,0,0,1-.3-2.31,5.69,5.69,0,0,1,.62-2.3A3.78,3.78,0,0,1,148.69,91a3.55,3.55,0,0,1,1.87-.51,3.17,3.17,0,0,1,1.8.51,3,3,0,0,1,1.16,1.48,5,5,0,0,1,.29,2.3,5.62,5.62,0,0,1-.62,2.31,3.8,3.8,0,0,1-1.36,1.47A3.56,3.56,0,0,1,150,99,3.21,3.21,0,0,1,148.15,98.53Zm3.16-1.76a3.89,3.89,0,0,0,.57-2,3.47,3.47,0,0,0-.29-2,1.25,1.25,0,0,0-1.14-.66,1.46,1.46,0,0,0-1.23.66,3.82,3.82,0,0,0-.57,2,3.52,3.52,0,0,0,.29,2,1.23,1.23,0,0,0,1.13.65A1.49,1.49,0,0,0,151.31,96.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.2,94.46a2.22,2.22,0,0,1-.45-1.66,2.53,2.53,0,0,1,.69-1.67,2.08,2.08,0,0,1,1.53-.62,1.8,1.8,0,0,1,1.44.62,2.23,2.23,0,0,1,.45,1.67,2.53,2.53,0,0,1-.69,1.66,2.07,2.07,0,0,1-1.52.62A1.83,1.83,0,0,1,155.2,94.46Zm2.17-.68a1.81,1.81,0,0,0,.3-1,1.66,1.66,0,0,0-.16-1,.68.68,0,0,0-.61-.33.78.78,0,0,0-.65.34,1.8,1.8,0,0,0-.31,1,1.61,1.61,0,0,0,.17,1,.66.66,0,0,0,.61.34A.79.79,0,0,0,157.37,93.78Zm4.54-3.18h1.41l-6.26,8.3h-1.41ZM161,98.72a1.68,1.68,0,0,1-.67-.81,2.56,2.56,0,0,1-.18-1.2,2.76,2.76,0,0,1,.35-1.21,2.07,2.07,0,0,1,.78-.8,2.12,2.12,0,0,1,1.08-.28,1.83,1.83,0,0,1,1.45.62,2.25,2.25,0,0,1,.45,1.67,2.53,2.53,0,0,1-.69,1.66A2,2,0,0,1,162,99,2,2,0,0,1,161,98.72Zm1.77-1a1.8,1.8,0,0,0,.3-1,1.63,1.63,0,0,0-.17-1,.65.65,0,0,0-.61-.34.81.81,0,0,0-.65.33,1.81,1.81,0,0,0-.3,1,1.57,1.57,0,0,0,.16,1,.7.7,0,0,0,.61.33A.78.78,0,0,0,162.73,97.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.9,110.73a3.71,3.71,0,0,1-1.51-1.53A4.06,4.06,0,0,1,139,107a4.42,4.42,0,0,1,.75-2.2,4.61,4.61,0,0,1,1.73-1.54,5.1,5.1,0,0,1,2.37-.55,4.58,4.58,0,0,1,2.28.55,3.88,3.88,0,0,1,1.52,1.54A3.93,3.93,0,0,1,148,107a4.3,4.3,0,0,1-.75,2.2,4.57,4.57,0,0,1-1.73,1.53,5,5,0,0,1-2.36.56A4.65,4.65,0,0,1,140.9,110.73Zm3.76-1.42a2.63,2.63,0,0,0,1-.94,2.88,2.88,0,0,0,.44-1.37,2.61,2.61,0,0,0-.24-1.38,2.24,2.24,0,0,0-.86-.94,2.48,2.48,0,0,0-1.31-.34,2.75,2.75,0,0,0-2.35,1.28,2.91,2.91,0,0,0-.43,1.38,2.57,2.57,0,0,0,.24,1.37,2.18,2.18,0,0,0,.86.94,2.48,2.48,0,0,0,1.31.34A2.71,2.71,0,0,0,144.66,109.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.58,104.39l-.15,2.19h3.84l-.11,1.54h-3.84l-.22,3h-1.92l.59-8.3H156l-.11,1.54Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.16,104.39l-.16,2.19h3.84l-.11,1.54h-3.84l-.21,3h-1.92l.59-8.3h6.27l-.11,1.54Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.83,148.93a17,17,0,0,1-20.79-.05,17.39,17.39,0,0,1-3-3,17,17,0,0,1-2.79-5.41h0a17,17,0,1,1,32.85-8.22c0,.27.1.55.14.83a17.06,17.06,0,0,1-1.34,9.45c-.1.22-.2.44-.31.65A16.83,16.83,0,0,1,161.83,148.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.81,133.61c-.53-4.53,3.12-10.06,7.49-13.05a20.58,20.58,0,0,1,14.55-2.84A13.56,13.56,0,0,1,166,126.53c.47,1.49-.43,3.42-1.28,4.74a5.57,5.57,0,0,1-3.83,2.46c.08,1-1.4,1.74-2.36,1.79a4.57,4.57,0,0,1-2.66-1,9.2,9.2,0,0,0-2.48-1.43c.21.8-.68,1.4-1.5,1.53a4.19,4.19,0,0,1-2.37-.55,5.21,5.21,0,0,0-2.34-.7c.43.71-.51,1.4-1.34,1.52a8.05,8.05,0,0,1-2.46-.39,5,5,0,0,0-5.25,2.72,1.71,1.71,0,0,1-2.58-1.08,1.49,1.49,0,0,1-2-.43C133.17,135.09,133.15,134,133.81,133.61Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.45,133.26a5.43,5.43,0,0,1-1.53.47c.08.93-1.31,1.69-2.27,1.78h-.09a4.57,4.57,0,0,1-2.66-1h0a9.26,9.26,0,0,0-2.47-1.42c.21.79-.68,1.4-1.5,1.53a3.56,3.56,0,0,1-2-.38l-.39-.17c-.27-.13-.55-.26-.83-.37a3.49,3.49,0,0,0-1.51-.33c.43.71-.51,1.4-1.34,1.52a8.37,8.37,0,0,1-2.46-.39,4.64,4.64,0,0,0-2,.1,5.17,5.17,0,0,0-1.35.57,4.87,4.87,0,0,0-1.87,2.05,1.71,1.71,0,0,1-2.58-1.08,1.49,1.49,0,0,1-2-.43c-.4-.65-.42-1.75.24-2.13-.53-4.53,3.12-10.05,7.49-13.05a20.58,20.58,0,0,1,14.55-2.84A13.56,13.56,0,0,1,166,126.53a3.79,3.79,0,0,1-.07,2.18,9.1,9.1,0,0,1-1,2.28h0c0,.09-.11.18-.17.27a5,5,0,0,1-.95,1.1A5.54,5.54,0,0,1,162.45,133.26Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138,145.7a.17.17,0,0,1-.14,0,7.24,7.24,0,0,1-.42-.61l.22.11a1.93,1.93,0,0,0,.3.27C138,145.48,138,145.69,138,145.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.13,146.16l0,0S147.13,146.13,147.13,146.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.62,136.69l.07,0h0C165.72,136.71,165.61,136.75,165.62,136.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.13,146.16l0,0S147.13,146.13,147.13,146.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.8,124.63a1.27,1.27,0,0,1,.61.05,11.14,11.14,0,0,1,3.2,1.34,6.06,6.06,0,0,1,2.26,2.58,7.93,7.93,0,0,0,.94,2.07c.25.3.62.69,1,.52a5.46,5.46,0,0,0-1.21-4.08,13.19,13.19,0,0,0-4.82-4.14,3.33,3.33,0,0,0-2,1.56C136.8,124.52,136.72,124.64,136.8,124.63Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.17,125.79a1.57,1.57,0,0,0-.14-.92l-.54-1.43c-.38-1-.65-2.12-1.62-2.64a5.25,5.25,0,0,0-1.34-1.69.78.78,0,0,1-.39-.65,2.4,2.4,0,0,0-1.58.27c-.2.11-.41.32-.33.54a2.22,2.22,0,0,1,1,.4,4.85,4.85,0,0,1,1,1c1.06,1.28,2.08,2.61,3,4,0,0,.1.1.15.07s0-.12,0,0a2.89,2.89,0,0,0,.31,1,.9.9,0,0,0,.27.46C149,126.15,149.12,126,149.17,125.79Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.22,134.32a10,10,0,0,1-.91-2.12c-.26-.72-.37-1.6-1.05-2a.83.83,0,0,1-.31-1,1.46,1.46,0,0,1,.81-.75,4.67,4.67,0,0,1,1.5,2.8c.11.35.21.7.32,1.05a6.31,6.31,0,0,1,.37,2.22c0,.23-.31.22-.51.12S136.35,134.5,136.22,134.32Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.4,117.28a2.65,2.65,0,0,1,1.6,1,8.09,8.09,0,0,1,.93,1.68q.94,2.13,1.91,4.27a1.47,1.47,0,0,0,.64.82c.08-.06.43-.24.51-.31a8.77,8.77,0,0,1-1.2-2.13c-.39-1-.59-2.12-1-3.14a7.65,7.65,0,0,0-1.08-1.91,2.15,2.15,0,0,0-2.24-.58c-.09,0-.19.08-.2.18s.1.17.2.17S153.33,117.35,153.4,117.28Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.34,119.77c.07-.09.2,0,.27.07a8.71,8.71,0,0,1,1.57,4.28c.28,1.51.7,3.14,1.91,4.09.1,0,.18-.14.18-.24a.52.52,0,0,0-.15-.27,8.16,8.16,0,0,1-.81-1c-.66-1.18-.33-2.64-.5-4a5.18,5.18,0,0,0-.83-2.2c-.37-.55-.72-1.17-1.38-1.28a.61.61,0,0,0-.33,0C160.16,119.28,160.3,119.66,160.34,119.77Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.62,151.66a9,9,0,0,0-2.2-.21,7.22,7.22,0,0,1-1.23,0,4.68,4.68,0,0,1-1.33-.55,2.32,2.32,0,0,1-.91-.72l.27-.22.52.14a10.26,10.26,0,0,0,2,.29,6.43,6.43,0,0,1,3,.45c.15.09.36.18.46.05C158.2,151.18,157.94,151.73,157.62,151.66Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.15,138.48a.19.19,0,0,1,.1.19,6.89,6.89,0,0,0-.64.4,7.09,7.09,0,0,1-1.4.64,3.53,3.53,0,0,1-.72.22.81.81,0,0,1-.63-.12c-.18-.13,0-.44.11-.6a5.18,5.18,0,0,0,3.46-1.69c.1-.1.19-.32,0-.35,0,.2.34.47.33.66a.47.47,0,0,1-.19.31C168.42,138.31,168.35,138.31,168.15,138.48Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.9,132.47a9.34,9.34,0,0,0-.57-1.58c-.26-.55-.85-.9-1-1.5a1.39,1.39,0,0,0-.24-.59.48.48,0,0,0-.57-.17c-.19.1-.26.79-.05.87a6.63,6.63,0,0,1,.83,1.69c.09.6.17,1.4.24,2.17A5.54,5.54,0,0,0,163.9,132.47Zm2.16-3.66-.1-.08c-.31.79-.62,1.57-.94,2.36A9.1,9.1,0,0,0,166.06,128.81Zm-9.85,1q-1.46-2.78-2.92-5.55c-.39-.74-1.39-2.1-1.27-2.23a.79.79,0,0,0-1,.19,2.74,2.74,0,0,0,.57,1.37c1.59,2,2.24,4.58,3.11,7a41.79,41.79,0,0,1,1.24,4h0a4.57,4.57,0,0,0,2.66,1h.09l-.09-.28A32.05,32.05,0,0,0,156.21,129.84Zm-7,2.1a.62.62,0,0,0-.42.6c0,.43.05.86.07,1.29.28.11.56.24.83.37l.39.17-.09-2.15A.78.78,0,0,0,149.17,131.94Zm-10-.25c-.27.09-.63.43-.53.71a20.19,20.19,0,0,0,1.54,2.9,5.17,5.17,0,0,1,1.35-.57A25.74,25.74,0,0,0,139.12,131.69Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64,149c0-.08,0-.18-.07-.25s-.18-.42-.36-.54c-1.72-1.25-5.4-1.75-7.5-1.44a21.25,21.25,0,0,0,3-1.92,14.65,14.65,0,0,0,1.61-1.44c-.15.12,1.67,1.07,2.93,1.18a9.54,9.54,0,0,0,3.21-.47c.45-.12,1.65-.09,1.72-.55a1.52,1.52,0,0,0,.45-.36c.21-.23.36-.49.31-.65s-.09-.12-.21-.13a13.84,13.84,0,0,1-1.77.35c-1-.09-1.94.08-2.91,0a2,2,0,0,1-2-1.28c.29-.29.68-.51.82-.89a2.31,2.31,0,0,1,1.22-1.39,27.31,27.31,0,0,0,3.95-2c.51-.25.56-.59.68-1.14-.31.16-.7.49-1,.68h0c0,.05-.08.09-.07,0l.07,0s-.1,0-.15,0c-.92.28-1.9.69-2.81,1a6.51,6.51,0,0,0,1.2-1.77c.12-.26.35-.32.6-.48.48-.29,1.29-.72,1.79-1s1-.95,1.64-1.2a1.48,1.48,0,0,0,.29-.12c0-.28-.09-.56-.14-.83a.11.11,0,0,0-.11.06,3.34,3.34,0,0,1-1.8,1.21c-.43.17-.79.4-1.23.56a7.1,7.1,0,0,0,1.12-4.38.62.62,0,0,0-.13-1,9.1,9.1,0,0,1-1,2.28h0c-.31.78-.63,1.56-.94,2.35a7.71,7.71,0,0,0-.18-1,5.54,5.54,0,0,1-1.35.89c.06.61.13,1.2.2,1.68a11.94,11.94,0,0,1-2.82,4.17c-.44-1.16-.82-2.4-1.18-3.6h-.09a4.57,4.57,0,0,1-2.66-1h0a23.41,23.41,0,0,1,.78,6.74c-1.93,2-4.84,3-7.56,3.77.22-.82.4-1.64.55-2.47a10.65,10.65,0,0,0,2.87-3.39,5.36,5.36,0,0,1,.4-.69c.23-.31.54-.57.75-.9a1.08,1.08,0,0,0,.14-1.11,1,1,0,0,0-.83.53c-.14.29.08.45-.13.7-.81,1-1.66,1.9-2.54,2.81a1.24,1.24,0,0,0-.39.62,1.22,1.22,0,0,1-.1.33c.12-.9.19-1.8.22-2.7,0-1.18,0-2.37-.07-3.55,0-.32,0-.64,0-1l-.39-.17c-.27-.13-.55-.26-.83-.37a19.53,19.53,0,0,1-.15,3.9c-.42,2.66-.84,5.31-1.47,7.93a23.45,23.45,0,0,1-4.3.61,4.86,4.86,0,0,0,.28-1.66c0-1.18.11-2.37.16-3.56a10.38,10.38,0,0,0-.16-3,8.78,8.78,0,0,0-1.13-2.4c-.18-.29-.37-.59-.57-.87a5.17,5.17,0,0,0-1.35.57c.12.22.23.43.33.65a7.4,7.4,0,0,1,.77,2.7,5.09,5.09,0,0,1-.06.87q-.36,2.7-.74,5.4a1.32,1.32,0,0,0,.18,1.14l.09.1a9.43,9.43,0,0,1-3-.89,1.72,1.72,0,0,1-.33-.51c-.11-.28-.15-.58-.24-.88-.13-.46-.36-.89-.53-1.34a11.19,11.19,0,0,1-.54-3.69c-.22,0-.49-.08-.6.11a1.39,1.39,0,0,0-.14.64,6,6,0,0,0,0,.95h0a9.93,9.93,0,0,0,.67,2.77,6,6,0,0,0,.43.93,32.58,32.58,0,0,0,2.75,3.6,5.23,5.23,0,0,0,1.93,1.12,7.59,7.59,0,0,0,1.57.35,7,7,0,0,0,2.39,1.31l2,.73c.14.2.46.17.7.21l3,.59c.33.06.73-.16.66-.49a25.72,25.72,0,0,1-6.33-2.21l-.16-.09a20,20,0,0,0,6.95-1.64,9.85,9.85,0,0,0,3.07.33,23.08,23.08,0,0,1,6.21,1.2l.42-.13A.29.29,0,0,0,161.64,149Zm-14.55-2.82s0,0,0,0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.47,137.17a.32.32,0,0,0,.06.18C168.56,137.27,168.56,137.19,168.47,137.17Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.53,137.35a.48.48,0,0,1-.1.17l-.15.12a17.13,17.13,0,0,0,0-4.58c0-.28-.09-.56-.14-.83a17.08,17.08,0,0,0-2-5.23,2.46,2.46,0,0,0-.1-.47h0a11.19,11.19,0,0,0-1-2.24l-.09-.16-.16-.27a13.08,13.08,0,0,0-2.6-3c-.07-.13-.14-.26-.22-.38-.37-.55-.72-1.17-1.37-1.28a.64.64,0,0,0-.34,0c-.05,0-.05.12,0,.23a14.15,14.15,0,0,0-3.79-1.58l-.61-.15h0s-.06-.1-.1-.14a2.15,2.15,0,0,0-2.24-.58c-.09,0-.19.08-.2.18s.1.17.2.17-.14,0-.07-.06a2.35,2.35,0,0,1,.55.17,21.75,21.75,0,0,0-8.78,1.19.48.48,0,0,1,0-.18,2.4,2.4,0,0,0-1.58.27c-.2.11-.41.32-.33.54a.88.88,0,0,1,.23.07,15.51,15.51,0,0,0-2.16,1.22,18.74,18.74,0,0,0-3,2.55,3.59,3.59,0,0,0-1.6,1.42c.07,0,0,.11.07.1a.81.81,0,0,1,.22,0,17.76,17.76,0,0,0-2.32,3.9,1.43,1.43,0,0,0-.75.72.87.87,0,0,0,.18.89,9.28,9.28,0,0,0-.32,3.48,1,1,0,0,0-.44.6,2,2,0,0,0,.2,1.53,1.43,1.43,0,0,0,1,.62,16.87,16.87,0,0,0,.71,4.09h0a9.93,9.93,0,0,0,.67,2.77,6,6,0,0,0,.43.93,32.58,32.58,0,0,0,2.75,3.6,5.23,5.23,0,0,0,1.93,1.12,17,17,0,0,0,15.9,2.67c.22,0,.45.06.68.11s.46-.28.55-.58a17,17,0,0,0,3.66-2.15,16.83,16.83,0,0,0,4.77-5.77c.21-.23.36-.49.31-.65a16.53,16.53,0,0,0,1.19-3.75l.15-.09a.19.19,0,0,0-.1-.19c.2-.17.27-.17.46-.34a.47.47,0,0,0,.19-.31C168.8,137.69,168.63,137.51,168.53,137.35Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.12,
    y: 70.71,
    width: 55.77,
    height: 3.54,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cart--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.52,330l-.29-2.16L335.92,330l.28,2.16a3,3,0,0,0-2.38,3.36l3.23,24.33a3,3,0,0,0,3.36,2.6l16-2.17a3,3,0,0,0,2.56-3.4l-3.23-24.34A3,3,0,0,0,352.52,330Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.52,330l-.29-2.16L335.92,330l.28,2.16a3,3,0,0,0-2.38,3.36l3.23,24.33a3,3,0,0,0,3.36,2.6l16-2.17a3,3,0,0,0,2.56-3.4l-3.23-24.34A3,3,0,0,0,352.52,330Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.87 343.6 340.39 345.16 339.57 339.02 351.06 337.46 351.87 343.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,328.49l-19.69,2.67-.21-1.59a1.28,1.28,0,0,1,1.08-1.44l17.19-2.33a1.26,1.26,0,0,1,1.42,1.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,328.49l-19.69,2.67-.21-1.59a1.28,1.28,0,0,1,1.08-1.44l17.19-2.33a1.26,1.26,0,0,1,1.42,1.09Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.93,356.89l-3.23-24.34a3,3,0,0,0-3.18-2.6l-.16-1.24,1.68-.22-.21-1.6a1.26,1.26,0,0,0-1.42-1.09l-17.19,2.33a1.28,1.28,0,0,0-1.08,1.44l.21,1.59,1.69-.23.16,1.24a3,3,0,0,0-2.38,3.36l3.23,24.33a3,3,0,0,0,3.36,2.6l16-2.17A3,3,0,0,0,358.93,356.89Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.16,293.75l-.29-2.16-16.32,2.22.29,2.16a3,3,0,0,0-2.38,3.36l3.23,24.33a3,3,0,0,0,3.36,2.6L379,324.09a3,3,0,0,0,2.56-3.4l-3.23-24.34A3,3,0,0,0,375.16,293.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.16,293.75l-.29-2.16-16.32,2.22.29,2.16a3,3,0,0,0-2.38,3.36l3.23,24.33a3,3,0,0,0,3.36,2.6L379,324.09a3,3,0,0,0,2.56-3.4l-3.23-24.34A3,3,0,0,0,375.16,293.75Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.51 307.39 363.02 308.96 362.21 302.82 373.69 301.26 374.51 307.39",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.68,292.29,357,295l-.21-1.59a1.28,1.28,0,0,1,1.08-1.44l17.19-2.33a1.26,1.26,0,0,1,1.42,1.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.68,292.29,357,295l-.21-1.59a1.28,1.28,0,0,1,1.08-1.44l17.19-2.33a1.26,1.26,0,0,1,1.42,1.09Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.56,320.69l-3.23-24.34a3,3,0,0,0-3.17-2.6l-.17-1.23,1.69-.23-.21-1.6a1.26,1.26,0,0,0-1.42-1.09l-17.19,2.33a1.28,1.28,0,0,0-1.08,1.44L357,295l1.69-.23.16,1.24a3,3,0,0,0-2.38,3.36l3.23,24.33a3,3,0,0,0,3.36,2.6L379,324.09A3,3,0,0,0,381.56,320.69Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.67,340.09c-1.54-3.35-5.77-12-9.36-11.34l-11.92,2.12c-3.59.64-4.66,10.22-5,13.9-.2,2.35.85,7.55,1.68,11.17a4.15,4.15,0,0,0,4.77,3.18l18.6-3.31a4.2,4.2,0,0,0,3.41-4.64C384.43,347.48,383.66,342.23,382.67,340.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.76,342.21c-1.54-3.35-5.77-12-9.37-11.34s-4.66,10.22-5,13.9c-.2,2.35.85,7.55,1.68,11.17a4.15,4.15,0,0,0,4.77,3.18l6.69-1.19a4.2,4.2,0,0,0,3.41-4.64C372.51,349.6,371.75,344.35,370.76,342.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.31 328.75 361.39 330.87 360.81 327.5 372.72 325.38 373.31 328.75",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.34 345.41 373.52 346.98 372.8 342.85 381.63 341.28 382.34 345.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.31 328.75 361.39 330.87 360.81 327.5 372.72 325.38 373.31 328.75",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.87,351.17c-.44-3.69-1.21-8.94-2.2-11.08-1.54-3.35-5.77-12-9.36-11.34l-.81.14.81-.14-.59-3.37-11.91,2.12.58,3.37h0c-3.59.64-4.66,10.22-5,13.9,0,.14,0,.3,0,.47a43.69,43.69,0,0,0,1.13,8.08l.18.87c.1.47.2.93.3,1.37l.09.38c0,.09.06.16.08.25a4.14,4.14,0,0,0,4.69,2.93l3.92-.7,14.68-2.61A4.2,4.2,0,0,0,384.87,351.17ZM371.73,329l-.45.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.72,337.84c-1.27-3.46-4.81-12.41-8.44-12.06l-12,1.14c-3.64.35-5.46,9.8-6.07,13.45-.39,2.32.24,7.59.78,11.27a4.16,4.16,0,0,0,4.5,3.56l18.8-1.79a4.19,4.19,0,0,0,3.77-4.35C407.87,345.35,407.53,340.06,406.72,337.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.67,339c-1.26-3.47-4.8-12.42-8.43-12.07s-5.46,9.8-6.07,13.45c-.39,2.32.24,7.59.78,11.27a4.16,4.16,0,0,0,4.5,3.56l6.76-.64a4.19,4.19,0,0,0,3.77-4.35C395.83,346.49,395.49,341.2,394.67,339Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.28 325.77 386.24 326.92 385.92 323.51 397.96 322.37 398.28 325.77",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.96 343.12 397.04 343.97 396.66 339.79 405.57 338.94 405.96 343.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.28 325.77 386.24 326.92 385.92 323.51 397.96 322.37 398.28 325.77",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.72,337.84c-1.27-3.46-4.81-12.41-8.44-12.06l-.32-3.41-12,1.15.32,3.4,4.93-.47-4.93.47h0a2.14,2.14,0,0,0-.66.17,5.13,5.13,0,0,0-2.24,2.37c-.16.28-.31.59-.46.91a40.8,40.8,0,0,0-2.58,9.25c-.05.27-.09.52-.13.75-.35,2.07.12,6.49.61,10,.05.42.11.84.17,1.24a4,4,0,0,0,.22.84,4.15,4.15,0,0,0,4.28,2.72h0l6.76-.64h0l12-1.15a4.19,4.19,0,0,0,3.77-4.35C407.87,345.35,407.53,340.06,406.72,337.84Zm-9-12-6.16.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.88,308.42c-.94-3.57-3.63-12.82-7.28-12.82H389.5c-3.65,0-6.34,9.25-7.28,12.82-.61,2.28-.46,7.58-.27,11.29a4.18,4.18,0,0,0,4.16,4H405a4.16,4.16,0,0,0,4.15-4C409.34,316,409.48,310.7,408.88,308.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.79,308.42c-1-3.57-3.64-12.82-7.29-12.82s-6.34,9.25-7.28,12.82c-.61,2.28-.46,7.58-.27,11.29a4.18,4.18,0,0,0,4.16,4h6.79a4.17,4.17,0,0,0,4.15-4C397.25,316,397.39,310.7,396.79,308.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.5,
    y: 292.18,
    width: 12.09,
    height: 3.42,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.68,
    y: 309.41,
    width: 8.96,
    height: 4.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.5,
    y: 292.18,
    width: 12.09,
    height: 3.42,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.88,308.42c-.94-3.57-3.63-12.82-7.28-12.82v-3.42H389.5v3.42h0a3,3,0,0,0-1.95.88,8.72,8.72,0,0,0-1.17,1.38c-2,3-3.52,8.1-4.16,10.56a8.84,8.84,0,0,0-.2,1,25.64,25.64,0,0,0-.2,2.58V312c0,.72,0,1.49,0,2.27h0c0,1.85.09,3.78.17,5.4a4.19,4.19,0,0,0,3.35,3.89,3.59,3.59,0,0,0,.81.08H405a4.16,4.16,0,0,0,4.15-4C409.34,316,409.48,310.7,408.88,308.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.41,306c-.94-3.57-3.64-12.81-7.29-12.81H346c-3.65,0-6.34,9.24-7.29,12.81-.6,2.28-.46,7.58-.26,11.3a4.17,4.17,0,0,0,4.15,4h18.89a4.17,4.17,0,0,0,4.15-4C365.87,313.57,366,308.27,365.41,306Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.31,306c-.94-3.57-3.63-12.81-7.28-12.81s-6.34,9.24-7.29,12.81c-.6,2.28-.46,7.58-.26,11.3a4.17,4.17,0,0,0,4.15,4h6.79a4.18,4.18,0,0,0,4.16-4C353.77,313.57,353.92,308.27,353.31,306Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.03,
    y: 289.76,
    width: 12.09,
    height: 3.42,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.21,
    y: 306.98,
    width: 8.96,
    height: 4.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.03,
    y: 289.76,
    width: 12.09,
    height: 3.42,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.41,306c-.94-3.57-3.64-12.81-7.29-12.81v-3.42H346v3.42h0a2.9,2.9,0,0,0-1.95.88,7.36,7.36,0,0,0-1.17,1.37c-2,3-3.52,8.11-4.17,10.56a9.73,9.73,0,0,0-.19,1c-.1.73-.17,1.61-.21,2.58v.05c0,.72,0,1.49,0,2.28h0c0,1.84.08,3.77.17,5.4a4.17,4.17,0,0,0,3.35,3.89,4.26,4.26,0,0,0,.8.08h18.89a4.17,4.17,0,0,0,4.15-4C365.87,313.57,366,308.27,365.41,306Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.36,313.26c-.8-3-3.09-10.89-6.2-10.89H381.88c-3.1,0-5.39,7.85-6.19,10.89-.52,1.94-.39,6.45-.23,9.6a3.55,3.55,0,0,0,3.53,3.38h16.06a3.55,3.55,0,0,0,3.53-3.38C398.75,319.71,398.87,315.2,398.36,313.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.36,313.26c-.8-3-3.09-10.89-6.2-10.89H381.88c-3.1,0-5.39,7.85-6.19,10.89-.52,1.94-.39,6.45-.23,9.6a3.55,3.55,0,0,0,3.53,3.38h16.06a3.55,3.55,0,0,0,3.53-3.38C398.75,319.71,398.87,315.2,398.36,313.26Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.07,313.26c-.8-3-3.09-10.89-6.19-10.89s-5.39,7.85-6.19,10.89c-.52,1.94-.39,6.45-.23,9.6a3.55,3.55,0,0,0,3.53,3.38h5.78a3.55,3.55,0,0,0,3.53-3.38C388.46,319.71,388.59,315.2,388.07,313.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.69,
    y: 314.1,
    width: 7.62,
    height: 3.57,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.88,
    y: 299.46,
    width: 10.28,
    height: 2.91,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.88,
    y: 299.46,
    width: 10.28,
    height: 2.91,
    style: {
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.36,313.26c-.8-3-3.09-10.89-6.2-10.89v-2.91H381.88v2.91h0c-3.1,0-5.39,7.85-6.19,10.89a19.71,19.71,0,0,0-.37,4.34v.67c0,.68,0,1.38,0,2.06,0,.88.06,1.75.1,2.53a3.74,3.74,0,0,0,1.62,2.81,4,4,0,0,0,.58.31,3.47,3.47,0,0,0,1.33.26h16.06a3.55,3.55,0,0,0,3.53-3.38C398.75,319.71,398.87,315.2,398.36,313.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.1,292.86s-1.18-7.68,4.89-5.85C374,287,372.86,291.43,369.1,292.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.1,292.86s-1.18-7.68,4.89-5.85C374,287,372.86,291.43,369.1,292.86Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.51,288c1.47-1.07,2.19-1.06,2.4-1-6-1.74-4.81,5.87-4.81,5.87S369.7,289.32,371.51,288Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,293.94s-.66-3.3-2.76-3.92c0,0,.07-.68,1.13-.75a10.48,10.48,0,0,1,2.16,4.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,293.94s-.66-3.3-2.76-3.92c0,0,.07-.68,1.13-.75a10.48,10.48,0,0,1,2.16,4.45Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.93,290.81a5.4,5.4,0,0,0-2.66,2.66,6.76,6.76,0,0,0-4.1.13c-3.24,1.42-2.3,5.77-.66,8.14,1.45,2.09,4.64,5.65,7.23,4.88a4,4,0,0,0,1.84-2.32,3.1,3.1,0,0,0,2.66.46c2.38-1.28,2.2-6.08,1.79-8.6C377.56,293.31,375.23,289.53,371.93,290.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.46,294.21c.9,2.28,0,5.89-1.78,6.63s-2.32-1.17-3.59-.65-.06,3.3-1.38,3.84-2.62-1.41-3.33-1c-.45.25-.49,1-.46,1.55,1.49,1.41,3.26,2.51,4.82,2.05a4,4,0,0,0,1.84-2.32,3.1,3.1,0,0,0,2.66.46c2.38-1.28,2.2-6.08,1.79-8.6A8.76,8.76,0,0,0,377.46,294.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.68,300.14s-1.56-4.36.14-5S364.44,297,364.68,300.14Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.37,289.27c-1.06.07-1.13.75-1.13.75S367.56,290.07,367.37,289.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,296.16c0-.29-.12-.58-.2-.88a.65.65,0,0,0,0-.13,7.19,7.19,0,0,0-.3-.85l0-.09,0,.07c-1-2.33-2.94-4.46-5.53-3.48a10.63,10.63,0,0,0,2-3.79l-.09,0h0l-.12,0-.4-.1-.13,0-.37-.06h-.11l-.36,0h-.5l-.31,0-.07,0-.29.07-.05,0-.27.11,0,0a2,2,0,0,0-.25.14l0,0-.23.17,0,0a1.89,1.89,0,0,0-.2.2l0,0a2,2,0,0,0-.19.22h0l-.17.25h0a1.82,1.82,0,0,0-.15.27h0a7.86,7.86,0,0,0-.57,3.78,9.89,9.89,0,0,0-1.66-2.87c-1.06.07-1.13.75-1.13.75,1.56.46,2.33,2.41,2.62,3.38a6.58,6.58,0,0,0-3.69.2c-3.24,1.42-2.3,5.77-.66,8.14a19.17,19.17,0,0,0,2.41,2.83h0l.09.08.39.35.16.14.41.32.15.12a7.22,7.22,0,0,0,1.14.69l.16.08.41.16.21.06a2.49,2.49,0,0,0,.37.09l.21,0,.39,0h.17a3.66,3.66,0,0,0,.56-.1,4,4,0,0,0,1.84-2.32,3.1,3.1,0,0,0,2.66.46C378.62,303.48,378.44,298.68,378,296.16Zm-8.17-3.65a6.07,6.07,0,0,0-.47.73l-.12-.46A6.28,6.28,0,0,0,369.86,292.51Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.52,314.64a17.73,17.73,0,0,1-13.19,17.21,17.48,17.48,0,0,1-4.36.55,17.28,17.28,0,0,1-6.2-1.14h0A17.79,17.79,0,0,1,362,296.88a17.28,17.28,0,0,1,7.83,1.86c.26.13.52.27.77.42a17.65,17.65,0,0,1,6.91,7.16c.12.22.23.45.33.67A17.79,17.79,0,0,1,379.52,314.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.24,328.07c-4.05-2.46-6.27-9-6-14.56a21.73,21.73,0,0,1,6.88-13.89,13.94,13.94,0,0,1,13.66-2.81c1.52.57,2.53,2.56,3.08,4.1a6,6,0,0,1-.41,4.76c.83.54.54,2.27,0,3.1a4.62,4.62,0,0,1-2.48,1.58,9.6,9.6,0,0,0-2.74,1.15c.79.33.72,1.46.31,2.22a4.36,4.36,0,0,1-1.95,1.61,5.41,5.41,0,0,0-2.06,1.49c.87.1.83,1.33.4,2.09a8.22,8.22,0,0,1-1.88,1.79,5.27,5.27,0,0,0-1.08,6.09,1.77,1.77,0,0,1-2.52,1.45,1.54,1.54,0,0,1-1.62,1.39C350.05,329.55,349.13,328.86,349.24,328.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.08,304.09a5.84,5.84,0,0,1-.59,1.57c.81.54.56,2.17,0,3a.22.22,0,0,1-.05.08,4.64,4.64,0,0,1-2.47,1.58h0a9.42,9.42,0,0,0-2.73,1.15c.79.33.72,1.46.31,2.22a3.66,3.66,0,0,1-1.56,1.4l-.39.21c-.28.14-.56.29-.83.45a3.86,3.86,0,0,0-1.23,1c.87.1.83,1.33.4,2.09a8.38,8.38,0,0,1-1.87,1.79,4.92,4.92,0,0,0-1.21,1.74,5.83,5.83,0,0,0-.38,1.49,5,5,0,0,0,.5,2.86,1.77,1.77,0,0,1-2.52,1.45,1.54,1.54,0,0,1-1.62,1.39c-.79-.08-1.71-.77-1.6-1.56-4.05-2.46-6.27-9-6-14.56a21.69,21.69,0,0,1,6.88-13.89,13.94,13.94,0,0,1,13.66-2.81,4,4,0,0,1,1.74,1.46,9.93,9.93,0,0,1,1.22,2.32h0l.12.31a5.41,5.41,0,0,1,.3,1.49A6,6,0,0,1,367.08,304.09Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.78,332.37a.21.21,0,0,1-.11.1l-.76-.05.22-.11a1.86,1.86,0,0,0,.41-.08C361.62,332.2,361.82,332.3,361.78,332.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,325.05l-.05,0S367.93,325,368,325.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.89,303.66s0-.05,0-.08h0C372,303.59,371.93,303.71,371.89,303.66Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M368,325.05l-.05,0S367.93,325,368,325.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.77,319.84a1.47,1.47,0,0,1,.43-.47,11.29,11.29,0,0,1,3.12-1.79,6.16,6.16,0,0,1,3.55-.23,7.73,7.73,0,0,0,2.28.54c.41,0,1-.07,1.05-.47a5.58,5.58,0,0,0-4.11-1.61,13.55,13.55,0,0,0-6.44,1.34,3.53,3.53,0,0,0,0,2.69C343.68,319.77,343.74,319.92,343.77,319.84Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.55,310.33a1.58,1.58,0,0,0-.84-.48l-1.52-.47c-1.08-.33-2.15-.81-3.18-.34a5.63,5.63,0,0,0-2.24,0A.83.83,0,0,1,344,309a2.5,2.5,0,0,0-.78,1.48c0,.24,0,.55.23.62a2.44,2.44,0,0,1,.94-.53,4.62,4.62,0,0,1,1.39-.19c1.72-.07,3.45-.07,5.17,0,.07,0,.15,0,.16-.08s-.12,0-.07,0a3,3,0,0,0,1,.37,1,1,0,0,0,.55.07C352.75,310.68,352.66,310.48,352.55,310.33Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.34,326.53a10.4,10.4,0,0,1-2.3-.6c-.76-.24-1.55-.72-2.28-.39a.84.84,0,0,1-1-.38,1.58,1.58,0,0,1-.11-1.15c1.07-.38,2.2.13,3.25.54L350,325a6.32,6.32,0,0,1,2.06,1.11c.17.16,0,.39-.23.5S351.58,326.54,351.34,326.53Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.26,301.37a2.63,2.63,0,0,1,1.83-.68,7.85,7.85,0,0,1,2,.31l4.7,1.14a1.54,1.54,0,0,0,1.08,0c0-.11.07-.52.07-.63a8.57,8.57,0,0,1-2.51-.37c-1.09-.32-2.11-.86-3.2-1.18a8.16,8.16,0,0,0-2.25-.32,2.23,2.23,0,0,0-1.9,1.49.26.26,0,0,0,0,.27.18.18,0,0,0,.26,0C348.4,301.27,348.27,301.47,348.26,301.37Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.68,297.2c0-.11.12-.17.23-.18,1.59-.1,3.08.72,4.5,1.45s3,1.42,4.56,1c.07-.08,0-.24-.08-.3a.5.5,0,0,0-.32-.05,9,9,0,0,1-1.37,0c-1.39-.2-2.37-1.42-3.58-2.13a5.21,5.21,0,0,0-2.33-.72c-.68,0-1.41-.16-1.91.32a.54.54,0,0,0-.19.3C354.16,297,354.57,297.18,354.68,297.2Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.1,319.88a9.6,9.6,0,0,0-1.57,1.68,6,6,0,0,1-.8,1,4.55,4.55,0,0,1-1.3.75,2.2,2.2,0,0,1-1.16.29c0-.1,0-.26,0-.36l.45-.34a10.35,10.35,0,0,0,1.49-1.47,6.83,6.83,0,0,1,2.28-2.2c.16-.07.37-.18.33-.36C379.07,319.1,379.36,319.66,379.1,319.88Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,302.71a.18.18,0,0,1,.22,0,5.16,5.16,0,0,0-.08.79,7.92,7.92,0,0,1-.36,1.57,3.79,3.79,0,0,1-.28.73.86.86,0,0,1-.49.45c-.22.06-.39-.25-.42-.48.88-1.05.88-2.57.79-3.95,0-.15-.14-.36-.25-.26.15.14.59,0,.75.15a.5.5,0,0,1,.13.36C375,302.38,374.94,302.43,375,302.71Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.34,302.38a9.34,9.34,0,0,0-1.65-.53c-.62-.14-1.28.13-1.86-.14a1.59,1.59,0,0,0-.63-.19.52.52,0,0,0-.51.38c0,.22.49.71.69.6a6.43,6.43,0,0,1,1.91.39c.55.31,1.25.75,1.93,1.18A5.63,5.63,0,0,0,367.34,302.38Zm-1.63-4.13-.13,0,1.34,2.29A9.89,9.89,0,0,0,365.71,298.25Zm-5.39,8.83L353.93,306a16.64,16.64,0,0,1-2.64-.37.83.83,0,0,0-.44.91,3,3,0,0,0,1.48.4c2.66,0,5.17,1.07,7.7,1.9a38.8,38.8,0,0,1,4.08,1.55h0a4.64,4.64,0,0,0,2.48-1.58.56.56,0,0,0,.05-.08l-.29-.11A32.79,32.79,0,0,0,360.32,307.08Zm-2.73,7.19a.66.66,0,0,0,.23.73l1.09.76.84-.45.39-.21-1.83-1.31A.81.81,0,0,0,357.59,314.27ZM351,322.43c-.1.3,0,.81.25.91a19.37,19.37,0,0,0,3.35.57,5.19,5.19,0,0,1,.38-1.49A29.36,29.36,0,0,0,351,322.43Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.42,314.81c0-.09-.16-.1-.25-.1s-.46-.12-.67,0c-2.11.62-4.85,3.36-5.92,5.3a23.14,23.14,0,0,0,.3-3.69,15.38,15.38,0,0,0-.16-2.25,6.06,6.06,0,0,0,2.81-1.68,10,10,0,0,0,1.65-3c.19-.46,1-1.43.64-1.79a1.74,1.74,0,0,0,0-.6c-.05-.32-.17-.62-.33-.67s-.16,0-.25.09a13.94,13.94,0,0,1-.83,1.69c-.68.74-1.16,1.66-1.85,2.4a2.05,2.05,0,0,1-2.3.81,3.28,3.28,0,0,0-.2-1.25,2.42,2.42,0,0,1-.38-1.9c.58-1.48.5-3,.83-4.57.13-.58-.12-.84-.5-1.3-.06.37,0,.9-.09,1.29h0c.06,0,0,.13,0,.08s0-.05,0-.08-.1.06-.12.12c-.34.94-.63,2-1,2.95a6.75,6.75,0,0,0-.7-2.13c-.14-.27,0-.5,0-.8.07-.59.23-1.54.33-2.12a18.81,18.81,0,0,1,.06-2.13,1.73,1.73,0,0,0,.07-.31c-.25-.15-.51-.29-.77-.42a.12.12,0,0,0,0,.13,3.57,3.57,0,0,1-.15,2.27c-.13.46-.18.91-.31,1.37a7.55,7.55,0,0,0-2.89-3.73.64.64,0,0,0-.88-.51,9.93,9.93,0,0,1,1.22,2.32h0l1.33,2.28a7.9,7.9,0,0,0-.91-.48,6,6,0,0,1-.12,1.69c.53.34,1.06.67,1.49.91a12.55,12.55,0,0,1,1.64,5c-1.23-.38-2.49-.86-3.7-1.32a.22.22,0,0,1-.05.08,4.64,4.64,0,0,1-2.47,1.58h0a24.45,24.45,0,0,1,6,3.67c.46,2.91-.6,6-1.7,8.69a25.15,25.15,0,0,0-1.67-2,11.34,11.34,0,0,0-1-4.55,4.27,4.27,0,0,1-.31-.77c-.12-.4-.14-.82-.27-1.21a1.15,1.15,0,0,0-.82-.82,1.1,1.1,0,0,0-.09,1c.15.3.42.22.49.55.28,1.3.51,2.6.7,3.91a1.25,1.25,0,0,0,.26.71,1.57,1.57,0,0,1,.2.3,26.75,26.75,0,0,0-2.07-1.91c-.95-.78-1.95-1.5-2.95-2.22l-.81-.57-.39.21c-.28.14-.56.29-.83.45a20.05,20.05,0,0,1,3.1,2.63c1.91,2,3.83,4.1,5.57,6.29a23.94,23.94,0,0,1-2.22,4,5,5,0,0,0-1.18-1.29L361.22,325a11.07,11.07,0,0,0-2.6-1.82,9,9,0,0,0-2.67-.6c-.37,0-.72-.07-1.09-.09a5.83,5.83,0,0,0-.38,1.49c.25,0,.5.09.74.15a7.42,7.42,0,0,1,2.7,1.09,4.79,4.79,0,0,1,.68.6l4,4.08a1.4,1.4,0,0,0,1,.57h.14a10.05,10.05,0,0,1-2.61,1.9,1.84,1.84,0,0,1-.62-.06,7.25,7.25,0,0,1-.87-.36c-.46-.19-1-.27-1.44-.42a11.76,11.76,0,0,1-3.37-1.91c-.16.16-.37.35-.28.56a1.36,1.36,0,0,0,.42.53,8.66,8.66,0,0,0,.79.6h0a10.54,10.54,0,0,0,2.69,1.22,7.8,7.8,0,0,0,1,.24,33.24,33.24,0,0,0,4.69,0,5.44,5.44,0,0,0,2.14-.88,7.75,7.75,0,0,0,1.28-1.08,7.13,7.13,0,0,0,2.59-1.14l1.85-1.17c.25,0,.43-.28.62-.45L375,325.9c.26-.23.32-.7,0-.85a26.16,26.16,0,0,1-5.82,3.83l-.17.08a21.15,21.15,0,0,0,3.06-6.82,10.43,10.43,0,0,0,2.21-2.33,24.13,24.13,0,0,1,4.91-4.39c.07-.2.08-.22.16-.42A.31.31,0,0,0,379.42,314.81ZM367.9,325.07s0,0,.05,0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.52,314.64a17.79,17.79,0,0,0-1.71-7.65c-.05-.32-.17-.62-.33-.67a17.72,17.72,0,0,0-2.33-3.39,1.13,1.13,0,0,1,0-.18.18.18,0,0,0-.22,0c0-.28,0-.33,0-.6a.5.5,0,0,0-.13-.36c-.12-.09-.37-.06-.57-.08a.37.37,0,0,1,.07.19,1.41,1.41,0,0,1,0,.2,17.51,17.51,0,0,0-3.78-2.9c-.25-.15-.51-.29-.77-.42a17.22,17.22,0,0,0-5.53-1.71,3.13,3.13,0,0,0-.45-.22h0a12.18,12.18,0,0,0-2.43-.61l-.21,0H361a13.21,13.21,0,0,0-4.25.21,3.47,3.47,0,0,0-.45-.06c-.68,0-1.41-.16-1.91.32a.54.54,0,0,0-.19.3c0,.05.07.11.17.16a14.75,14.75,0,0,0-3.71,2.14l-.49.4,0,0H350a2.22,2.22,0,0,0-1.9,1.49.26.26,0,0,0,0,.27c.05.06.13,0,.2,0s0,0,0,0a2,2,0,0,1,.48-.34,22.62,22.62,0,0,0-4.58,8A.7.7,0,0,1,344,309a2.5,2.5,0,0,0-.78,1.48c0,.24,0,.55.23.62l.21-.15a16.88,16.88,0,0,0-.37,2.58,19.79,19.79,0,0,0,.22,4.12,3.81,3.81,0,0,0,.15,2.21c0-.07.09.08.12,0a.62.62,0,0,1,.14-.19,18.47,18.47,0,0,0,1.72,4.42,1.51,1.51,0,0,0,.12,1.09.89.89,0,0,0,.84.42,9.59,9.59,0,0,0,2.65,2.49,1.07,1.07,0,0,0,.23.79,2,2,0,0,0,1.37.77,1.5,1.5,0,0,0,1.13-.41,17.7,17.7,0,0,0,3.79,2h0a10.45,10.45,0,0,0,2.7,1.22,7.33,7.33,0,0,0,1,.24,33.24,33.24,0,0,0,4.69,0,5.44,5.44,0,0,0,2.14-.88,17.68,17.68,0,0,0,12.25-11.47c.17-.17.33-.34.52-.5s.06-.56-.13-.82A17.84,17.84,0,0,0,379.52,314.64Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.33,301.36h0S348.35,301.33,348.33,301.36Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.33,301.36l-.05,0A.05.05,0,0,0,348.33,301.36Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.09,301.6a.33.33,0,0,0,.18.07C374.22,301.59,374.16,301.54,374.09,301.6Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.88,296s-1.18-7.68,4.89-5.85C347.77,290.13,346.63,294.55,342.88,296Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.88,296s-1.18-7.68,4.89-5.85C347.77,290.13,346.63,294.55,342.88,296Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.29,291.13c1.47-1.07,2.18-1.06,2.4-1-6-1.74-4.81,5.87-4.81,5.87S343.47,292.44,345.29,291.13Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.78,297.06s-.66-3.3-2.76-3.92c0,0,.07-.68,1.13-.75a10.48,10.48,0,0,1,2.16,4.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.78,297.06s-.66-3.3-2.76-3.92c0,0,.07-.68,1.13-.75a10.48,10.48,0,0,1,2.16,4.45Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.71,293.93a5.42,5.42,0,0,0-2.67,2.66,6.73,6.73,0,0,0-4.09.13c-3.24,1.42-2.3,5.77-.66,8.14,1.45,2.09,4.63,5.65,7.22,4.88a4,4,0,0,0,1.84-2.32,3.12,3.12,0,0,0,2.67.46c2.38-1.29,2.2-6.08,1.79-8.6C351.34,296.43,349,292.65,345.71,293.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.24,297.33c.9,2.28,0,5.89-1.78,6.63s-2.32-1.17-3.59-.65-.06,3.3-1.38,3.84-2.62-1.41-3.33-1c-.45.25-.49,1-.46,1.55,1.48,1.41,3.26,2.51,4.81,2.05a4,4,0,0,0,1.84-2.32,3.12,3.12,0,0,0,2.67.46c2.38-1.29,2.2-6.08,1.79-8.6A9.32,9.32,0,0,0,351.24,297.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.46,303.26s-1.56-4.36.14-5S338.22,300.13,338.46,303.26Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.15,292.39c-1.06.07-1.13.75-1.13.75S341.33,293.19,341.15,292.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.81,299.28c-.05-.29-.12-.59-.2-.88a.93.93,0,0,1,0-.13,7.19,7.19,0,0,0-.3-.85l0-.09a.19.19,0,0,1,0,.07c-.95-2.34-2.93-4.46-5.53-3.48a10.65,10.65,0,0,0,2-3.79l-.09,0h0l-.13,0a2.79,2.79,0,0,0-.39-.1l-.13,0-.37-.06h-.12l-.35,0h-.5l-.31,0-.07,0L345,290l0,0-.27.11,0,0a2,2,0,0,0-.25.14l0,0-.23.17,0,0-.2.2,0,0a2,2,0,0,0-.19.22v0a1.46,1.46,0,0,0-.17.24h0c0,.09-.1.18-.14.27h0a7.81,7.81,0,0,0-.57,3.77,10.17,10.17,0,0,0-1.66-2.87c-1.06.07-1.13.75-1.13.75,1.56.46,2.33,2.41,2.62,3.37a6.57,6.57,0,0,0-3.69.21c-3.24,1.42-2.3,5.77-.66,8.14a19.7,19.7,0,0,0,2.41,2.83h0l.09.08.39.35.16.14.41.32.15.12a6.79,6.79,0,0,0,1.14.69l.16.07a3.56,3.56,0,0,0,.41.17l.21.06a2.49,2.49,0,0,0,.37.09l.21,0a2.44,2.44,0,0,0,.38,0H345a2.53,2.53,0,0,0,.55-.09,4,4,0,0,0,1.84-2.32,3.12,3.12,0,0,0,2.67.46C352.4,306.59,352.22,301.8,351.81,299.28Zm-8.17-3.65a6.07,6.07,0,0,0-.47.73l-.12-.46A6.28,6.28,0,0,0,343.64,295.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.76,303.81l-2-.87-6.55,15.28,2,.87a3,3,0,0,0,1.61,3.8l22.26,9.77a3,3,0,0,0,3.93-1.57l6.4-14.95a3,3,0,0,0-1.55-4L323.6,302.4A3,3,0,0,0,319.76,303.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.76,303.81l-2-.87-6.55,15.28,2,.87a3,3,0,0,0,1.61,3.8l22.26,9.77a3,3,0,0,0,3.93-1.57l6.4-14.95a3,3,0,0,0-1.55-4L323.6,302.4A3,3,0,0,0,319.76,303.81Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.97 311.41 326.36 322.17 320.75 319.71 325.35 308.95 330.97 311.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.3,301.73l-7.9,18.44-1.46-.64a1.28,1.28,0,0,1-.66-1.67l6.9-16.11a1.26,1.26,0,0,1,1.66-.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.3,301.73l-7.9,18.44-1.46-.64a1.28,1.28,0,0,1-.66-1.67l6.9-16.11a1.26,1.26,0,0,1,1.66-.66Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.86,312.16,323.6,302.4a3,3,0,0,0-3.84,1.41l-1.14-.5.68-1.58-1.46-.64a1.26,1.26,0,0,0-1.66.66l-6.9,16.11a1.28,1.28,0,0,0,.66,1.67l1.46.64.68-1.58,1.13.5a3,3,0,0,0,1.61,3.8l22.26,9.77a3,3,0,0,0,3.93-1.57l6.4-14.95A3,3,0,0,0,345.86,312.16Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.09,317.88c-1.88-2.5-6.95-8.89-9.82-7.7l-9.51,4c-2.87,1.19-2,9.34-1.64,12.46.26,2,2.06,6.11,3.4,9a3.53,3.53,0,0,0,4.54,1.76l14.85-6.17a3.6,3.6,0,0,0,2-4.49C309.87,323.69,308.29,319.47,307.09,317.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.09,317.88c-1.88-2.5-6.95-8.89-9.82-7.7l-9.51,4c-2.87,1.19-2,9.34-1.64,12.46.26,2,2.06,6.11,3.4,9a3.53,3.53,0,0,0,4.54,1.76l14.85-6.17a3.6,3.6,0,0,0,2-4.49C309.87,323.69,308.29,319.47,307.09,317.88Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.58,321.83c-1.88-2.5-6.95-8.88-9.82-7.69s-2,9.34-1.64,12.46c.26,2,2.06,6.11,3.4,9a3.53,3.53,0,0,0,4.54,1.76l5.33-2.22a3.58,3.58,0,0,0,2-4.48C300.36,327.64,298.78,323.43,297.58,321.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.77 322.36 300.73 325.29 299.39 321.99 306.43 319.06 307.77 322.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.27 310.19 287.76 314.14 286.67 311.45 296.18 307.5 297.27 310.19",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.27 310.19 287.76 314.14 286.67 311.45 296.18 307.5 297.27 310.19",
    style: {
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.9,326.67c-1-3-2.61-7.2-3.81-8.79-1.88-2.5-6.95-8.89-9.82-7.7l-1.09-2.68-9.51,3.95,1.09,2.69h0c-1.62.67-2.06,3.54-2.07,6.48v0a49.88,49.88,0,0,0,.43,6c0,.15.06.33.1.51s.11.5.19.78a60.07,60.07,0,0,0,3.11,7.68,5.48,5.48,0,0,0,.31.52,3.51,3.51,0,0,0,2.24,1.45,3.68,3.68,0,0,0,.66.06,3.51,3.51,0,0,0,1.33-.27l5.33-2.22h0l9.52-3.95A3.6,3.6,0,0,0,310.9,326.67ZM296.5,310.5l-.54.23Zm-2.77,1.16-2.11.87Zm1-.4-.51.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,329.11a18,18,0,0,1,9.19,20.05,18.59,18.59,0,0,1-5.41,9.52h0a17.53,17.53,0,0,1-20,3,18.18,18.18,0,0,1-7.67-24.34,18.42,18.42,0,0,1,5.28-6.42l.73-.52a17.81,17.81,0,0,1,9.56-3.15q.38,0,.75,0A17.24,17.24,0,0,1,325,329.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.94,363.28c-4.06,2.64-10.92,1.71-15.7-1.09a21.59,21.59,0,0,1-9.17-12.69,14.94,14.94,0,0,1,3.83-13.94c1.2-1.15,3.44-1.18,5.07-1a5.72,5.72,0,0,1,4,2.53c.87-.52,2.28.54,2.75,1.44a5,5,0,0,1,.26,3,10.29,10.29,0,0,0-.25,3.07c.66-.58,1.63,0,2.11.72a4.48,4.48,0,0,1,.53,2.54,5.72,5.72,0,0,0,.38,2.58c.49-.75,1.56-.16,2,.58a8.39,8.39,0,0,1,.72,2.56,5.16,5.16,0,0,0,4.91,3.77,1.85,1.85,0,0,1,.12,3,1.59,1.59,0,0,1,.49,2.13C324.63,363.21,323.59,363.74,322.94,363.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.88,335.85a5.62,5.62,0,0,1,1.12,1.26c.85-.51,2.19.47,2.7,1.36a.22.22,0,0,1,.05.08,4.89,4.89,0,0,1,.26,3v0a10.49,10.49,0,0,0-.24,3.05c.66-.58,1.63,0,2.11.72a3.8,3.8,0,0,1,.53,2.08v.46c0,.32,0,.65,0,1a3.86,3.86,0,0,0,.36,1.61c.49-.76,1.56-.17,2,.57a8.77,8.77,0,0,1,.72,2.56,5.27,5.27,0,0,0,2.14,2.93,4.83,4.83,0,0,0,2.77.84,1.86,1.86,0,0,1,.13,3,1.59,1.59,0,0,1,.48,2.13c-.43.7-1.47,1.23-2.13.77-4.05,2.64-10.91,1.71-15.7-1.09a21.56,21.56,0,0,1-9.15-12.69,14.91,14.91,0,0,1,3.82-13.94,4.11,4.11,0,0,1,2.1-.95,9.64,9.64,0,0,1,2.62-.07h0l.34,0a5.79,5.79,0,0,1,2.91,1.28Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.56,353.61a.2.2,0,0,1,0,.15c-.12.23-.25.45-.39.68v-.25a2.25,2.25,0,0,0,.13-.42C332.34,353.68,332.52,353.54,332.56,353.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.91,344.57v.05S328.89,344.58,328.91,344.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.72,331.19l-.06-.05h0C311.69,331.09,311.78,331.18,311.72,331.19Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.91,344.57v.05S328.89,344.58,328.91,344.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.09,364.61a1.4,1.4,0,0,1-.22-.61,12.15,12.15,0,0,1-.15-3.71,6.57,6.57,0,0,1,1.44-3.39A8.52,8.52,0,0,0,315.7,355c.18-.39.38-.92.06-1.19a5.9,5.9,0,0,0-3.33,3.08,14.72,14.72,0,0,0-1.79,6.58,3.42,3.42,0,0,0,2.39,1.23C313,364.66,313.14,364.68,313.09,364.61Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.7,352.15a1.57,1.57,0,0,0-.81.57c-.38.39-.75.79-1.12,1.19-.81.85-1.73,1.62-1.78,2.79a5.84,5.84,0,0,0-1,2.1.86.86,0,0,1-.44.67,2.51,2.51,0,0,0,1,1.4c.19.14.48.24.65.07a2.45,2.45,0,0,1,0-1.11,5.24,5.24,0,0,1,.47-1.38q1.11-2.44,2.41-4.79c0-.06.06-.14,0-.18s-.1.1,0,.07a3.54,3.54,0,0,0,.79-.76.93.93,0,0,0,.31-.47C309.1,352.13,308.88,352.12,308.7,352.15Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.54,360.63a11.38,11.38,0,0,1-1.6,1.87c-.57.59-1.36,1.11-1.4,1.93a.86.86,0,0,1-.8.76,1.44,1.44,0,0,1-1.08-.42c.16-1.16,1.13-2,2-2.76l.86-.8a6.91,6.91,0,0,1,1.93-1.4c.23-.09.35.2.34.44S322.66,360.42,322.54,360.63Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.75,352.06a2.79,2.79,0,0,1,.24-2,8.31,8.31,0,0,1,1.19-1.69l3.19-3.84a1.68,1.68,0,0,0,.5-1c-.1,0-.43-.31-.53-.35a9.09,9.09,0,0,1-1.49,2.15c-.79.87-1.74,1.57-2.53,2.44a8.67,8.67,0,0,0-1.33,1.94,2.31,2.31,0,0,0,.45,2.43c.07.07.16.14.25.1a.19.19,0,0,0,.08-.27C298.72,351.88,298.84,352.1,298.75,352.06Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,344.21c-.11,0-.1-.19-.06-.29.64-1.53,2.06-2.53,3.37-3.51s2.66-2.15,3-3.76c0-.11-.21-.12-.31-.06a.51.51,0,0,0-.19.26,8,8,0,0,1-.64,1.28c-.82,1.19-2.35,1.55-3.54,2.35a5.48,5.48,0,0,0-1.72,1.83,2.57,2.57,0,0,0-.6,1.92.56.56,0,0,0,.17.31C297.63,344.62,297.94,344.31,298,344.21Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.47,331.88a9.6,9.6,0,0,0,.78,2.22,6.7,6.7,0,0,1,.52,1.2,5,5,0,0,1,.07,1.55,2.58,2.58,0,0,1-.28,1.2l-.33-.15c0-.19-.06-.38-.1-.57a11.58,11.58,0,0,0-.61-2.06,7,7,0,0,1-.9-3.1c0-.19,0-.43-.17-.47C328.76,331.55,329.4,331.55,329.47,331.88Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.29,327.91a.19.19,0,0,1,.14-.18,4.66,4.66,0,0,0,.66.43,7.26,7.26,0,0,1,1.23,1,3.72,3.72,0,0,1,.53.59.9.9,0,0,1,.17.67c0,.23-.4.24-.62.17-.52-1.3-1.88-2-3.14-2.53-.14-.07-.39,0-.35.11.19-.07.29-.54.48-.63a.49.49,0,0,1,.37.05C312,327.74,312,327.81,312.29,327.91Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.48,334.83a10.1,10.1,0,0,0-1.24,1.29c-.41.51-.48,1.25-1,1.66a1.47,1.47,0,0,0-.46.5.53.53,0,0,0,.1.64c.17.13.86-.13.84-.36A7.25,7.25,0,0,1,308,337c.53-.37,1.26-.82,2-1.26A5.79,5.79,0,0,0,308.48,334.83Zm-4.43-.36,0,.12,2.65-.19A9.26,9.26,0,0,0,304.05,334.47Zm5.36,9-4,5.41c-.53.73-1.37,2.33-1.55,2.28a.84.84,0,0,0,.6.83,3.12,3.12,0,0,0,1.05-1.2c1.2-2.47,3.35-4.3,5.25-6.27a43.41,43.41,0,0,1,3.27-3.08v0a4.92,4.92,0,0,0-.26-3,.35.35,0,0,0-.05-.08l-.23.22A34.78,34.78,0,0,0,309.41,343.47Zm5.12,5.8a.64.64,0,0,0,.76.12l1.18-.67c0-.32,0-.65,0-1,0-.15,0-.3,0-.45l-2,1.1A.83.83,0,0,0,314.53,349.27Zm4.22,9.8c.22.22.7.4.92.17a19.83,19.83,0,0,0,2.06-2.84,5.07,5.07,0,0,1-1.14-1A29.64,29.64,0,0,0,318.75,359.07Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.11,329.29c-.09,0-.16.09-.2.18s-.32.37-.36.6c-.42,2.24.75,6,2,7.9a22.22,22.22,0,0,0-3.15-2,14,14,0,0,0-2.07-.88,6.34,6.34,0,0,0-.19-3.37,10.07,10.07,0,0,0-1.87-2.87c-.32-.38-.82-1.55-1.29-1.41a1.81,1.81,0,0,0-.54-.26c-.31-.1-.63-.12-.75,0a.25.25,0,0,0,0,.27,16.17,16.17,0,0,1,1.11,1.54c.35,1,.95,1.83,1.28,2.81a2.18,2.18,0,0,1-.34,2.5,3.22,3.22,0,0,0-1.21-.38,2.38,2.38,0,0,1-1.86-.51c-1.05-1.22-2.44-1.83-3.68-2.85-.46-.38-.8-.27-1.38-.13.29.23.77.45,1.1.67h0c0-.05.12,0,.06.05l-.06-.05a.14.14,0,0,0,0,.16c.68.75,1.49,1.5,2.17,2.25a6.37,6.37,0,0,0-2.21-.32c-.31,0-.46-.2-.72-.36-.5-.33-1.26-.91-1.73-1.27s-1.36-.53-1.87-1l-.24-.21-.73.52a.13.13,0,0,0,.11.08,3.46,3.46,0,0,1,1.95,1.16c.35.34.73.58,1.08.92a7.45,7.45,0,0,0-4.66,1c-.44-.15-.76.14-.86.58a9.64,9.64,0,0,1,2.62-.07h0l2.65-.2a7.79,7.79,0,0,0-.85.63,5.79,5.79,0,0,1,1.45.88c.55-.34,1.08-.68,1.5-1a12.11,12.11,0,0,1,5.21.76c-.91,1-1.92,1.92-2.89,2.83a.22.22,0,0,1,.05.08,4.89,4.89,0,0,1,.26,3v0a25.38,25.38,0,0,1,6.05-3.92c2.79.9,5,3.26,6.93,5.53a26.14,26.14,0,0,0-2.58.62,11,11,0,0,0-4.49-1.18,4.57,4.57,0,0,1-.83-.06c-.4-.07-.78-.25-1.19-.3a1.14,1.14,0,0,0-1.12.39,1.07,1.07,0,0,0,.88.54c.34,0,.39-.28.72-.19,1.27.33,2.54.7,3.79,1.12a1.25,1.25,0,0,0,.76.09,1,1,0,0,1,.36-.05c-.9.3-1.79.65-2.66,1-1.14.53-2.24,1.13-3.34,1.73l-.88.49v.46c0,.32,0,.65,0,1a20.51,20.51,0,0,1,3.77-1.69c2.71-.84,5.41-1.68,8.17-2.3a23.52,23.52,0,0,1,2.49,3.86,4.7,4.7,0,0,0-1.69.5l-3.46,1.52a11.1,11.1,0,0,0-2.81,1.58,9.46,9.46,0,0,0-1.77,2.21c-.2.32-.4.64-.58,1a5.07,5.07,0,0,0,1.14,1c.16-.21.31-.42.47-.61a7.85,7.85,0,0,1,2.22-2,4.93,4.93,0,0,1,.85-.36l5.46-1.81a1.44,1.44,0,0,0,1-.71,1.21,1.21,0,0,1,.05-.14,10.13,10.13,0,0,1,.48,3.29,1.87,1.87,0,0,1-.33.54,8.93,8.93,0,0,1-.73.65c-.38.34-.68.77-1,1.14a12,12,0,0,1-3.25,2.25c.06.23.13.51.36.52a1.43,1.43,0,0,0,.67-.15,5.86,5.86,0,0,0,.9-.46h0a10.83,10.83,0,0,0,2.33-1.95,6.93,6.93,0,0,0,.69-.85,35.78,35.78,0,0,0,2.19-4.34,5.79,5.79,0,0,0,.2-2.38,7.43,7.43,0,0,0-.36-1.68,7.68,7.68,0,0,0,.18-2.91c-.06-.75-.12-1.51-.19-2.26.13-.22,0-.52-.11-.77-.25-1.05-.51-2.1-.77-3.16-.09-.34-.48-.62-.75-.4a28.07,28.07,0,0,1,.71,7.14,1.21,1.21,0,0,1,0,.19,21.31,21.31,0,0,0-4.65-5.93,10.58,10.58,0,0,0-1.05-3.11,25.19,25.19,0,0,1-1.63-6.54l-.3-.34A.23.23,0,0,0,325.11,329.29Zm3.8,15.33s0,0,0-.05Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.67,332.59c-.07-.23-.14-.46-.2-.71s-.46-.31-.79-.25a17.67,17.67,0,0,0-3.67-2.52,17.24,17.24,0,0,0-7.59-1.89c-.31-.1-.63-.12-.75,0a17.59,17.59,0,0,0-4.09.62l-.15-.11a.19.19,0,0,0-.14.18c-.25-.1-.27-.17-.53-.27a.49.49,0,0,0-.37-.05c-.14.07-.23.32-.34.49a.37.37,0,0,1,.21,0l.18.08a17.78,17.78,0,0,0-4.33,2.18l-.73.52a18.49,18.49,0,0,0-4.06,4.34,3.39,3.39,0,0,0-.42.33h0a11.87,11.87,0,0,0-1,1.11l-.24.29,0,0a14.32,14.32,0,0,0-2.4,4.93c-.09.13-.18.26-.26.4a2.57,2.57,0,0,0-.6,1.92.56.56,0,0,0,.17.31c.05,0,.14,0,.23-.08a15.43,15.43,0,0,0,.2,4.45c0,.2.07.4.11.59l0,0-.1.17a2.31,2.31,0,0,0,.45,2.43c.07.07.16.14.25.1s.1-.11.09-.19,0,0,0,0a2.06,2.06,0,0,1-.08-.6,22.8,22.8,0,0,0,5,7.9.58.58,0,0,1-.15.11,2.51,2.51,0,0,0,1,1.4c.19.14.48.24.65.07a2.51,2.51,0,0,1,0-.27,15.73,15.73,0,0,0,2.13,1.52,19.38,19.38,0,0,0,3.76,1.68,3.76,3.76,0,0,0,2,.86c0-.07.11-.05.06-.12a.51.51,0,0,1-.1-.21,17.32,17.32,0,0,0,4.72.41,1.42,1.42,0,0,0,1,.38.9.9,0,0,0,.75-.58,9.85,9.85,0,0,0,3.45-1.33,1,1,0,0,0,.84.14,2.08,2.08,0,0,0,1.28-.91,1.56,1.56,0,0,0,.16-1.23,18.24,18.24,0,0,0,3.56-2.6h0a10.83,10.83,0,0,0,2.33-1.95,6.93,6.93,0,0,0,.69-.85,35.78,35.78,0,0,0,2.19-4.34,5.79,5.79,0,0,0,.2-2.38A18.27,18.27,0,0,0,329.67,332.59Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.77,352s0,0,0,.07S298.78,352,298.77,352Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.77,352h0S298.76,352,298.77,352Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.91,328.22a.31.31,0,0,0,.14-.14C311,328.09,310.89,328.13,310.91,328.22Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.66,292.71l-1.58,1.38c-4.8-11.89-10.88-21.21-20.28-23.88l1.58-1.38C268.34,271.2,274.6,280.45,279.66,292.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.66,292.71l-1.58,1.38c-4.8-11.89-10.88-21.21-20.28-23.88l1.58-1.38C268.34,271.2,274.6,280.45,279.66,292.71Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.51,292.82l-2.15,1.59c-4.54-9.29-4-14.06-15.31-21.26l2.15-1.59C269.46,279.29,269.46,284.06,273.51,292.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.51,292.82l-2.15,1.59c-4.54-9.29-4-14.06-15.31-21.26l2.15-1.59C269.46,279.29,269.46,284.06,273.51,292.82Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.44,292.77h-140a2.74,2.74,0,0,0-2.46,3.88l32.49,72.17a2.69,2.69,0,0,0,2.86,1.57L406.7,354.93a2.74,2.74,0,0,0,2.3-2.46l5.13-56.71A2.72,2.72,0,0,0,411.44,292.77Zm-.38,4.5-4.92,54.32A2.6,2.6,0,0,1,404,354l-98.06,14.81a2.6,2.6,0,0,1-2.74-1.51L272,298.12a2.61,2.61,0,0,1,2.35-3.71H408.48A2.61,2.61,0,0,1,411.06,297.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.39 368.79 310.35 368.79 277.08 292.77 279.12 292.77 312.39 368.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.55 367.32 319.51 367.32 287.7 292.77 289.74 292.77 321.55 367.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.04 365.86 328 365.86 300.53 292.77 302.56 292.77 330.04 365.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.12 364.32 337.08 364.32 312.39 292.77 314.42 292.77 339.12 364.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.35 363.2 345.32 363.2 324.78 292.77 326.81 292.77 347.35 363.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.65 361.83 354.61 361.83 336.4 292.77 338.44 292.77 356.65 361.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.41 360.2 363.37 360.2 348.37 292.77 350.41 292.77 365.41 360.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.6 359.17 372.56 359.17 360.51 292.77 362.55 292.77 374.6 359.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.34 358.05 381.3 358.05 372.99 292.77 375.02 292.77 383.34 358.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.08 356.42 390.04 356.42 385.16 292.77 387.2 292.77 392.08 356.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.08 355.56 399.04 355.56 397.76 292.77 399.8 292.77 401.08 355.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.08 314.42 411.08 316.48 281.07 322.4 281.07 320.34 411.08 314.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.44 336 409.44 338.06 293.54 350.88 293.54 348.81 409.44 336",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.39,414.84a7.3,7.3,0,1,1-7.3-7.38A7.35,7.35,0,0,1,312.39,414.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.65,414.8a5.11,5.11,0,0,1-4.84,3.61,4.27,4.27,0,0,1-4.33-3.61l-2.27-14h18.57l-2.26,7.8a4.07,4.07,0,0,1-.79,1.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.65,414.8a5.11,5.11,0,0,1-4.84,3.61,4.27,4.27,0,0,1-4.33-3.61l-2.27-14h18.57l-2.26,7.8a4.07,4.07,0,0,1-.79,1.48Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.26,414.84a7.3,7.3,0,1,0,7.3-7.38A7.34,7.34,0,0,0,382.26,414.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,414.8a5.09,5.09,0,0,0,4.83,3.61,4.27,4.27,0,0,0,4.33-3.61l2.28-14H376.87l2.25,7.8a4,4,0,0,0,.8,1.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,414.8a5.09,5.09,0,0,0,4.83,3.61,4.27,4.27,0,0,0,4.33-3.61l2.28-14H376.87l2.25,7.8a4,4,0,0,0,.8,1.48Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.44,292.77h-140a2.74,2.74,0,0,0-2.46,3.88l32.49,72.17a2.69,2.69,0,0,0,2.86,1.57L406.7,354.93a2.74,2.74,0,0,0,2.3-2.46l5.13-56.71A2.72,2.72,0,0,0,411.44,292.77Zm-3,1.64a2.61,2.61,0,0,1,2.58,2.86l-1.55,17.22-9.26.42-.41-20.5ZM282.93,322.32l6.94-.32,11.37,26-6.45.71Zm8.94-.41,8.11-.37,10.82,25.37-7.62.84Zm87.05,17.47-7.76.86-4-21.76,9-.41Zm-.69-21.4,8.84-.41,1.58,20.73-7.72.85Zm-9.07,22.48-8,.87-5-22.35,8.95-.41Zm-9.93,1.09-7.7.86-6-22.94,8.74-.4Zm-9.68,1.07-7.94.88L334.74,320l8.73-.4Zm-9.92,1.1-7.34.81L324,320.45l8.75-.4Zm-9.3,1-7.9.87-9.28-24.68,8.82-.4Zm-9.86,1.09-7.72.85L302,321.45l9.17-.42Zm-8.83,3,7.62,17.86-7.29,1.1L304,349.72Zm1.95-.22,7.63-.84,6.62,17.62-6.66,1Zm9.58-1.06,7.84-.87,6,17.33-7.22,1.09Zm9.81-1.08,7.24-.8,5,17.1-6.27.95Zm9.21-1,7.89-.87,4.42,16.78-7.34,1.11Zm9.86-1.09,7.62-.84,3.68,16.51-6.89,1Zm9.61-1.06,7.87-.87,3,16.22-7.16,1.08Zm9.87-1.09,7.65-.85,2,16-6.76,1Zm9.66-1.07,7.62-.84,1.21,15.7-6.8,1Zm9.64-1.07,7.88-.87.31,15.44-7,1.06Zm-.16-2-1.58-20.6,9.17-.42.41,20.13ZM400.29,317l9-.41-1.78,19.65-6.84.76Zm-2.49-22.56.42,20.59-9.28.43-1.61-21Zm-12.51,0,1.62,21.11-8.94.41-2.74-21.52Zm-12.1,0L376,316l-9.11.41-4-22Zm-12.38,0,4,22.12-9,.41-5-22.53Zm-12.07,0,5,22.62-8.83.4-6.07-23Zm-11.9,0,6.09,23.11-8.78.4-6.86-23.51Zm-11.59,0L332.14,318l-8.86.4-8.29-24Zm-12.3,0,8.32,24.1-8.88.41-9.21-24.51Zm-11.81,0,9.25,24.6-9.28.42-10.67-25Zm-12.74,0,10.72,25.11-8.13.37-11.16-25.48Zm-14,0h3.41L289,320l-7,.32-10-22.18A2.61,2.61,0,0,1,274.39,294.41Zm28.76,72.84-7.47-16.61,6.42-.71,8,18.2-4.17.63A2.6,2.6,0,0,1,303.15,367.25Zm103-15.66A2.6,2.6,0,0,1,404,354l-2.9.43L400.74,339l6.61-.73Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.12,269.7l8.8,5.14,3.67-6.43-8.8-5.14a3.13,3.13,0,0,0-4.31,1.16l-.52.91A3.21,3.21,0,0,0,249.12,269.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.87,
    y: 345.45,
    width: 3.99,
    height: 108.64,
    transform: "translate(-51.91 747.63) rotate(-90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.46 366.26 332.06 370.21 312.66 373.25 312.05 369.31 331.46 366.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.92,395.61c-.77,1,.42,2.51,2.62,2.16v4c-7.4.25-8.87-5-5.56-8.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,375.13a6,6,0,0,1,3.66-1.88l-.61-3.94a10.64,10.64,0,0,0-6,3.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.87,
    y: 345.45,
    width: 3.99,
    height: 108.64,
    transform: "translate(-51.91 747.63) rotate(-90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.46 366.26 332.06 370.21 312.66 373.25 312.05 369.31 331.46 366.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.92,395.61c-.77,1,.42,2.51,2.62,2.16v4c-7.4.25-8.87-5-5.56-8.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,375.13a6,6,0,0,1,3.66-1.88l-.61-3.94a10.64,10.64,0,0,0-6,3.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.06 372.47 309 375.13 290.93 395.62 287.98 392.95 306.06 372.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.06 372.47 309 375.13 290.93 395.62 287.98 392.95 306.06 372.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.54,397.77c-2.2.35-3.39-1.16-2.61-2.16h0L309,375.13h0a6,6,0,0,1,3.66-1.88l19.4-3-.6-3.95-19.41,3.05a10.64,10.64,0,0,0-6,3.16L288,393h0c-3.31,3.79-1.84,9.07,5.56,8.82H402.18v-4Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "228.35 409.24 223.55 405.81 226.26 396.78 228.43 389.56 235.2 391.22 232.03 399.57 228.35 409.24",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.45,405.11c.33-.54,6.87,3.82,6.87,3.82s1.73,6.67,5.24,10-.17,4.43-4.71,1.8l-11.23-6.49C215.4,412.35,219,410.77,222.45,405.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.59,412.92c-1,.16-2.69-2.2-3-2.68a.16.16,0,0,1,0-.07h0v-.07h0a.14.14,0,0,1,0-.06h0l.05-.06c.07-.06,1.55-1.31,2.7-1.16a1.22,1.22,0,0,1,.86.53c.23.33.27.61.12.83s-.92.43-1.64.4a3.22,3.22,0,0,1,1.42,1.05.84.84,0,0,1,.1.67.81.81,0,0,1-.45.59Zm-.07-.41s.17,0,.25-.34a.45.45,0,0,0-.05-.35,5.2,5.2,0,0,0-2.46-1.33C231,411.49,232.05,412.59,232.52,412.51Zm-2.28-2.5c1.23.2,2.51.23,2.7-.07.06-.09,0-.27-.11-.36a.78.78,0,0,0-.58-.36,1.85,1.85,0,0,0-.95.18A6.06,6.06,0,0,0,230.24,410Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.05,282.44c6.78,15.21,13.74,30.67,19.15,46.59,4.65,12.92,3.5,20.76-.7,33.42a228.34,228.34,0,0,1-15,33.16,5.25,5.25,0,0,1-9.74-3.64c2.06-9.36,4.63-18.47,6.69-27.41,1.38-6.71,3.48-14.09,2.71-20.79a56.11,56.11,0,0,0-2.66-8c-6.21-15.16-13.48-29.74-19.71-45.06-4.72-12.84,13.21-20.57,19.29-8.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.79,406.15c.15,2.16.22,4.57.83,5.4.73,1.5,11.38,7.63,11.75,8.33a2.49,2.49,0,0,1,.48,2c-1.08.37-2.63-.19-4.37-1.16l-9.56-5.51L219.64,409Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.7 392 237.2 395.49 234.88 399.56 224.83 396.65 225.7 392",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.7 392 237.2 395.49 234.88 399.56 224.83 396.65 225.7 392",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.85,413.59c0-.64,7.86-.14,7.86-.14s4.83,4.91,9.52,6,2.07,3.92-3.17,3.92h-13C211.37,423.39,213.7,420.21,213.85,413.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.59,414.47a.15.15,0,0,1-.06-.05h0l0-.06h0l0-.06h0a.24.24,0,0,1,0-.08c0-.09.69-1.91,1.75-2.35a1.19,1.19,0,0,1,1,0c.36.17.53.39.52.66s-.58.82-1.22,1.16a3.25,3.25,0,0,1,1.76.2.82.82,0,0,1,.42.53.76.76,0,0,1-.19.83,1.08,1.08,0,0,1-.7.19A10,10,0,0,1,222.59,414.47Zm.72-.13c1.16.48,2.59.92,3,.61,0,0,.13-.1.06-.41a.45.45,0,0,0-.23-.28,2,2,0,0,0-.92-.17A9.27,9.27,0,0,0,223.31,414.34Zm1.09-2.1a3.45,3.45,0,0,0-1.35,1.69c1.16-.44,2.28-1.05,2.31-1.41,0-.11-.18-.21-.29-.26a.8.8,0,0,0-.36-.09A.87.87,0,0,0,224.4,412.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.17 413.44 215.38 413.44 214.43 405.37 213.57 397.97 220.45 396.85 220.84 405.63 221.17 413.44",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221 407.87 214.59 407.58 213.73 400.1 220.61 398.94 221 407.87",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.78,322.88l-10.33-23.31s-1.06-3.9-.33-6.74a6,6,0,0,1,1.95-.82l7.16-2L222,295Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.31,292s8.65,46.09,8.75,51.18-7.19,59.57-7.19,59.57l-7.88.91c-5.07-24.2-1.59-43.07-4.08-59.83-3.81-25.74-18.09-49.21-5.63-74.73l.05,0a1.12,1.12,0,0,0,0-.13c3.73-8.28,28.15-2.18,28.15-2.18,1.75,6.87,2.87,20.79,2.87,20.79Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.31,292s8.65,46.09,8.75,51.18-7.19,59.57-7.19,59.57l-7.88.91c-5.07-24.2-1.59-43.07-4.08-59.83-3.81-25.74-18.09-49.21-5.63-74.73l.05,0a1.12,1.12,0,0,0,0-.13c3.73-8.28,28.15-2.18,28.15-2.18,1.75,6.87,2.87,20.79,2.87,20.79Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.3 264.85 203.3 268.99 231.56 266.82 231.56 261.92 203.3 264.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.3 264.85 203.3 268.99 231.56 266.82 231.56 261.92 203.3 264.85",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.41,
    y: 263.14,
    width: 1.4,
    height: 7.15,
    transform: "translate(-13.31 11.15) rotate(-2.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.89,
    y: 263.2,
    width: 6.21,
    height: 4.71,
    transform: "translate(-22.8 20.86) rotate(-5.12)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.68,
    y: 261.24,
    width: 1.4,
    height: 7.15,
    transform: "translate(-13.19 12.03) rotate(-2.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.41,
    y: 263.14,
    width: 1.4,
    height: 7.15,
    transform: "translate(-13.31 11.15) rotate(-2.92)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.68,
    y: 261.24,
    width: 1.4,
    height: 7.15,
    transform: "translate(-13.19 12.03) rotate(-2.92)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.38 400.05 223.51 398.27 222.49 403.12 212.48 404.47 211.38 400.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.38 400.05 223.51 398.27 222.49 403.12 212.48 404.47 211.38 400.05",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,205.55c-9.46,1-23.06,5.85-25.3,11.28s2.63,7.31,2.63,7.31-8.7,5.19-5.85,12.49,11.11.75,11.11.75S188.39,245,202,243.27s10.84-33.55,10.84-33.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.25,210.5c-2,2.69-4.06,2.38-8.9,1.28s-6.38-3.62-5.91-6.6,3.12-4.94,3.26-2.74C207.48,206.29,219.53,204.73,215.25,210.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.21,225.48l5.61-3.8,1.13,7.85s-4.39,1.39-7.81-1.37Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.48 222.2 291.23 228.19 285.95 229.53 284.82 221.68 291.48 222.2",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.83,222.1c4.36,2.75,8.61,5.62,12.86,8.37,3.94,2.42,8.06,5.36,12.32,6.87l-.27,0c-.36,0,0,0,.31-.06,5.52-1.73,11.46-5.65,16.66-8.35,2.1-1.13,4.21-2.29,6.38-3.36a2,2,0,0,1,2.08,3.37l-5.69,4.32C270,237,264.32,241.84,258,244.11a7.64,7.64,0,0,1-3.48.31,32.71,32.71,0,0,1-8.12-3.31c-6.91-3.7-13.43-8-19.89-12.3a4,4,0,0,1,4.36-6.71Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.63,229.38c1.82,4.79,3.15,6.54,2.85,10.77-.23,5.52-2,16.13-3.48,25.07-3.79,0-21.14,2.51-30.92,1.24.59-7.83.44-20.15-2.9-37.84a6.52,6.52,0,0,1,5.89-8.43c1.18-.11,2.42-.2,3.69-.26a100.17,100.17,0,0,1,13.42,0c1.43.13,3,.3,4.42.49C231.82,221.09,231.48,223.51,233.63,229.38Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.71,204.83c1.16,4.29,2.59,12.23-.21,15.11,0,0,3.7,3,11.56,5.84,2.34-.6,1.85-5.84,1.85-5.84-4.91-1.15-5-4.72-4.46-8.07Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.39,207.44l7.07,4.42a10,10,0,0,0-.07,4.11c-1.86-.26-5.82-4.14-6.67-6.09A7.57,7.57,0,0,1,211.39,207.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.85,224.4c2.16,7.36,3.7,14.68,6.14,21.8a28.48,28.48,0,0,0,2.73,6,4.67,4.67,0,0,0,1.66,1.58c7.6,4,16.16,6.46,24.13,10a2,2,0,0,1-1.2,3.78q-7.49-1.59-15-3.54a62.53,62.53,0,0,1-11.5-4,11.79,11.79,0,0,1-4.05-3.42c-3.5-4.9-4.86-9.84-6.58-15.22-1.52-5-2.77-10-4.06-14.8a4,4,0,0,1,7.7-2.16Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.5,192.31a4.32,4.32,0,0,1,3.84-2.6h4.22l-3.2,8.36,2.28,10.48s-7-2.29-7.52-9.41C203,197,202.46,194.91,203.5,192.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.49,187.79c7.2-.4,9.73,3.33,10.67,10.73,1.16,9.24-.53,15.94-9.65,14.46C205.13,211,204.52,188.44,216.49,187.79Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.48,198.37a15,15,0,0,0,2.26,2.87,2,2,0,0,1-1.86.92Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,198c.05.59-.23,1.1-.62,1.13s-.76-.42-.8-1,.23-1.09.63-1.12S218,197.43,218,198Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.08,197.05l1.24-.61S217.77,197.58,217.08,197.05Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.37,197.32c0,.6-.23,1.1-.63,1.13s-.75-.42-.79-1,.23-1.1.63-1.13S225.33,196.73,225.37,197.32Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.41,196.35l1.25-.6S225.1,196.88,224.41,196.35Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.62,194.67a.36.36,0,0,1-.29-.57,4.12,4.12,0,0,1,3.39-1.41.35.35,0,0,1,.33.39.34.34,0,0,1-.39.33,3.44,3.44,0,0,0-2.74,1.11A.36.36,0,0,1,214.62,194.67Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.81,193.26a.41.41,0,0,1-.18,0,3,3,0,0,0-2.58-.42.36.36,0,0,1-.47-.19.35.35,0,0,1,.19-.47,3.7,3.7,0,0,1,3.23.45.37.37,0,0,1,.13.5A.38.38,0,0,1,225.81,193.26Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,205.05a18.81,18.81,0,0,0-.71,2.55,3.54,3.54,0,0,1-.46,0c-2.11-.09-3.06-.83-3.47-1.63a2.64,2.64,0,0,1-.27-1.26,2.43,2.43,0,0,1,.09-.73,10,10,0,0,0,4.1,1C221.71,205.05,222,205.05,222,205.05Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.27,205l-.23.75c-2-.1-3.37-.43-4-1.07a2.43,2.43,0,0,1,.09-.73A10,10,0,0,0,221.27,205Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.82,207.58c-2.11-.09-3.06-.83-3.47-1.63a6.92,6.92,0,0,1,2.32.57A2.66,2.66,0,0,1,220.82,207.58Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.28,200.36s3-6.1,2.28-10.64c0,0,14-6.62,15.46,7.83,0,0,.69-12.94-11.71-12.55s-11.36,18.51-4.67,23.56C210.64,208.56,207.4,204.18,209.28,200.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.54,201.82a3.16,3.16,0,0,0-3.56-2.7c-2.22.36-3,5,2.58,5.8C210.36,205,210.77,204.23,210.54,201.82Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.34,189.71a5.45,5.45,0,0,1,2.07-6c3.24-2.19,8.85-1.06,12.58,0,5.5,1.56,6.93,9.3,5,12.37-2.23-3.33-1.94-5.72-4.07-7.61a13.64,13.64,0,0,0-10.17-.09l-1.18,1.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.5 268.35 249.76 273.03 244.7 270.99 248.44 263.99 253.5 268.35",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.66,263.74l6.78.25-3.74,7s-4.35-1.47-5.48-5.72Z",
    style: {
      fill: "#ffc3bd"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodsI);
export default __webpack_public_path__ + "static/media/foodsI.14430da0c2848c5b7ff16874802cc9b9.svg";
export { ForwardRef as ReactComponent };